{
  "account.label": "Konto",
  "admin.addAnswer": "Antwort",
  "admin.addQuestion": "Frage hinzufügen",
  "admin.answerPlaceholder": "Antwortoption",
  "admin.collapseList": "Liste einklappen",
  "admin.confirmDeleteQ": "Fragebogen löschen?",
  "admin.defaultPowerLabel": "Standard-Power (optional)",
  "admin.expandList": "Fragebögen anzeigen",
  "admin.instructionsLabel": "Instruktionen (optional)",
  "admin.instructionsPlaceholder": "Hinweis für die ausfüllende Person",
  "admin.nameLabel": "Name",
  "admin.namePlaceholder": "z.B. Empathie-Check",
  "admin.newQuestionnaire": "+ Neuer Fragebogen",
  "admin.noQuestionnaires": "Noch keine Fragebögen.",
  "admin.nonePlaceholder": "Keine",
  "admin.qTitle": "Fragebögen",
  "admin.questionPlaceholder": "Frage / Aussage",
  "admin.removeAnswer": "Antwort entfernen",
  "admin.removeQuestion": "Frage entfernen",
  "admin.selectOrCreate": "Wähle links einen Fragebogen oder lege einen neuen an.",
  "admin.selectPower": "Power wählen",
  "admin.statusActive": "Aktiv",
  "admin.statusInactive": "Inaktiv",
  "admin.statusLabel": "Status",
  "admin.validationHint": "Name, je Frage Text + Power und je Antwort Text erforderlich.",
  "admin.weightLabel": "Gewicht",
  "admin.yesDelete": "Ja, löschen",
  "adminSettings.appearance.accentHint": "Accent · Buttons, Highlights",
  "adminSettings.appearance.accentLabel": "Signalfarbe",
  "adminSettings.appearance.bgHint": "Basis · Page",
  "adminSettings.appearance.bgLabel": "Hintergrund",
  "adminSettings.appearance.openPicker": "Color-Picker öffnen",
  "adminSettings.appearance.presetsFor": "Presets für {label}",
  "adminSettings.appearance.reset": "↺ Auf Default zurücksetzen",
  "adminSettings.appearance.sub": "Hintergrund, Boxen und Signalfarbe steuern die App. Text wird automatisch schwarz oder weiß gesetzt.",
  "adminSettings.appearance.surfaceHint": "Karten · Surfaces",
  "adminSettings.appearance.surfaceLabel": "Boxen",
  "adminSettings.appearance.title": "Palette",
  "adminSettings.branding.appName": "App-Name",
  "adminSettings.branding.appNameHint": "Wird oben links angezeigt. Leer fällt auf „smycles“ zurück.",
  "adminSettings.branding.appNamePlaceholder": "smycles",
  "adminSettings.branding.paletteNote": "Die Palette unten wird live übernommen; ungespeicherte Änderungen erscheinen im Speichern-Balken und werden beim Speichern plattformweit übernommen.",
  "adminSettings.branding.sub": "App-Name und Farbpalette. Gilt plattformweit.",
  "adminSettings.branding.title": "Branding",
  "adminSettings.hrPrompt.defaultActive": "Aktuell ist der Genesis-Standard aktiv.",
  "adminSettings.hrPrompt.hint": "Der Platzhalter {{responseLanguage}} wird automatisch ersetzt. Eine Match-Ergänzung steht im kombinierten Prompt zuletzt und hat bei Konflikten Vorrang.",
  "adminSettings.hrPrompt.label": "Globaler HR-Basis-Prompt",
  "adminSettings.hrPrompt.reset": "Genesis-Standard verwenden",
  "adminSettings.hrPrompt.sub": "Zentrale Recruiter-Anweisung für alle Prüf-Matches. Match-spezifische Ergänzungen werden danach angefügt.",
  "adminSettings.hrPrompt.title": "HR-Prompt",
  "agent.back": "Zurück zu Chats",
  "agent.chatsEmpty": "Noch keine Chats. Starte oben einen neuen.",
  "agent.chatsError": "Chats konnten nicht geladen werden.",
  "agent.chatsLoading": "Lädt…",
  "agent.close": "Schließen",
  "agent.closeImage": "Bild schließen",
  "agent.contextBreak": "Neues Kontextfenster",
  "agent.deleteChat": "Chat löschen",
  "agent.deleteMessage": "Diese Unterhaltung wird dauerhaft gelöscht.",
  "agent.deleteTitle": "Chat löschen?",
  "agent.empty": "Frag den Assistenten zu Personen, Profilen und mehr.",
  "agent.error": "Assistent nicht erreichbar. Bitte erneut versuchen.",
  "agent.expandImage": "In voller Größe anzeigen",
  "agent.input": "Assistenten-Eingabe",
  "agent.jumpToLatest": "Zum Neuesten springen",
  "agent.newChat": "Neuer Chat",
  "agent.personInfo.heading": "Profil",
  "agent.personInfo.label": "Vollständiges Profil laden",
  "agent.placeholder": "Frag den Assistenten…",
  "agent.send": "Senden",
  "agent.starters.growth.0": "Welche Fähigkeiten sollte ich als Nächstes entwickeln?",
  "agent.starters.growth.1": "Welche Rollen passen zu meiner Erfahrung?",
  "agent.starters.growth.2": "Wohin kann ich mich von hier entwickeln?",
  "agent.starters.growth.3": "Welche Erfahrung fehlt mir für Senior-Rollen?",
  "agent.starters.growth.4": "Schlage mir einen Lernpfad vor",
  "agent.starters.growth.5": "Welche Fähigkeiten sind am gefragtesten?",
  "agent.starters.growth.6": "Auf welche Stärken kann ich aufbauen?",
  "agent.starters.growth.7": "Vergleiche mein Profil mit einer Zielrolle",
  "agent.starters.growth.8": "Welche Lücken halten mich zurück?",
  "agent.starters.growth.9": "Empfiehl nächste Schritte für meine Karriere",
  "agent.starters.match.0": "Zeig meine letzten Matches",
  "agent.starters.match.1": "Welche Suchoptionen gibt es?",
  "agent.starters.match.2": "Zeig Details meines neuesten Matches",
  "agent.starters.match.3": "Zähle meine Matches",
  "agent.starters.match.4": "Finde ein Match nach Namen",
  "agent.starters.match.5": "Welches Match habe ich zuletzt aktualisiert?",
  "agent.starters.match.6": "Suche nach einer Person",
  "agent.starters.match.7": "Zeig die Kandidaten meines neuesten Matches",
  "agent.starters.match.8": "Wonach kann ich suchen?",
  "agent.starters.match.9": "Liste Matches aus diesem Monat auf",
  "agent.starters.save.0": "Zeig mein Profil",
  "agent.starters.save.1": "Welche Fähigkeiten stehen in meinem Profil?",
  "agent.starters.save.2": "Welche Sprachen habe ich?",
  "agent.starters.save.3": "Welche Erfahrung steht in meinem Profil?",
  "agent.starters.save.4": "Fasse mein Profil zusammen",
  "agent.starters.save.5": "Was ist meine aktuelle Position?",
  "agent.starters.save.6": "Liste meine Ausbildung auf",
  "agent.starters.save.7": "Bei welchen Unternehmen habe ich gearbeitet?",
  "agent.starters.save.8": "Was ist mein stärkster Kompetenzbereich?",
  "agent.starters.save.9": "Zeig meine Kontaktdaten",
  "agent.starters.share.0": "Liste meine geteilten Inhalte auf",
  "agent.starters.share.1": "Zeig meinen neuesten Share",
  "agent.starters.share.2": "Fasse meine geteilten Projekte zusammen",
  "agent.starters.share.3": "Zeig meine öffentlichen Shares",
  "agent.starters.share.4": "Zeig meine privaten Shares",
  "agent.starters.share.5": "Liste auf, was ich diesen Monat geteilt habe",
  "agent.starters.share.6": "Zeig Details meines neuesten Shares",
  "agent.starters.share.7": "Finde einen geteilten Inhalt nach Namen",
  "agent.starters.share.8": "Liste mit dem Team geteilte Inhalte auf",
  "agent.starters.share.9": "Liste meine geteilten Projekte auf",
  "agent.starters.tobis.0": "Welche Filme haben wir im Genre Drama?",
  "agent.starters.tobis.1": "Finde Vergleichsfilme für die Tonalität dieses Pitches",
  "agent.starters.tobis.2": "Suche nach einem Schauspieler oder einer Regisseurin",
  "agent.starters.tobis.3": "An welchen Filmen hat diese Person mitgewirkt?",
  "agent.starters.tobis.4": "Was ist der beste Film eines bestimmten Schauspielers?",
  "agent.starters.tobis.5": "Welche preisgekrönten Filme haben wir im Bestand?",
  "agent.starters.tobis.6": "Welcher Regisseur hat die meiste Zugkraft in Deutschland?",
  "agent.starters.tobis.7": "Wie hat sich das Genre Horror im Kino zuletzt entwickelt?",
  "agent.starters.tobis.8": "Welche Regisseurin ist gerade besonders gefragt?",
  "agent.starters.tobis.9": "Was wäre ein fairer Kaufpreis für einen Film wie diesen?",
  "agent.title": "Assistent",
  "agent.tour.back": "Zurück",
  "agent.tour.buttonHint.back": "Zurück: zeigt den vorherigen Schritt noch einmal.",
  "agent.tour.buttonHint.next": "Weiter: springt sofort zum nächsten Schritt.",
  "agent.tour.buttonHint.pause": "Pause: hält die Tour an, Fragen sind willkommen.",
  "agent.tour.buttonHint.skipSection": "Bereich überspringen: wechselt zum nächsten Bereich.",
  "agent.tour.buttonHint.stop": "Tour beenden oder Esc: beendet die Tour.",
  "agent.tour.chipHome": "Hauptseite",
  "agent.tour.continue": "Fortsetzen",
  "agent.tour.escHint": "_Nutze die Buttons unter dem Chat: zurück, Pause, weiter und Bereich überspringen. Drücke jederzeit **Esc** oder den Stopp-Button, um die Tour zu beenden._",
  "agent.tour.finished": "Das war das Ende der Tour. Frag mich gern alles zu dem, was du gesehen hast!",
  "agent.tour.mobileNotice": "Touren heben Elemente auf der Seite neben dem Chat hervor und brauchen dafür einen größeren Bildschirm. Probiere es bitte in einem Desktop-Fenster.",
  "agent.tour.modeActive": "Tour-Modus",
  "agent.tour.modeFinished": "Tour beendet. Klicke einen Abschnitt oder gehe zurück zum Ansehen; Stopp beendet.",
  "agent.tour.modePaused": "Tour pausiert. Du kannst jetzt Fragen stellen.",
  "agent.tour.next": "Weiter",
  "agent.tour.next.heading": "Jetzt probiere es selbst aus:",
  "agent.tour.next.linkedin": "Importiere deine Daten über LinkedIn",
  "agent.tour.next.match": "Erstelle ein Match",
  "agent.tour.next.profile": "Fülle dein Profil aus",
  "agent.tour.next.project": "Erstelle ein Projekt",
  "agent.tour.next.quiz": "Mache ein Power-Quiz",
  "agent.tour.noTour": "Für diese Seite gibt es noch keine Tour.",
  "agent.tour.pause": "Pause",
  "agent.tour.pillar.grow": "GROW ist dein Power-Spielplatz: Schätze deine 30 Powers ein, schau Lerninhalte und spiele dich zu einem schärferen Profil.",
  "agent.tour.pillar.home": "Das Smycles-Logo bringt dich immer zur Hauptseite: deinem Dashboard mit den aktuellen Zahlen aus allen Bereichen.",
  "agent.tour.pillar.match": "MATCH baut Teams: Du definierst die Anforderungen, der Solver findet die passenden Leute.",
  "agent.tour.pillar.save": "SAVE ist dein persönlicher Datentresor: dein Profil, deine Lebenslauf-Einträge, Dokumente, Kontakte und deine Pinnwand.",
  "agent.tour.pillar.share": "SHARE ist der Community-Feed: Veröffentliche Projekte und Beiträge, gewinne Interessierte und sammle Feedback.",
  "agent.tour.questionContinue": "Alles zeigen",
  "agent.tour.questionFinish": "Tour beenden",
  "agent.tour.sectionQuestion": "Soll ich dir zuerst einen Bereich zeigen? Wähle ihn unter dem Chat aus, sonst stelle ich die Hauptseite und jeden Bereich der Reihe nach vor.",
  "agent.tour.sectionQuestionNext": "Dieser Bereich ist fertig. Soll ich dir noch einen zeigen? Wähle ihn unter dem Chat aus, sonst endet die Tour hier.",
  "agent.tour.sectionsIntro": "Ich zeige dir kurz die Bereiche, bevor wir ins Detail gehen.",
  "agent.tour.skipSection": "Bereich überspringen",
  "agent.tour.starterChip": "Zeig mir diese Seite",
  "agent.tour.starterChipAll": "Zeig mir die App",
  "agent.tour.stop": "Tour beenden",
  "agent.tour.topbar.assistant": "Der KI-Assistent: Dieser Button öffnet und schließt den Chat, den du gerade liest.",
  "agent.tour.topbar.chat": "Nachrichten: Direkte Chats mit deinen Kontakten.",
  "agent.tour.topbar.notifications": "Benachrichtigungen: Einladungen, Updates und Aktivität rund um dich landen hier.",
  "agent.tour.topbar.search": "Die globale Suche: Finde Personen, Projekte und Beiträge von überall in der App.",
  "agent.tour.topbar.user": "Dein Konto: Klick auf deinen Namen für Profilmenü, Einstellungen und Logout.",
  "agent.tour.welcome": "Willkommen im Smycles System. Diese Tour stellt die wichtigen Funktionalitäten vor. Die Knöpfe unter dem Chat steuern die Tour. Du kannst auch jeden Chat-Schnipsel anklicken, um zu seiner Stelle zurückzuspringen.",
  "agent.untitled": "Unbenannter Chat",
  "auth.redirecting": "Weiterleitung zum Login…",
  "auth.sessionExpired.body": "Sie wurden abgemeldet, weil die Sitzung ihr Zeitlimit erreicht hat. \u00c4nderungen werden nicht mehr gespeichert. Melden Sie sich erneut an, um dort weiterzumachen, wo Sie aufgeh\u00f6rt haben.",
  "auth.sessionExpired.bodyTokensLost": "Sie wurden abgemeldet. Änderungen werden nicht mehr gespeichert. Melden Sie sich erneut an, um dort weiterzumachen, wo Sie aufgehört haben.",
  "auth.sessionExpired.signIn": "Erneut anmelden",
  "auth.sessionExpired.title": "Sitzung beendet",
  "chat.closeChat": "Chat schließen",
  "chat.deleteChat": "Chat löschen",
  "chat.deleteChatConfirm": "Diese Unterhaltung wirklich löschen?",
  "chat.liveUpdatesUnavailable": "Live-Updates nicht verfügbar",
  "chat.messageInput": "Nachrichteneingabe",
  "chat.messages": "Nachrichten",
  "chat.minimize": "Minimieren",
  "chat.more": "Mehr",
  "chat.newConversation": "Neue Unterhaltung",
  "chat.noConversationsYet": "Noch keine Unterhaltungen",
  "chat.online": "Online",
  "chat.openMessages": "Nachrichten",
  "chat.searchChats": "Chats durchsuchen…",
  "chat.searchEnd": "{count} Ergebnisse",
  "chat.searchHint": "Mindestens {n} Zeichen eingeben",
  "chat.searchPeople": "Personen suchen…",
  "chat.seen": "Gesehen",
  "chat.sendMessage": "Nachricht senden",
  "chat.typing": "tippt…",
  "chat.unreadMessages": "{count} ungelesen",
  "chat.writeMessage": "Nachricht schreiben…",
  "chat.you": "Du",
  "cockpit.dismiss": "Verwerfen",
  "cockpit.markRead": "Als gelesen markieren",
  "cockpit.noNotifications": "Keine Benachrichtigungen",
  "cockpit.notifications": "Benachrichtigungen",
  "cockpit.unread": "ungelesen",
  "common.add": "Hinzufügen",
  "common.back": "Zurück",
  "common.cancel": "Abbrechen",
  "common.close": "Schließen",
  "common.comingSoon": "Demnächst verfügbar",
  "common.confirm": "Bestätigen",
  "common.create": "Erstellen",
  "common.delete": "Löschen",
  "common.deleteFailed": "Löschen fehlgeschlagen.",
  "common.discard": "Verwerfen",
  "common.duplicateName": "Es existiert bereits ein Eintrag mit diesem Namen. Bitte einen anderen Namen wählen.",
  "common.edit": "Bearbeiten",
  "common.errorWithMessage": "Fehler: {message}",
  "common.fileDrop.overlay": "Zum Hochladen ablegen …",
  "common.fileDrop.zone": "Datei hier ablegen oder klicken",
  "common.loadMore": "Mehr laden",
  "common.loading": "Laden…",
  "common.loadingMore": "Lädt…",
  "common.next": "Weiter",
  "common.noBackend": "Kein Backend-Endpunkt",
  "common.noResults": "Keine Ergebnisse gefunden",
  "common.notFound": "Nicht gefunden",
  "common.notFoundBody": "Die gesuchte Seite existiert nicht.",
  "common.remove": "Entfernen",
  "common.reset": "Zurücksetzen",
  "common.save": "Speichern",
  "common.saveFailed": "Speichern fehlgeschlagen.",
  "common.saving": "Speichern…",
  "common.serverError": "Etwas ist schiefgelaufen. Bitte versuch es erneut.",
  "common.serverErrorWithCode": "Etwas ist schiefgelaufen. Bitte versuch es erneut. (Fehlercode {code})",
  "common.share.ariaActive": "Teilen aktiv",
  "common.share.ariaAllOff": "Alle privat",
  "common.share.ariaAllOn": "Alle teilen",
  "common.share.ariaInactive": "Nicht teilen",
  "common.share.off": "Privat",
  "common.share.on": "Teilen",
  "common.tryAgain": "Erneut versuchen",
  "common.unsavedChanges": "Nicht gespeicherte Änderungen",
  "community.tour.contacts.desc": "{count} Kontakte in der aktuellen Ansicht. Klicke eine Karte, um das Profil zu öffnen, nutze „+ Hinzufügen“, um sie in Communities einzuordnen, oder ziehe sie links auf eine Community.",
  "community.tour.contacts.title": "Deine Kontakte",
  "community.tour.controls.desc": "Suche Kontakte nach Namen, ändere die Sortierung oder filtere auf Kontakte, die noch in keiner Community sind.",
  "community.tour.controls.title": "Suchen & Sortieren",
  "community.tour.groups.desc": "{count} Communities, um deine Kontakte zu gruppieren. Klicke eine an, um ihre Mitglieder zu sehen, lege neue über „+ Community“ an und ziehe eine Kontaktkarte auf eine Community, um sie hinzuzufügen.",
  "community.tour.groups.title": "Deine Communities",
  "community.tour.label": "Save Community",
  "community.tour.summary": "Das ist deine Community-Seite: {contacts} Kontakte, organisiert in {groups} Communities.",
  "cv.color": "Farbe",
  "cv.createFailed": "CV-Anlage fehlgeschlagen.",
  "cv.createTitle": "Lebenslauf erstellen",
  "cv.download": "Download",
  "cv.downloadFailed": "Download fehlgeschlagen.",
  "cv.editTitle": "Lebenslauf bearbeiten",
  "cv.field.address": "Ort",
  "cv.field.birthDate": "Geburtstag",
  "cv.field.drivingLicence": "Führerschein",
  "cv.field.email": "E-Mail",
  "cv.field.nationality": "Nationalität",
  "cv.field.phone": "Telefon",
  "cv.field.web": "Web",
  "cv.generator": "CV-Generator",
  "cv.name": "Name",
  "cv.notSignedIn": "Nicht angemeldet?",
  "cv.personal.born": "geb. {date}",
  "cv.personal.licence": "Führerschein {value}",
  "cv.previewTitle": "CV-Vorschau",
  "cv.reallyDelete": "Wirklich löschen",
  "cv.saveCv": "CV Speichern",
  "cv.section.certifications": "Zertifikate",
  "cv.section.education": "Ausbildung",
  "cv.section.experience": "Berufserfahrung",
  "cv.section.expertise": "Fachwissen",
  "cv.section.languages": "Sprachen",
  "cv.section.summary": "Profil",
  "cv.sectionCertifications": "Zertifikate",
  "cv.sectionEducation": "Ausbildung",
  "cv.sectionExperience": "Berufserfahrung",
  "cv.sectionExpertise": "Fachwissen",
  "cv.sectionLanguages": "Sprachen",
  "cv.sectionProfile": "Profil",
  "cv.sections": "Sektionen",
  "cv.sidebarContact": "Kontakt",
  "cv.sliderHeadingSize": "Überschriftgröße",
  "cv.sliderIndentation": "Einrückung",
  "cv.sliderSectionMargin": "Sektionsrand",
  "cv.sliderSpacing": "Abstand",
  "cv.sliderTextSize": "Textgröße",
  "cv.template": "Template",
  "cv.template.comic.tagline": "DER BESTE LEBENSLAUF ALLER ZEITEN!!!",
  "cv.template.contact": "Kontakt",
  "cv.updateFailed": "CV-Update fehlgeschlagen.",
  "cv.variant": "Variante {n}",
  "design.addEntry": "Eintrag hinzufügen",
  "design.apply": "Übernehmen",
  "design.booleanYes": "Ja",
  "design.cardComments": "Kommentare",
  "design.cardRating": "Bewertung",
  "design.cardViews": "Aufrufe",
  "design.chipCommented": "Kommentiert",
  "design.chipCreated": "Erstellt",
  "design.chipInterested": "Interessent",
  "design.chipRated": "Bewertet",
  "design.chipWatched": "Beobachtet",
  "design.chooseLevel": "Stufe wählen.",
  "design.clearValue": "Wert löschen",
  "design.copied": "Kopiert",
  "design.copy": "Kopieren",
  "design.cropPhoto": "Foto zuschneiden",
  "design.filterPlaceholder": "Tippen zum Filtern …",
  "design.monthPlaceholder": "Monat",
  "design.numberStepperDecrease": "{noun} verringern",
  "design.numberStepperFallbackNoun": "Wert",
  "design.numberStepperIncrease": "{noun} erhöhen",
  "design.removeTask": "Aufgabe entfernen",
  "design.requiredField": "Pflichtfeld",
  "design.selectPlaceholder": "Auswählen …",
  "design.selfAssessmentDone": "Selbstbewertung abgeschlossen",
  "design.shareLink": "Link teilen",
  "design.shareTitle": "Teilen",
  "design.shareWithArrow": "↗ Teilen",
  "design.stillFillIn": "Bitte noch ausfüllen: {fields}",
  "design.yearPlaceholder": "Jahr",
  "design.zoom": "Zoom",
  "grow.assessment.allAnswered": "Alle Fragen beantwortet",
  "grow.assessment.askAria": "Den Assistenten zu dieser Aussage fragen",
  "grow.assessment.boxAriaLabel": "Zu Frage {index}",
  "grow.assessment.boxTitle": "Frage {index}",
  "grow.assessment.boxTitleAnswered": "Frage {index} · beantwortet",
  "grow.assessment.enterToContinue": "Enter für weiter",
  "grow.assessment.keyboardHint": "Tasten 1–{max} oder ←/→ zum Auswählen",
  "grow.assessment.progress": "Frage {index} / {total} · {answered} beantwortet",
  "grow.assessment.saveFailed": "Konnte nicht speichern.",
  "grow.assessment.skip": "Überspringen",
  "grow.assessment.zoneHint": "↑/↓ wechselt die Zeile (Fragen · Bewertung · Navigation)",
  "grow.assessmentSubtitle": "Bewerte, wie stark jede Aussage auf dich zutrifft.",
  "grow.elementAssessment.askIntro.0": "Ich bewerte gerade die Selbsteinschätzungs-Aussage: „{statement}“. Hilf mir zu verstehen, was sie bedeutet und wie ich sie für mich einschätzen soll.",
  "grow.elementAssessment.askIntro.1": "Hilf mir, diese Selbsteinschätzungs-Aussage zu verstehen: „{statement}“. Was bedeutet sie und wie soll ich sie bewerten?",
  "grow.elementAssessment.askIntro.2": "Ich bin unsicher, wie ich „{statement}“ bewerten soll. Kannst du mir helfen, sie zu deuten und einzuschätzen?",
  "grow.elementAssessment.askIntro.3": "Worauf zielt die Aussage „{statement}“ eigentlich ab, und wie beurteile ich sie für mich?",
  "grow.elementAssessment.askIntro.4": "Führe mich durch die Aussage „{statement}“, damit ich sie ehrlich bewerten kann.",
  "grow.elementAssessment.askIntro.5": "Hilf mir, über „{statement}“ nachzudenken – was bedeutet sie und wie schätze ich sie ein?",
  "grow.elementAssessment.askIntro.6": "Wie sollte ich über die Aussage „{statement}“ nachdenken, wenn ich mich selbst bewerte?",
  "grow.elementAssessment.askIntro.7": "Erläutere „{statement}“ und hilf mir zu entscheiden, wie sehr sie auf mich zutrifft.",
  "grow.elementAssessment.askIntro.8": "Ich bewerte „{statement}“. Was bedeutet sie, und was sollte ich vor der Bewertung bedenken?",
  "grow.elementAssessment.askIntro.9": "Erkläre „{statement}“ und hilf mir herauszufinden, wo ich dabei stehe.",
  "grow.elementAssessment.notSaved": "nicht gespeichert",
  "grow.elementAssessment.savedStatus": "gespeichert",
  "grow.elementAssessment.savingStatus": "speichert…",
  "grow.elementAssessment.statementLabel": "Aussage {index}",
  "grow.elementAssessment.toEvaluation": "Zur Auswertung",
  "grow.elementResult.answeredCount": "{answered}/{total} beantwortet",
  "grow.elementResult.askButton": "Ergebnis besprechen",
  "grow.elementResult.askIntro.0": "Ich habe bei {name} {score} erreicht. Hilf mir zu verstehen, was das bedeutet und wie ich mich verbessern kann.",
  "grow.elementResult.askIntro.1": "Deute mein {name}-Ergebnis ({score}) anhand des Referenzmaterials und schlag vor, wie ich es steigern kann.",
  "grow.elementResult.askIntro.2": "Was sagt ein {name}-Wert von {score} über mich aus, und was kann ich tun?",
  "grow.elementResult.askIntro.3": "Hilf mir, mein {name}-Ergebnis ({score}) einzuordnen und wie es weitergeht.",
  "grow.elementResult.askIntro.4": "Ich habe {score} bei {name}. Wie kann ich diese Power laut Referenzmaterial entwickeln?",
  "grow.elementResult.askIntro.5": "Schlüssele mein {name}-Ergebnis ({score}) auf und gib mir konkrete nächste Schritte.",
  "grow.elementResult.askIntro.6": "Wie sollte ich einen {name}-Wert von {score} lesen? Wie sähe Verbesserung aus?",
  "grow.elementResult.askIntro.7": "Gib mir auf dem Referenzmaterial basierende Tipps, um {name} zu verbessern – bei meinem Wert von {score}.",
  "grow.elementResult.askIntro.8": "Mein {name} liegt bei {score}. Wie kann ich es konkret stärken?",
  "grow.elementResult.askIntro.9": "Deute mein {name}-Ergebnis ({score}) und coache mich bei der Verbesserung.",
  "grow.elementResult.evaluation": "Auswertung",
  "grow.elementResult.fullyAnswered": "Vollständig beantwortet",
  "grow.elementResult.lastEvaluatedOn": "Zuletzt ausgewertet: {date}",
  "grow.elementResult.reassess": "Nochmal bewerten",
  "grow.elementResult.selfAssessmentCompleted": "Selbsteinschätzung abgeschlossen",
  "grow.elementResult.toPower": "Zur Power",
  "grow.elementResult.toPowerMap": "Zur Power Map",
  "grow.elementResult.unknownElement": "Unbekanntes Element",
  "grow.elementResult.yourScore": "Dein Score",
  "grow.landing.allAssessmentsDone": "Alle Selbsteinschätzungen abgeschlossen.",
  "grow.landing.circusStories": "Circus · Experten-Stories",
  "grow.landing.community": "Community",
  "grow.landing.focusAskButton": "Worauf soll ich mich konzentrieren?",
  "grow.landing.focusAskIntro.0": "Meine derzeit schwächsten Powers sind {powers}. Worauf sollte ich mich zuerst konzentrieren und warum?",
  "grow.landing.focusAskIntro.1": "Hilf mir zu entscheiden, wo ich mit dem Verbessern anfange – meine niedrigsten Powers sind {powers}.",
  "grow.landing.focusAskIntro.2": "Angesichts meiner schwächsten Bereiche ({powers}): Woran sollte ich zuerst arbeiten?",
  "grow.landing.focusAskIntro.3": "Ich möchte wachsen. Wie sollte ich laut Referenzmaterial {powers} priorisieren?",
  "grow.landing.focusAskIntro.4": "Was sollte ich zuerst angehen: {powers}? Hilf mir, einen Plan zu machen.",
  "grow.landing.focusAskIntro.5": "Coache mich beim Verbessern meiner Schwachstellen: {powers}. Wo fange ich an?",
  "grow.landing.focusAskIntro.6": "Meine Wachstumsfelder sind {powers}. Was ist ein guter erster Schritt für jedes?",
  "grow.landing.focusAskIntro.7": "Hilf mir, {powers} von Schwächen zu Stärken zu machen – wo anfangen?",
  "grow.landing.focusAskIntro.8": "Worauf sollte mein Fokus liegen, wenn meine niedrigsten Powers {powers} sind?",
  "grow.landing.focusAskIntro.9": "Schlag einen Fokus und eine erste Maßnahme für meine schwächsten Powers vor: {powers}.",
  "grow.landing.gamesExercises": "Spiele · Lernspielerische Übungen",
  "grow.landing.heroBody": "Quests, Spiele, Mikro-Übungen. Dein persönlicher Power-Spielplatz. Bewege Powers, ohne sie zu vermessen.",
  "grow.landing.heroSubtitleLine1": "Spielerisch entdecken,",
  "grow.landing.heroSubtitleLine2": "wie du wirklich tickst.",
  "grow.landing.improveAria": "Hilfe beim Verbessern von {name}",
  "grow.landing.inComparison": "Im Vergleich",
  "grow.landing.liveHacks": "Live-Hacks",
  "grow.landing.loading": "lädt…",
  "grow.landing.noCommunityProgress": "Noch keine Community mit Grow-Fortschritt.",
  "grow.landing.noData": "Keine Daten.",
  "grow.landing.noRatedPowers": "Noch keine bewerteten Powers.",
  "grow.landing.openCount": "{count} offen",
  "grow.landing.openProfile": "{name} öffnen",
  "grow.landing.powerMap": "Power Map ↗",
  "grow.landing.profileFallback": "Profil",
  "grow.landing.profileProgress": "Profilfortschritt",
  "grow.landing.progressHint": "Beantworte alle Fragen zu den Powers, um deinen Profilfortschritt zu erhöhen.",
  "grow.landing.roomToGrow": "Ausbaufähig",
  "grow.landing.upNext": "Als Nächstes",
  "grow.landing.viewAll": "Alle ansehen ↗",
  "grow.landing.yourStrengths": "Deine Stärken",
  "grow.mediaKind.podcast": "Podcast",
  "grow.mediaKind.script": "Script",
  "grow.mediaKind.video": "Video",
  "grow.noQuestions": "Für dieses Element sind keine Fragen verfügbar.",
  "grow.play.allGames": "Alle Spiele",
  "grow.play.featured": "Featured",
  "grow.play.filter.all": "Alle",
  "grow.play.filter.solo": "Solo",
  "grow.play.filter.team": "Team",
  "grow.play.game.back2Future.caption": "Du wirfst dein heutiges Ich in eine 10-Jahres-Zukunft. Was siehst du dort?",
  "grow.play.game.back2Future.duration": "15 Min · solo",
  "grow.play.game.back2Future.kind": "Szenario",
  "grow.play.game.creativeJam.caption": "Improvisations-Setting für 3–6 Personen. Schnell, laut, ehrlich.",
  "grow.play.game.creativeJam.duration": "30 Min · Team",
  "grow.play.game.creativeJam.kind": "Team-Improv",
  "grow.play.game.missionBuilder.caption": "Erstelle deine persönliche Heldenreise: Berufung, Hürden, Verbündete.",
  "grow.play.game.missionBuilder.duration": "45 Min · solo",
  "grow.play.game.missionBuilder.kind": "Story-Mode",
  "grow.play.game.perspectiveSwap.caption": "Schlüpfe für 10 Minuten in eine andere Rolle und sieh dich selbst von außen.",
  "grow.play.game.perspectiveSwap.duration": "10 Min · solo / duo",
  "grow.play.game.perspectiveSwap.kind": "Rolle",
  "grow.play.game.powerQuiz.caption": "90 Aussagen → dein Power-Profil. 30 Kategorien, 5-Punkt-Skala.",
  "grow.play.game.powerQuiz.duration": "20-30 Min · solo",
  "grow.play.game.powerQuiz.kind": "Quiz",
  "grow.play.game.teamPuzzle.caption": "Drei Personen, drei Powers, ein Problem. Wer passt zusammen, und warum?",
  "grow.play.game.teamPuzzle.duration": "20 Min · Team",
  "grow.play.game.teamPuzzle.kind": "Co-op",
  "grow.play.game.treasureHunt.caption": "Schatzkarte mit deinen Stärken: finde 5 unerkannte Powers in deinem Alltag.",
  "grow.play.game.treasureHunt.duration": "20 Min · solo",
  "grow.play.game.treasureHunt.kind": "Adventure",
  "grow.play.game.valueCards.caption": "60 Wertkarten: priorisiere, eliminiere, kommittiere. Mit Reflexionsfragen.",
  "grow.play.game.valueCards.duration": "25 Min · solo",
  "grow.play.game.valueCards.kind": "Karten-Spiel",
  "grow.play.headerCount": "{count} Spiele · Solo & Team",
  "grow.play.intro": "Spielerische Übungen, Quizzes und Szenarien, die deine Powers in Bewegung bringen. Solo, mit Partner:in oder im Team.",
  "grow.play.personPlural": "Personen",
  "grow.play.personSingular": "Person",
  "grow.play.quiz.allAnswered": "Alle Teile beantwortet.",
  "grow.play.quiz.continue": "Weiter mit Teil {index}",
  "grow.play.quiz.eyebrow": "Grow · Play",
  "grow.play.quiz.missing": "Das Power Quiz ist auf dieser Umgebung noch nicht eingerichtet.",
  "grow.play.quiz.partAnswered": "beantwortet",
  "grow.play.quiz.partLabel": "Teil {index}",
  "grow.play.quiz.partOpen": "offen",
  "grow.play.quiz.partsProgress": "{answered} von {total} Teilen beantwortet",
  "grow.play.quiz.start": "Quiz starten",
  "grow.play.quiz.title": "Power Quiz",
  "grow.play.start": "Starten ↗",
  "grow.play.teamCount": "Team · {count}",
  "grow.play.title": "Play",
  "grow.play.tour.filter.desc": "Filtere den Katalog: Solo zeigt Spiele für dich allein, Team die für Gruppen.",
  "grow.play.tour.filter.title": "Solo oder Team",
  "grow.play.tour.grid.desc": "Der Rest des Katalogs umfasst {count} weitere Spiele wie Szenarien, Kartenspiele und Team-Übungen. Karten mit Play-Button sind startklar.",
  "grow.play.tour.grid.title": "Alle Spiele",
  "grow.play.tour.label": "Grow Play",
  "grow.play.tour.quiz.desc": "Das Highlight: 90 Aussagen über alle 30 Powers auf einer 5er-Skala. Deine Antworten bauen dein Power-Profil auf. Klicke hier, um zu starten.",
  "grow.play.tour.quiz.title": "Das Power Quiz",
  "grow.play.tour.summary": "Das ist die Play-Arcade: {count} spielerische Games und Übungen, die deine Powers in Bewegung bringen, solo oder im Team.",
  "grow.powerDetail.answeredCount": "{answered}/{total} beantwortet",
  "grow.powerDetail.askButton": "Assistent fragen",
  "grow.powerDetail.askImprove.0": "Wie kann ich mein {name} verbessern? Gib mir praktische, auf dem Referenzmaterial basierende Schritte.",
  "grow.powerDetail.askImprove.1": "Was sind laut Referenzmaterial konkrete Wege, um {name} zu entwickeln?",
  "grow.powerDetail.askImprove.2": "Coache mich beim Stärken von {name} – wo fange ich an?",
  "grow.powerDetail.askImprove.3": "Gib mir Übungen oder Gewohnheiten aus dem Referenzmaterial, um {name} zu fördern.",
  "grow.powerDetail.askImprove.4": "Was empfiehlt das Referenzmaterial, um {name} zu verbessern?",
  "grow.powerDetail.askImprove.5": "Hilf mir, einen einfachen Plan zu erstellen, um {name} zu verbessern.",
  "grow.powerDetail.askImprove.6": "Was sind die besten ersten Schritte, um {name} zu stärken?",
  "grow.powerDetail.askImprove.7": "Wie entwickelt man {name} üblicherweise? Nutze das Referenzmaterial.",
  "grow.powerDetail.askImprove.8": "Gib mir ein paar praktische Wege, um an {name} zu arbeiten.",
  "grow.powerDetail.askImprove.9": "Ich möchte besser in {name} werden. Was sollte ich laut Referenzmaterial tun?",
  "grow.powerDetail.askImproveButton": "Wie verbessere ich das?",
  "grow.powerDetail.askIntro.0": "Gib mir anhand des Referenzmaterials eine Einführung zu {name} und erzähl mir mehr darüber.",
  "grow.powerDetail.askIntro.1": "Stell mir {name} anhand des Referenzmaterials vor – worum geht es dabei?",
  "grow.powerDetail.askIntro.2": "Erkläre mir {name} auf Basis des Referenzmaterials.",
  "grow.powerDetail.askIntro.3": "Was sagt das Referenzmaterial über {name}? Gib mir einen Überblick.",
  "grow.powerDetail.askIntro.4": "Gib mir eine leicht verständliche Einführung zu {name}, gestützt auf das Referenzmaterial.",
  "grow.powerDetail.askIntro.5": "Führe mich anhand des Referenzmaterials durch {name}.",
  "grow.powerDetail.askIntro.6": "Fasse aus dem Referenzmaterial zusammen, was {name} ist und warum es wichtig ist.",
  "grow.powerDetail.askIntro.7": "Hilf mir, {name} zu verstehen – nutze das Referenzmaterial für eine Einführung.",
  "grow.powerDetail.askIntro.8": "Erkläre mir {name} aus dem Referenzmaterial, als wäre ich neu darin.",
  "grow.powerDetail.askIntro.9": "Was sollte ich laut Referenzmaterial über {name} wissen?",
  "grow.powerDetail.confidence": "Konfidenz: {percent}%",
  "grow.powerDetail.continueSelfAssessment": "Selbstbewertung fortsetzen",
  "grow.powerDetail.evidence": "Nachweis ({count})",
  "grow.powerDetail.eyebrow": "Power · {abbr}",
  "grow.powerDetail.noEvidence": "Keine Belege vorhanden. Lade Dokumente in die {link}, um Nachweise zu sammeln.",
  "grow.powerDetail.noPodcasts": "Noch keine Podcasts zu „{name}\" hinterlegt.",
  "grow.powerDetail.noScripts": "Noch keine Scripts zu „{name}\" hinterlegt.",
  "grow.powerDetail.noSmartAnalysis": "Noch keine Smart-Analyse für diese Power.",
  "grow.powerDetail.noVideos": "Noch keine Videos zu „{name}\" hinterlegt.",
  "grow.powerDetail.openDocument": "Dokument öffnen",
  "grow.powerDetail.openDocumentNamed": "Dokument {name} öffnen",
  "grow.powerDetail.page": "Seite {number}",
  "grow.powerDetail.podcasts": "Podcasts",
  "grow.powerDetail.powerAnalysis": "Power-Analyse",
  "grow.powerDetail.powerDetails": "Power-Details",
  "grow.powerDetail.questionnaires": "Fragebögen",
  "grow.powerDetail.rationale": "Begründung",
  "grow.powerDetail.repeatSelfAssessment": "Selbstbewertung wiederholen",
  "grow.powerDetail.revealPower": "„{name}\" aufdecken",
  "grow.powerDetail.scripts": "Scripts",
  "grow.powerDetail.selfAssessment": "Selbstbewertung",
  "grow.powerDetail.selfEvaluation": "Selbsteinschätzung",
  "grow.powerDetail.selfEvaluationIntro": "Beantworte die Aussagen zu „{name}\". Dein Ergebnis fließt in den Selbstbewertungs-Score; bei vollständiger Beantwortung erhältst du die Medaille.",
  "grow.powerDetail.smartAnalysis": "Smart Analyse",
  "grow.powerDetail.stanceContra": "Contra",
  "grow.powerDetail.stancePro": "Pro",
  "grow.powerDetail.startSelfAssessment": "Selbstbewertung starten",
  "grow.powerDetail.tour.artwork.desc": "Das Artwork ist nur so scharf, wie deine Selbsteinschätzung vollständig ist. Bisher hast du {answered} von {total} Aussagen beantwortet. Beantworte mehr, um es ganz freizulegen.",
  "grow.powerDetail.tour.artwork.title": "Das Artwork",
  "grow.powerDetail.tour.description.desc": "Lies, wofür „{name}“ steht und zu welchem Cluster es gehört. Das ist eine gute Grundlage, bevor du dich selbst einschätzt.",
  "grow.powerDetail.tour.description.title": "Was diese Power bedeutet",
  "grow.powerDetail.tour.label": "Grow Power",
  "grow.powerDetail.tour.selfEvaluation.desc": "Beantworte hier die Aussagen zu „{name}“; {answered} von {total} sind geschafft. Wenn du alle beantwortest, gibt es die Medaille und das Artwork wird scharf.",
  "grow.powerDetail.tour.selfEvaluation.doneDesc": "Alle {total} Aussagen beantwortet. Dein Selbsteinschätzungs-Score ist {score}. Du kannst die Einschätzung jederzeit wiederholen und aktualisieren.",
  "grow.powerDetail.tour.selfEvaluation.title": "Selbsteinschätzung",
  "grow.powerDetail.tour.summary": "Auf dieser Seite dreht sich alles um die Power „{name}“ ({abbr}). {status}",
  "grow.powerDetail.tour.summaryStatus": "Du hast {answered} von {total} Selbsteinschätzungs-Aussagen beantwortet.",
  "grow.powerDetail.tour.summaryStatusNone": "Du hast sie noch nicht selbst eingeschätzt.",
  "grow.powerDetail.videos": "Videos",
  "grow.powerLibrary.all": "Alle",
  "grow.powerLibrary.askButton": "Meine Power Map lesen",
  "grow.powerLibrary.askIntro.0": "Lies meine Power Map – wo liegen meine Stärken und Lücken, und worauf sollte ich mich konzentrieren?",
  "grow.powerLibrary.askIntro.1": "Gib mir einen Überblick über meine Powers: was stark ist, was schwach, und wo ich wachsen kann.",
  "grow.powerLibrary.askIntro.2": "Deute mein Power-Profil – die Höhen, die Tiefen und einen Fokusvorschlag.",
  "grow.powerLibrary.askIntro.3": "Welche Muster siehst du auf Basis meiner Powers und des Referenzmaterials?",
  "grow.powerLibrary.askIntro.4": "Hilf mir, mein gesamtes Power-Profil zu verstehen und wo ich investieren sollte.",
  "grow.powerLibrary.askIntro.5": "Was sagen meine stärksten und schwächsten Powers über mich aus?",
  "grow.powerLibrary.askIntro.6": "Fasse meine Power-Landschaft zusammen und empfiehl einen Wachstumsfokus.",
  "grow.powerLibrary.askIntro.7": "Wo liegen meine größten Chancen über alle Powers hinweg?",
  "grow.powerLibrary.askIntro.8": "Führe mich durch meine Power Map und schlag vor, woran ich zuerst arbeite.",
  "grow.powerLibrary.askIntro.9": "Gib mir einen Gesamtüberblick über meine Powers und einen Startpunkt.",
  "grow.powerLibrary.clearSearch": "Suche leeren",
  "grow.powerLibrary.eyebrow": "Power Map",
  "grow.powerLibrary.heading": "{count} Powers",
  "grow.powerLibrary.noResults": "Keine Power gefunden für „{query}\".",
  "grow.powerLibrary.onlyUnrated": "Unbewertete",
  "grow.powerLibrary.openPower": "{name} öffnen",
  "grow.powerLibrary.powerScore": "Power Score",
  "grow.powerLibrary.profileProgress": "Profilfortschritt",
  "grow.powerLibrary.profileProgressTooltip": "Beantworte alle Fragen zu den Powers, um deinen Profilfortschritt zu erhöhen.",
  "grow.powerLibrary.searchPlaceholder": "Suchen nach Name oder Kürzel",
  "grow.powerLibrary.sourceCombined": "Kombiniert",
  "grow.powerLibrary.sourceSelf": "Selbstbewertung",
  "grow.powerLibrary.sourceSmart": "Smart Analyse",
  "grow.powerLibrary.subheading": "Das vollständige Vokabular: {clusters} Cluster, {powers} Powers.",
  "grow.powerLibrary.tour.filters.desc": "Suche Powers nach Name oder Kürzel, oder tippe auf Unbewertet, um nur die {unrated} Powers zu sehen, deren Selbsteinschätzung noch offen ist.",
  "grow.powerLibrary.tour.filters.title": "Suchen & Filtern",
  "grow.powerLibrary.tour.grid.desc": "Alle {total} Powers, gruppiert in {clusters} Cluster. Klicke eine Kachel, um die Power zu öffnen. Medaille und Artwork erscheinen, sobald ihre Selbsteinschätzung vollständig ist; {completed} bisher geschafft.",
  "grow.powerLibrary.tour.grid.title": "Die Power-Kacheln",
  "grow.powerLibrary.tour.label": "Grow Map",
  "grow.powerLibrary.tour.scoreSource.desc": "Stelle um, welche Bewertung die Zahlen auf allen Kacheln zeigen. Wähle Selbsteinschätzung, um die Werte aus deinen eigenen Bewertungen zu sehen.",
  "grow.powerLibrary.tour.scoreSource.title": "Bewertungsquelle",
  "grow.powerLibrary.tour.summary": "Das ist die Power Map: alle {total} Powers im Periodensystem-Stil. {completed} von {total} hast du bisher vollständig selbst eingeschätzt.",
  "grow.powerQuestionnaires.answer": "Beantworten",
  "grow.powerQuestionnaires.completed": "abgeschlossen",
  "grow.powerQuestionnaires.empty": "Noch keine Fragebögen zu „{powerName}“ hinterlegt.",
  "grow.powerQuestionnaires.heading": "Fragebögen",
  "grow.powerQuestionnaires.loading": "lädt…",
  "grow.powerQuestionnaires.repeat": "Wiederholen",
  "grow.questionnaire.eyebrow": "Grow · Fragebogen",
  "grow.questionnaire.fallbackName": "Fragebogen",
  "grow.questionnaire.noQuestions": "Keine Fragen in diesem Fragebogen.",
  "grow.questionnaire.questionLabel": "Frage {position}",
  "grow.questionnaire.submit": "Absenden",
  "grow.questionnaire.unknownElement": "Unbekanntes Element",
  "grow.title": "Wachsen",
  "grow.tour.label": "Grow",
  "grow.tour.progress.desc": "Dein Gesamtfortschritt: {score}%{rank, select, none {} other { (Rang: {rank})}}. Beantworte Power-Fragen, um ihn zu steigern. Klicke auf „Power Map“, um alle 30 Powers zu sehen.",
  "grow.tour.progress.title": "Profil-Fortschritt",
  "grow.tour.room.desc": "{count, plural, =0 {Deine am schwächsten bewerteten Powers erscheinen hier.} other {Deine am niedrigsten bewerteten Powers: {names}. Der Button darunter fragt mich nach Verbesserungsideen.}}",
  "grow.tour.room.title": "Luft nach oben",
  "grow.tour.strengths.desc": "{count, plural, =0 {Sobald du Powers bewertest, erscheinen deine stärksten hier.} other {Deine stärksten Powers im Moment: {names}.}}",
  "grow.tour.strengths.title": "Deine Stärken",
  "grow.tour.summary": "Das ist dein Grow-Dashboard. Dein Gesamt-Power-Score liegt bei {score}%.",
  "grow.tour.upNext.desc": "{count, plural, =0 {Alle Selbsteinschätzungen sind erledigt. Nichts ist offen.} other {Du hast {count} offene Selbsteinschätzungen; die am weitesten fortgeschrittenen stehen oben. Klicke eine an, um weiter zu bewerten.}}",
  "grow.tour.upNext.title": "Als Nächstes",
  "grow.unknownElement": "Unbekanntes Element",
  "grow.watch.contentCount": "{count} Inhalte",
  "grow.watch.emptyContent": "Noch keine Inhalte hinterlegt. Sobald Videos, Podcasts oder Scripts vorliegen, erscheinen sie hier.",
  "grow.watch.filterAll": "Alle",
  "grow.watch.intro": "Inhalte zum Konsumieren rund um deine Powers: Videos, Podcasts und Scripts. Setze dich hin, schau zu, hör rein und lies nach.",
  "grow.watch.loadingContent": "Inhalte werden geladen …",
  "grow.watch.title": "Watch",
  "grow.watch.tour.content.desc": "{count} Inhalte, jeweils mit Power und Cluster markiert. Klicke eine Karte, um den Inhalt anzusehen.",
  "grow.watch.tour.content.emptyDesc": "Noch sind keine Inhalte verfügbar. Sobald es Videos, Podcasts oder Skripte gibt, erscheinen sie hier als Karten zum Öffnen.",
  "grow.watch.tour.content.title": "Der Katalog",
  "grow.watch.tour.emptySummary": "Das ist Watch: Lerninhalte rund um deine Powers als Videos, Podcasts und Skripte. Im Moment ist hier noch nichts.",
  "grow.watch.tour.filters.desc": "Grenze den Katalog nach Format ein (Videos, Podcasts oder Skripte), oder wähle Alle für alles.",
  "grow.watch.tour.filters.title": "Inhalts-Filter",
  "grow.watch.tour.label": "Grow Watch",
  "grow.watch.tour.summary": "Das ist Watch: Lerninhalte rund um deine Powers als Videos, Podcasts und Skripte. Im Moment gibt es hier {count} Inhalte.",
  "home.allMatches": "Alle Matches ↗",
  "home.allRated": "alle bewertet",
  "home.candidatesCount": "{count, plural, one {# Kandidat} other {# Kandidaten}}",
  "home.certificate": "Zertifikat",
  "home.communitiesSub": "{count, plural, one {# Community} other {# Communities}}",
  "home.community": "Community",
  "home.contacts": "Kontakte",
  "home.documents": "Dokumente",
  "home.draft": "Entwurf",
  "home.education": "Bildung",
  "home.entries": "Einträge",
  "home.greeting": "Schön, dass du da bist.",
  "home.group": "Gruppe",
  "home.inComparison": "Im Vergleich · Community",
  "home.myPosts": "Meine Beiträge ↗",
  "home.noCommunity": "Noch keine Community.",
  "home.noContacts": "noch keine Kontakte",
  "home.noMatches": "Keine Matches",
  "home.noOwnPosts": "Noch keine eigenen Beiträge",
  "home.noOwnPostsHint": "erstelle ein Projekt oder einen Post",
  "home.noPins": "noch nichts gepinnt",
  "home.notRatedYet": "noch nicht bewertet",
  "home.notStarted": "noch nicht gestartet",
  "home.openCount": "{count} offen",
  "home.openProfileOf": "{name} öffnen",
  "home.personsCount": "{count, plural, one {# Person} other {# Personen}}",
  "home.pins": "Pins",
  "home.postsCount": "{count, plural, one {# Post} other {# Posts}}",
  "home.powerVersus": "Power Versus",
  "home.profile": "Profil",
  "home.profileEmpty": "noch nichts erfasst",
  "home.profileFallback": "Profil",
  "home.profileProgress": "Profilfortschritt",
  "home.projectsCount": "{count, plural, one {# Projekt} other {# Projekte}}",
  "home.rated": "Bewertet",
  "home.searchCommunities": "Communities durchsuchen",
  "home.searchGroups": "Gruppen durchsuchen",
  "home.service": "Dokumente",
  "home.serviceEmpty": "noch nichts abgelegt",
  "home.strongest": "Stärkste: {name}",
  "home.tobis.favorites": "Favoriten",
  "home.tobis.favoritesEmpty": "Noch keine Favoriten. Auf einer Titel- oder Personenseite den Stern setzen.",
  "home.tobis.market": "Markt",
  "home.tobis.marketSub": "letzter TV-Tag · {days, plural, one {# Tag} other {# Tage}} erfasst",
  "home.tobis.people": "Personen",
  "home.tobis.recent": "Zuletzt hereingekommen",
  "home.tobis.title": "Movie",
  "home.tobis.titles": "Titel",
  "home.tobis.updatedToday": "heute aktualisiert · {week} in 7 Tagen",
  "home.tobis.viewAll": "Alle Titel ↗",
  "home.tour.grow.desc": "Dein Profil-Fortschritt, deine stärksten Powers und offene Selbsteinschätzungen.",
  "home.tour.grow.title": "Grow",
  "home.tour.label": "Hauptseite",
  "home.tour.match.desc": "Deine Matches. Klicke eines an, um dort weiterzumachen, wo du warst.",
  "home.tour.match.title": "Match",
  "home.tour.save.desc": "Deine Profil-Einträge, Dokumente, Kontakte und Pins, mit Schnellaktionen zum Anlegen.",
  "home.tour.save.title": "Save",
  "home.tour.share.desc": "Deine Beiträge und Projekte und was rund um sie passiert.",
  "home.tour.share.title": "Share",
  "home.tour.summary": "Das ist die Hauptseite: die wichtigsten Zahlen aus allen Bereichen auf einen Blick. Jede Kachel führt zu ihrer Stelle in der App.",
  "home.tour.tobis.desc": "Was der letzte Import gebracht hat: Titel, Personen und Markt, jede Kachel führt zu ihrer Liste.",
  "home.tour.tobis.title": "Movie",
  "home.unnamedMatch": "Unbenanntes Match",
  "home.uploadFile": "Datei hochladen",
  "home.viewAll": "Alle ansehen ↗",
  "home.viewPower": "{name} ansehen",
  "home.viewPowerMap": "Power Map anzeigen",
  "home.viewUnrated": "Unbewertete anzeigen",
  "home.weakestSuffix": " vs. Schwächste: {name}",
  "home.workExperience": "Berufserfahrung",
  "likert.1": "Trifft nicht zu",
  "likert.2": "Trifft eher nicht zu",
  "likert.3": "Teils / teils",
  "likert.4": "Trifft eher zu",
  "likert.5": "Trifft voll zu",
  "linkedin.error.authorize_denied": "Die LinkedIn-Autorisierung wurde abgebrochen.",
  "linkedin.error.cancelled": "Du hast die LinkedIn-Verbindung abgebrochen. Du kannst dich jederzeit erneut verbinden.",
  "linkedin.error.import_failed": "Der Import ist fehlgeschlagen. Bitte versuche es später erneut.",
  "linkedin.error.invalid_callback": "Die Antwort von LinkedIn war unvollständig. Bitte versuche es erneut.",
  "linkedin.error.invalid_state": "Die LinkedIn-Sitzung ist abgelaufen. Bitte versuche es erneut.",
  "linkedin.error.not_configured": "Der LinkedIn-Import ist nicht konfiguriert. Bitte wende dich an deine Administration.",
  "linkedin.error.reconnect": "Deine LinkedIn-Sitzung ist abgelaufen oder der Zugriff war unvollständig. Bitte verbinde dich erneut.",
  "linkedin.error.stillImporting": "Der Import dauert länger als erwartet. Er läuft weiter – aktualisiere die Seite gleich, um das Ergebnis zu sehen.",
  "linkedin.error.temporary": "LinkedIn hat nicht rechtzeitig geantwortet. Bitte versuche es gleich noch einmal.",
  "linkedin.error.token_exchange": "Verbindung zu LinkedIn fehlgeschlagen. Bitte versuche es später erneut.",
  "linkedin.error.unavailable": "Der LinkedIn-Import ist derzeit nicht verfügbar. Bitte wende dich an deine Administration.",
  "linkedin.error.unexpected": "Beim Import ist etwas schiefgelaufen. Bitte versuche es später erneut.",
  "linkedin.import.abort": "Import abbrechen",
  "linkedin.import.abortTip": "Der Import läuft noch – du kannst weiter warten oder ihn abbrechen und von vorne neu starten. Gespeichert wurde noch nichts.",
  "linkedin.import.alreadyUpToDate": "Alles, was LinkedIn ergänzen könnte, ist bereits in deinem Profil vorhanden.",
  "linkedin.import.close": "Schließen",
  "linkedin.import.connect": "Mit LinkedIn verbinden",
  "linkedin.import.dialogTitle": "LinkedIn-Import",
  "linkedin.import.elapsed": "Verstrichene Zeit: {time}",
  "linkedin.import.field.bio": "Bio",
  "linkedin.import.field.currentEmployer": "Arbeitgeber",
  "linkedin.import.field.dateOfBirth": "Geburtstag",
  "linkedin.import.field.degree": "Abschluss",
  "linkedin.import.field.description": "Beschreibung",
  "linkedin.import.field.email": "E-Mail",
  "linkedin.import.field.employer": "Arbeitgeber",
  "linkedin.import.field.endDate": "Ende",
  "linkedin.import.field.fieldOfStudy": "Studienfach",
  "linkedin.import.field.institution": "Institution",
  "linkedin.import.field.issued": "Ausgestellt",
  "linkedin.import.field.jobTitle": "Jobtitel",
  "linkedin.import.field.language": "Sprache",
  "linkedin.import.field.level": "Niveau",
  "linkedin.import.field.location": "Ort",
  "linkedin.import.field.name": "Name",
  "linkedin.import.field.period": "Zeitraum",
  "linkedin.import.field.phone": "Telefon",
  "linkedin.import.field.profession": "Beruf",
  "linkedin.import.field.skill": "Skill",
  "linkedin.import.field.startDate": "Beginn",
  "linkedin.import.field.street": "Straße",
  "linkedin.import.field.title": "Position",
  "linkedin.import.field.zipCode": "PLZ",
  "linkedin.import.importing": "Deine LinkedIn-Daten werden importiert – das kann bis zu einer Minute dauern …",
  "linkedin.import.intro": "Verbinde dein LinkedIn-Konto, um Profil, Positionen und Fähigkeiten zu importieren. Vor dem Speichern prüfst du, was übernommen oder ersetzt wird.",
  "linkedin.import.loadingResult": "Import wird abgeschlossen…",
  "match.result.ranking.actualInline": "Nachweis:",
  "match.result.ranking.assessment.interviewQuestions": "Fragen fürs Gespräch",
  "match.result.ranking.assessment.ratingVeryHigh": "Sehr geeignet",
  "match.result.ranking.assessment.ratingHigh": "Geeignet",
  "match.result.ranking.assessment.ratingMedium": "Bedingt geeignet",
  "match.result.ranking.assessment.ratingLow": "Eher ungeeignet",
  "match.result.ranking.assessment.ratingVeryLow": "Ungeeignet",
  "match.result.ranking.fulfilledTab": "Erfüllt ({count})",
  "match.result.ranking.unfulfilledTab": "Nicht erfüllt ({count})",
  "match.result.suitability.basis": "AI-Gesamteinschätzung",
  "match.result.suitability.empty": "Noch keine AI-Eignungsscores vorhanden. Bitte den Match erneut ausführen.",
  "match.result.suitability.header": "Top 5 – beste Eignung",
  "match.result.suitability.openProfile": "{name} – Profil öffnen",
  "match.result.suitability.rankLabel": "Rang {rank}",
  "match.result.suitability.scoreLabel": "AI-Eignung {score} %",
  "profile.merge.save": "Änderungen speichern",
  "profile.merge.saving": "Wird gespeichert…",
  "profile.merge.savePartial": "{count, plural, one {# Änderung konnte nicht gespeichert werden. Bitte erneut versuchen.} other {# Änderungen konnten nicht gespeichert werden. Bitte erneut versuchen.}}",
  "profile.merge.dateBlocked": "Einige Daten müssen vor dem Speichern korrigiert werden.",
  "profile.merge.fieldBlocked": "Einige Werte müssen vor dem Speichern korrigiert werden.",
  "profile.merge.languageBlocked": "Bitte eine echte Sprache für den importierten Eintrag wählen oder ihn überspringen.",
  "profile.merge.language.unknown": "„{value}“ ist keine erkennbare Sprache. Bitte die richtige wählen oder den Eintrag überspringen.",
  "profile.merge.reviewBlocked": "Prüfe jede Änderung vor dem Speichern.",
  "profile.merge.date.future": "Dieses Datum darf nicht in der Zukunft liegen.",
  "profile.merge.date.format": "Verwende ein Datum wie JJJJ, JJJJ-MM oder JJJJ-MM-TT.",
  "profile.merge.date.range": "Das Enddatum muss am oder nach dem Startdatum liegen.",
  "profile.merge.date.beforeBirth": "Dieses Datum liegt vor dem Geburtsdatum.",
  "profile.merge.field.tooLong": "Bitte auf höchstens {max} Zeichen kürzen.",
  "profile.merge.field.invalidEmail": "Bitte eine gültige E-Mail-Adresse eingeben.",
  "profile.merge.field.invalidPhone": "Bitte eine gültige Telefonnummer eingeben.",
  "profile.merge.field.childCountMax": "Die Anzahl der Kinder darf {max} nicht überschreiten.",
  "profile.merge.bar.aria": "Importänderungen",
  "profile.merge.bar.open": "{count, plural, one {# Feld zu prüfen} other {# Felder zu prüfen}}",
  "profile.merge.bar.allReviewed": "Alle Änderungen geprüft",
  "profile.merge.bar.previous": "Zurück",
  "profile.merge.bar.next": "Weiter",
  "profile.merge.guide.step": "{current, number} von {total, number}",
  "profile.merge.guide.review": "Prüfen",
  "profile.merge.status.keep": "Dein Wert bleibt",
  "profile.merge.status.use": "Importierter Wert wird verwendet",
  "profile.merge.status.add": "Wird hinzugefügt",
  "profile.merge.status.skip": "Übersprungen",
  "profile.merge.keepAll": "Alle meine behalten",
  "profile.merge.useAll": "Alle importierten übernehmen",
  "profile.merge.skip": "Überspringen",
  "profile.merge.add": "Hinzufügen",
  "profile.merge.showMore": "Mehr anzeigen",
  "profile.merge.showLess": "Weniger anzeigen",
  "profile.merge.badge.new": "Neu",
  "profile.merge.badge.conflict": "Weicht ab",
  "profile.merge.incomingLabel": "Importiert",
  "profile.merge.keep": "Meine behalten",
  "profile.merge.use": "Übernehmen",
  "profile.merge.chooseAria": "Eigenen Wert behalten oder den importierten verwenden",
  "profile.merge.side.existing": "Dein Wert",
  "profile.merge.editAria.existing": "Deinen Wert bearbeiten",
  "profile.merge.editAria.incoming": "Importierten Wert bearbeiten",
  "profile.merge.reset.existing": "Auf deinen gespeicherten Wert zurücksetzen",
  "profile.merge.reset.incoming": "Auf den importierten Wert zurücksetzen",
  "profile.merge.replacesSaved": "Ersetzt deinen gespeicherten Wert",
  "profile.merge.replacesSavedRow": "Ersetzt deinen gespeicherten Eintrag",
  "profile.merge.skills.importAllAria": "Alle Kenntnisse importieren",
  "profile.merge.cefr.native": "Muttersprachler",
  "linkedin.import.openingReview": "Dein Profil wird geöffnet, um die Änderungen zu prüfen…",
  "linkedin.import.warning.certificateInvalidName": "Ein Zertifikat wurde übersprungen, weil sein Name ungültig war.",
  "linkedin.import.warning.certificateNameDefaulted": "Ein Zertifikat hatte keinen Namen und wurde mit einem Platzhalter importiert.",
  "linkedin.import.warning.educationInvalidStartDate": "Ein Bildungseintrag wurde übersprungen, weil sein Startdatum ungültig war.",
  "linkedin.import.warning.educationMissingFieldOfStudyAndDegree": "Ein Bildungseintrag wurde übersprungen, weil weder Fachrichtung noch Abschluss angegeben waren.",
  "linkedin.import.warning.educationStartDateDefaulted": "Ein Bildungseintrag hatte kein Startdatum und wurde auf den aktuellen Monat gesetzt.",
  "linkedin.import.warning.experienceInvalidJobTitle": "Eine Position wurde übersprungen, weil ihre Berufsbezeichnung ungültig war.",
  "linkedin.import.warning.experienceInvalidStartDate": "Eine Position wurde übersprungen, weil ihr Startdatum ungültig war.",
  "linkedin.import.warning.experienceJobTitleDefaulted": "Eine Position hatte keine Berufsbezeichnung und wurde mit einem Platzhalter importiert.",
  "linkedin.import.warning.experienceStartDateDefaulted": "Eine Position hatte kein Startdatum und wurde auf den aktuellen Monat gesetzt.",
  "linkedin.import.warning.languageMissingName": "Eine Sprache wurde übersprungen, weil sie keinen Namen hatte.",
  "linkedin.import.warning.languageTagTooLong": "Eine Sprache wurde übersprungen, weil ihr Name zu lang war.",
  "linkedin.import.warning.languageUnrecognizedName": "Eine Sprache wurde übersprungen, weil ihr Name nicht erkannt wurde.",
  "linkedin.import.warning.languageUnrecognizedProficiency": "Das Sprachniveau einer Sprache wurde nicht erkannt.",
  "match.addDocumentsAriaLabel": "Dokumente hinzufügen",
  "match.agenticAi": "Agentic AI",
  "match.agenticAiBoxDesc": "Dieses Match wird von Agentic AI unterstützt: Anforderungen, Recherche und Vorschläge werden automatisch ergänzt.",
  "match.agenticAiConfig": "Agentic-AI-Konfiguration",
  "match.agenticAiOff": "Agentic AI aus",
  "match.agenticAiOn": "Agentic AI aktiv",
  "match.agenticAiQuestion": "Soll dieses Match mit Agentic AI unterstützt werden?",
  "match.aiHintsPlaceholder": "Optionale Hinweise an die KI: Fokus, Ton, Muss-Kriterien, was vermeiden …",
  "match.challenge.aiAssist": "KI-Unterstützung",
  "match.challenge.aiAssistHint": "KI prüft Anforderungen, die nicht direkt aus dem Profil belegbar sind, und erstellt zu jeder Person eine Einschätzung mit Score.",
  "match.challenge.aiDeriveHint": "Leitet Team-Größe, Anforderungen und Powers automatisch aus Titel und Beschreibung ab. Du kannst alles danach noch anpassen.",
  "match.challenge.aiDeriveHintNoTeamSize": "Leitet Anforderungen und Powers automatisch aus Titel und Beschreibung ab. Du kannst alles danach noch anpassen.",
  "match.challenge.aiFillFirstHint": "Erst Requirements Prompt oder detaillierte Beschreibung ausfüllen, damit die KI etwas ableiten kann.",
  "match.challenge.aiGenerating": "KI generiert…",
  "match.challenge.aiWorking": "KI arbeitet – bitte warten.",
  "match.challenge.describeProject": "Projekt beschreiben",
  "match.challenge.describeRole": "Rolle beschreiben",
  "match.challenge.enterTitle": "Titel eintragen",
  "match.challenge.generateWithAi": "Mit KI generieren",
  "match.challenge.linkBtn": "Verknüpfen",
  "match.challenge.linkProjectTitle": "Projekt mit existierendem Share-Item verknüpfen",
  "match.challenge.noFilesYet": "Noch keine Dateien.",
  "match.challenge.openLinkedShare": "Verknüpftes Share-Item öffnen",
  "match.challenge.projectTitleLabel": "Projekt-Titel",
  "match.challenge.roleTitleLabel": "Rollen-Titel",
  "match.challenge.publishBtn": "Veröffentlichen",
  "match.challenge.requirements": "Anforderungen",
  "match.challenge.requirementsSharedInfo": "Berücksichtigt werden nur Profilinformationen, die Kandidat:innen geteilt haben.",
  "match.challenge.requirementsSharedInfoLabel": "Hinweis",
  "match.challenge.unlink": "Verbindung lösen",
  "match.challenge.unlinkTitle": "Verbindung zum Share-Item lösen",
  "match.challenge.unnamedSharedItem": "Unbenanntes Share-Item",
  "match.charsCount": "{count} Zeichen",
  "match.detail.error": "Fehler: {message}",
  "match.detail.invalidUrl": "Ungültige Match-URL.",
  "match.detail.loading": "Lädt …",
  "match.detail.notFound": "Match nicht gefunden.",
  "match.detailedPlaceholder": "Kontext, Outcome, Constraints, Vorerfahrungen, alles was sonst relevant ist.",
  "match.docs.retry": "↻ Erneut versuchen",
  "match.docs.tooLarge": "Zu groß (max. {max} MB pro Datei): {names}",
  "match.docs.uploadFailed": "Upload fehlgeschlagen.",
  "match.docs.uploading": "Wird hochgeladen…",
  "match.documents": "Dokumente",
  "match.dropFiles": "Dateien <b>hierher ziehen</b> oder klicken",
  "match.editor.reset": "Zurücksetzen",
  "match.fieldDetailedDesc": "Detaillierte Beschreibung",
  "match.fieldShortDesc": "Kurzbeschreibung",
  "match.freitext.addJobTitle": "Jobtitel",
  "match.freitext.addSkill": "Skill",
  "match.freitext.jobTitlePlaceholder": "z. B. Senior Designer, Lead Engineer",
  "match.freitext.levelLabel": "Niveau",
  "match.freitext.skillPlaceholder": "z. B. C++, Production Workflows",
  "match.freitext.title": "Fachwissen & Berufserfahrung",
  "match.group.COMMUNICATION": "Kommunikationsfähigkeit",
  "match.group.FUTURE_ORIENTATION": "Zukunftsorientierung",
  "match.group.INVENTIVENESS": "Erfindungsstärke",
  "match.group.RESILIENCE": "Belastbarkeit",
  "match.group.RESULT_ORIENTATION": "Ergebnisorientierung",
  "match.group.TEAM_SPIRIT": "Teamfähigkeit",
  "match.kpiTeamSize": "Team-Größe",
  "match.labelLanguage": "Sprache",
  "match.landing.body": "Initiiere ein Match, definiere Anforderungen und lass den Solver Menschen und Agentic-AI zu einem optimalen Team komponieren – transparent, gewichtet, erklärbar.",
  "match.landing.candidatesCount": "{count} Kandidaten",
  "match.landing.error": "Fehler: {message}",
  "match.landing.loading": "lädt…",
  "match.landing.newMatch": "Neues Match erstellen ↗",
  "match.landing.noMatches": "Keine Matches",
  "match.landing.noMatchesHint": "… oder nicht angemeldet",
  "match.landing.resultsCount": "{count} Ergebnisse",
  "match.landing.subtitle": "Vom Teamgedanken{br}zum besten Team.",
  "match.landing.yourMatches": "Deine Matches",
  "match.matchNameLabel": "Match-Name",
  "match.new.accessLabel": "Zugriff",
  "match.new.create": "Erstellen",
  "match.new.creating": "Erstellt …",
  "match.new.defaultName": "Neues Match",
  "match.new.title": "Neues Match erstellen",
  "match.modal.accessCount": "Zugriff · {count}",
  "match.modal.addPersonPlaceholder": "+ Person hinzufügen – Name suchen …",
  "match.modal.chooseShareItem": "Share-Item wählen",
  "match.modal.fillTitle": "Projekt mit dem Share-Item füllen",
  "match.modal.link": "Verknüpfen",
  "match.modal.linkOnly": "Nur verknüpfen",
  "match.modal.linkOnlyTitle": "Verknüpfen, ohne Inhalte zu kopieren",
  "match.modal.linkWithShareItem": "Mit Share-Item verknüpfen",
  "match.modal.linking": "Verknüpft …",
  "match.modal.loadingEllipsis": "lädt …",
  "match.modal.matchNotes": "Notizen zum Match",
  "match.modal.matchNotesPlaceholder": "Interne Notizen, Kontext oder offene Fragen – nicht die Projektbeschreibung.",
  "match.modal.myShareItems": "Meine Share-Items",
  "match.modal.myShareItemsCount": "Meine Share-Items · {count}",
  "match.modal.nameNotesAccess": "Name, Notizen & Zugriff",
  "match.modal.noAccessYet": "Niemand hat Zugriff. Unten Person hinzufügen.",
  "match.modal.noHits": "Keine Treffer.",
  "match.modal.noWriteRights": "Du hast keine Schreibrechte auf diese Match-Einstellungen.",
  "match.modal.overwriteTitle": "Projekt-Inhalte mit dem Share-Item überschreiben",
  "match.modal.owner": "Eigentümer:in",
  "match.modal.ownerCreatedBy": "Eigentümer:in · erstellt von",
  "match.modal.publishEyebrow": "Veröffentlichen",
  "match.modal.publishHint": "Bild, Theme und Audience sind anschließend im Share-Editor zu ergänzen.",
  "match.modal.publishNow": "Jetzt veröffentlichen",
  "match.modal.publishOpenInEditor": "Im Editor öffnen",
  "match.modal.publishOpeningEditor": "Öffnet …",
  "match.modal.publishPublishing": "Veröffentlicht …",
  "match.modal.publishQuestion": "Wie willst du das Projekt als Share-Item veröffentlichen?",
  "match.modal.removeLink": "Verknüpfung entfernen?",
  "match.modal.roleAdmin": "Admin",
  "match.modal.roleEditor": "Bearbeiter:in",
  "match.modal.roleHintAdmin": "Alle Inhalte + Zugriff verwalten",
  "match.modal.roleHintEditor": "Inhalte bearbeiten",
  "match.modal.roleHintReader": "Nur ansehen",
  "match.modal.roleReader": "Leser:in",
  "match.modal.savingEllipsis": "Speichert …",
  "match.modal.searchByName": "Nach Name suchen …",
  "match.modal.searchingEllipsis": "sucht …",
  "match.modal.takeOver": "Übernehmen",
  "match.modal.unlinkAction": "Verbindung lösen",
  "match.modal.unlinkBody": "Die Verknüpfung zu <b>{name}</b> wird entfernt.",
  "match.modal.unlinkEyebrow": "Verbindung lösen",
  "match.modal.unlinkHint": "Die kopierten Inhalte (Titel, Beschreibung, Dokumente) bleiben erhalten – nur der Hinweis auf das Share-Item verschwindet.",
  "match.modal.unlinking": "Trennt …",
  "match.modal.unnamedShareItem": "Unbenanntes Share-Item",
  "match.modal.visibleToMe": "Sichtbar für mich",
  "match.modal.visibleToMeCount": "Sichtbar für mich · {count}",
  "match.modePicker.assessOutput": "Einschätzung + Lücken",
  "match.modePicker.assessSlogan": "Du hast bereits ein Team im Kopf und willst sehen, wie gut es passt und wo die Lücken sind.",
  "match.modePicker.assessTitle": "Team bewerten",
  "match.modePicker.optimizeTitle": "Team optimieren",
  "match.modePicker.rankTitle": "Kandidaten vergleichen",
  "match.modePicker.optimizeOutput": "ein Team",
  "match.modePicker.optimizeSlogan": "Du hast einen Pool an Personen und willst das beste Team für ein Projekt oder eine Aufgabe zusammenstellen.",
  "match.modePicker.outputLabel": "Ergebnis",
  "match.modePicker.rankOutput": "Rangliste",
  "match.modePicker.rankSlogan": "Du besetzt eine offene Stelle und willst Kandidaten danach sortieren, wer am besten passt.",
  "match.modePicker.title": "Welche Frage soll dieses Match beantworten?",
  "match.noMatchesEmpty": "Keine Matches",
  "match.noPeopleFound": "Keine Personen gefunden",
  "match.notConnectedYet": "noch nicht angebunden",
  "match.optChoose": "– wählen –",
  "match.people.addAll": "Alle hinzufügen ({count})",
  "match.people.addAllFromSet": "Alle {count} aus {name} hinzufügen",
  "match.people.addAllPinned": "Alle {count} Gepinnten hinzufügen",
  "match.people.addInterested": "Interessenten hinzufügen ({count})",
  "match.people.addUpTo": "Bis zu {count} passende hinzufügen",
  "match.people.added": "Hinzugefügt",
  "match.people.allPinned": "Alle Gepinnten",
  "match.people.evaluateLocked": "Dieses Team bewerten",
  "match.people.evaluateLockedTitle": "Dieses vollständig gesperrte Team bewerten",
  "match.people.emptyCandidates": "Noch keine Kandidaten – links über Suche oder Filter hinzufügen.",
  "match.people.finderTitle": "Personen finden",
  "match.people.interestedExplain": "Personen mit Interesse an diesem Projekt",
  "match.people.intro": "Suche und filtere Personen aus deinem Unternehmen und füge sie als Kandidaten hinzu.",
  "match.people.introLock": "Markiere einzelne als Fix im Team, wenn sie gesetzt sein sollen.",
  "match.people.lockAsFix": "Als Fix im Team markieren",
  "match.people.personGroups": "Gruppen",
  "match.people.pinGroups": "Pingruppen",
  "match.people.sampleNotice": "Der Kandidatenpool enthält die ersten {count} von {total} passenden Personen aus dem letzten Massen-Hinzufügen.",
  "match.people.sampleNoticeCapped": "Der Kandidatenpool enthält die ersten {count} passenden Personen; es gab mehr Treffer, als auf einmal hinzugefügt werden konnten.",
  "match.people.savedSetsPlaceholder": "Gruppen & Pins …",
  "match.people.searchPlaceholder": "Name, Jobtitel …",
  "match.people.selectedCandidates": "Ausgewählte Kandidaten",
  "match.people.unlock": "Sperrung aufheben",
  "match.placeholderCount": "Anzahl",
  "match.preSolve.assessTeam": "Team bewerten",
  "match.preSolve.assessing": "Bewerte Team…",
  "match.preSolve.rankCandidates": "Kandidaten ranken",
  "match.preSolve.ranking": "Ranke…",
  "match.preSolve.candidatesLoaded": "Kandidaten geladen",
  "match.preSolve.conditionsComplete": "Kriterien vollständig",
  "match.preSolve.conditionsIncompleteHint": "{n, plural, one {# Kriterium ohne Auswahl (z. B. Branche wählen) – ausfüllen oder entfernen} other {# Kriterien ohne Auswahl – ausfüllen oder entfernen}}",
  "match.preSolve.eyebrow": "Bereit zum Solven",
  "match.preSolve.eyebrowAssess": "Bereit zur Bewertung",
  "match.preSolve.eyebrowRank": "Bereit zum Ranking",
  "match.preSolve.headingAssess": "Bewerte, wie gut dein Team die Anforderungen erfüllt.",
  "match.preSolve.headingRank": "Sortiere deine Kandidaten nach Passung zum Anforderungsprofil.",
  "match.challenge.assessmentDetail": "Ausführlichkeit",
  "match.challenge.assessmentDetailBullets": "Stichpunkte",
  "match.challenge.assessmentDetailBulletsDescription": "Kompakte Punkte mit Zeilenumbrüchen.",
  "match.challenge.assessmentDetailInfo": "Ausführlichkeit erklären",
  "match.challenge.assessmentDetailLongText": "Langtext",
  "match.challenge.assessmentDetailLongTextDescription": "Ausführliche Begründung mit konkreten Belegen.",
  "match.challenge.assessmentDetailSentences": "Sätze",
  "match.challenge.assessmentDetailSentencesDescription": "Kurze, vollständige Sätze.",
  "match.challenge.assessmentOutcomeBalanced": "Ausgewogen",
  "match.challenge.assessmentOutcomeBalancedDescription": "Bewertet neutral, Stärken und Lücken gleichgewichtet.",
  "match.challenge.assessmentOutcomeFocus": "Ergebnisfokus",
  "match.challenge.assessmentOutcomeFocusInfo": "Ergebnisfokus erklären",
  "match.challenge.assessmentOutcomeOpportunities": "Stärken",
  "match.challenge.assessmentOutcomeOpportunitiesDescription": "Bewertet wohlwollend: Stärken und Einsatzmöglichkeiten zuerst.",
  "match.challenge.assessmentOutcomeRisks": "Lücken",
  "match.challenge.assessmentOutcomeRisksDescription": "Prüft den Lebenslauf gezielt auf Lücken und benennt sie zuerst.",
  "match.challenge.assessmentStrictness": "Bewertungsmaßstab",
  "match.challenge.assessmentStrictnessExtreme": "Sehr hoch",
  "match.challenge.assessmentStrictnessExtremeDescription": "Nur explizite, rollenrelevante Belege zählen; jede Lücke kostet deutlich Punkte.",
  "match.challenge.assessmentStrictnessInfo": "Bewertungsmaßstab erklären",
  "match.challenge.assessmentStrictnessNormal": "Normal",
  "match.challenge.assessmentStrictnessNormalDescription": "Verwendet die normale Bewertungskalibrierung.",
  "match.challenge.assessmentStrictnessStrict": "Hoch",
  "match.challenge.assessmentStrictnessStrictDescription": "Unklare oder nur angedeutete Erfahrung senkt den Score moderat.",
  "match.challenge.hrPromptLabel": "Bewertungsstil",
  "match.challenge.requirementLeniency": "Anforderungsprüfung",
  "match.challenge.requirementLeniencyInfo": "Anforderungsprüfung erklären",
  "match.challenge.requirementLeniencyLenient": "Kulant",
  "match.challenge.requirementLeniencyLenientDescription": "Die geforderte Stufe ist ein Richtwert: vorhandenes Fachwissen genügt.",
  "match.challenge.requirementLeniencyMustStrict": "Kulant bei Kann",
  "match.challenge.requirementLeniencyMustStrictDescription": "Bei Muss-Kriterien muss die Stufe erreicht sein, bei Kann genügt Vorhandensein.",
  "match.challenge.requirementLeniencyStrict": "Beides streng",
  "match.challenge.requirementLeniencyStrictDescription": "Die geforderte Stufe muss bei Muss und Kann erreicht sein.",
  "match.preSolve.fulfillFirst": "Erfülle zuerst die Anforderungen oben.",
  "match.preSolve.fullyLockedHint": "Alle {teamSize} Plätze sind durch fixierte Mitglieder belegt. Der Solver bewertet dieses Team nur, er optimiert es nicht.",
  "match.preSolve.lockedExceedsHeading": "Es sind mehr Personen fixiert als Plätze vorhanden.",
  "match.preSolve.lockedExceedsBody": "{locked} Personen sind fixiert, aber das Team hat {teamSize} Plätze. Entsperre einige Mitglieder oder erhöhe die Team-Größe, bevor du solvest.",
  "match.preSolve.heading": "Aus deinem Kandidatenpool ein optimales Team komponieren.",
  "match.preSolve.intro": "Der Solver verteilt deine Kandidaten auf {teamSize} Plätze und optimiert auf dein Anforderungsprofil. Du kannst die Berechnung beliebig oft wiederholen.",
  "match.preSolve.noSizeYet": "noch keine Größe gewählt",
  "match.preSolve.personsCount": "{n} Personen",
  "match.preSolve.poolOnly": "{n} im Pool",
  "match.preSolve.poolWithLocked": "{n} im Pool · {locked} fix",
  "match.preSolve.solverRunning": "Solver läuft…",
  "match.preSolve.startSolver": "Solver starten",
  "match.preSolve.teamSizePlaceholder": "n",
  "match.preSolve.teamSizeSet": "Team-Größe gesetzt",
  "match.profilesLoadError": "Profile laden: {message}",
  "match.publishToShare": "Als Projekt in Share veröffentlichen",
  "match.readOnlyBanner": "Du kannst dieses Match nur ansehen. Bitte einen Admin oder Eigentümer:in um Schreibrechte.",
  "match.renameLabel": "Match umbenennen",
  "match.recruiting.addBranche": "Branche",
  "match.recruiting.addCertificate": "Zertifikat",
  "match.recruiting.addEducation": "Ausbildung",
  "match.recruiting.addSkillHere": "Fachwissen hier hinzufügen",
  "match.recruiting.branchePlaceholder": "Branche wählen",
  "match.recruiting.certificatePlaceholder": "z. B. AWS Solutions Architect",
  "match.recruiting.certificateTitle": "Benötigte Zertifikate",
  "match.recruiting.educationPlaceholder": "z. B. Master Informatik oder kaufmännische Ausbildung",
  "match.recruiting.educationDegreePlaceholder": "Abschluss auswählen",
  "match.recruiting.educationDegreeLabel": "Benötigter Abschluss",
  "match.recruiting.educationLevelInfo.aria": "AI-Auswertung des Abschlusses erklären",
  "match.recruiting.educationLevelInfo.title": "Auswertung des Abschlusses",
  "match.recruiting.educationLevelInfo.body": "Ohne AI wird der ausgewählte Katalogeintrag direkt verglichen. Mit aktivierter AI erhält das Modell den Hinweis, zusätzlich gleichwertige oder eindeutig höherwertige formale Abschlüsse zu berücksichtigen.",
  "match.recruiting.educationTitle": "Benötigte Ausbildung",
  "match.recruiting.experienceTitle": "Benötigte Berufserfahrung",
  "match.recruiting.expertiseTitle": "Benötigtes Fachwissen (mind.)",
  "match.recruiting.kann.tooltip": "Kann-Kriterium: zählt in den Passungs-Score. Klicken für Muss.",
  "match.recruiting.minYears": "mind.",
  "match.recruiting.must.tooltip": "Muss-Kriterium: wer es nicht erfüllt, ist unqualifiziert. Klicken für Kann.",
  "match.recruiting.skillPlaceholder": "z. B. Wundmanagement",
  "match.recruiting.unrated": "Vorhanden",
  "match.recruiting.years": "Jahre",
  "match.recruiting.yearsUnit": "Jahre",
  "match.removeAll": "Alle entfernen",
  "match.requirements.aiMode.looseTooltip": "AI bewertet Freitext locker. Klicken für strikten Modus.",
  "match.requirements.aiMode.off": "AI aus",
  "match.requirements.aiMode.on": "AI an",
  "match.requirements.aiMode.strictTooltip": "Strikte Bewertung. Klicken für AI-Interpretation.",
  "match.requirements.aria.cefrLevel": "Niveau",
  "match.requirements.aria.composition": "Composition",
  "match.requirements.aria.operator": "Operator",
  "match.requirements.cefr.A1": "A1 – Anfänger",
  "match.requirements.cefr.A2": "A2 – Grundlagen",
  "match.requirements.cefr.B1": "B1 – Mittelstufe",
  "match.requirements.cefr.B2": "B2 – Selbstständig",
  "match.requirements.cefr.C1": "C1 – Fortgeschritten",
  "match.requirements.cefr.C2": "C2 – Verhandlungssicher",
  "match.requirements.cefr.NATIVE": "Muttersprache",
  "match.requirements.condition.annualSalary": "Jahresgehalt",
  "match.requirements.otherUnchanged": "{count, plural, one {# weitere Anforderung bleibt} other {# weitere Anforderungen bleiben}} unverändert erhalten.",
  "match.requirements.personDetails": "Personen-Details",
  "match.result.adjustRequirements": "Anforderungen anpassen",
  "match.result.adjustTeamSize": "Team-Größe",
  "match.result.age": "Age",
  "match.result.agentBudgetRole": "Hält Aufwand und Kosten im Blick",
  "match.result.agentCastingRole": "Findet ergänzende Crew aus dem Pool",
  "match.result.agentScheduleRole": "Plant Termine, Sprints, Übergaben",
  "match.result.agentsComingSoon": "Bald verfügbar",
  "match.result.agentsIntro": "Agentic-AI Assistenten, die das Team im Hintergrund begleiten – von der Terminplanung bis zur Aufwandsverfolgung. Noch nicht aktiv, in Vorbereitung.",
  "match.result.agentsTitle": "Agents",
  "match.result.backToSelection": "← Schließen",
  "match.result.candidatesMeta": "{count, plural, one {# Kandidat} other {# Kandidaten}}",
  "match.result.condition.age": "Alter",
  "match.result.condition.annualSalary": "Gehalt",
  "match.result.condition.certificate": "Zertifikat",
  "match.result.condition.children": "Kinder",
  "match.result.condition.citizenship": "Staatsangehörigkeit",
  "match.result.condition.city": "Wohnort",
  "match.requirements.cityRadius": "Umkreis in Kilometern",
  "match.requirements.cityRadiusDial": "Umkreis wählen, von der Mitte nach außen ziehen",
  "match.requirements.cityRadiusHint": "Ziehen bis 100 km, größere Werte oben eintragen",
  "match.result.condition.country": "Land",
  "match.result.condition.department": "Abteilung",
  "match.result.condition.driversLicense": "Führerschein",
  "match.result.condition.education": "Ausbildung",
  "match.result.condition.exact": "{label}: {value}",
  "match.result.condition.exactNot": "{label}: nicht {value}",
  "match.result.condition.experience": "Berufserfahrung",
  "match.result.condition.expertise": "Fachwissen",
  "match.result.condition.gender": "Geschlecht",
  "match.result.condition.industry": "Branche",
  "match.result.condition.language": "Sprache",
  "match.result.condition.location": "Arbeitsstandort",
  "match.result.condition.maritalStatus": "Familienstand",
  "match.result.condition.nationality": "Nationalität",
  "match.result.condition.present": "{label}: Vorhanden",
  "match.result.condition.presentActual": "Vorhanden",
  "match.result.condition.threshold": "{label}: {word} {value}",
  "match.result.condition.thresholdExact": "genau",
  "match.result.condition.thresholdMax": "max.",
  "match.result.condition.thresholdMin": "mind.",
  "match.result.condition.thresholdNot": "nicht",
  "match.result.coverage": "Coverage",
  "match.result.dataHint": "Datenhinweis",
  "match.result.deleteAriaLabel": "Ergebnis „{name}“ löschen",
  "match.result.deleteConfirmBody": "Das gespeicherte Ergebnis <b>„{name}“</b> wird endgültig entfernt. Diese Aktion kann nicht rückgängig gemacht werden.",
  "match.result.deleteConfirmTitle": "Ergebnis löschen?",
  "match.result.deleteFinal": "Endgültig löschen",
  "match.result.deleteTitle": "Löschen",
  "match.result.deleting": "Lösche…",
  "match.result.dept": "Dept",
  "match.result.detailsHeader": "Details",
  "match.result.discardUnsavedConfirm.confirm": "Verwerfen",
  "match.result.discardUnsavedConfirm.message": "Das berechnete Ergebnis wurde noch nicht gespeichert und geht beim Zurückgehen verloren.",
  "match.result.discardUnsavedConfirm.title": "Ungespeichertes Ergebnis verwerfen?",
  "match.result.dismissDataHint": "Datenhinweis schließen",
  "match.result.elementRequirementsFulfilled": "Element Requirements · {count} erfüllt",
  "match.result.emptyHint": "Keine Daten im Ergebnis vorhanden.",
  "match.result.facts.mustViolated": "{count, plural, one {# Muss-Kriterium ist nicht erfüllt} other {# Muss-Kriterien sind nicht erfüllt}}.",
  "match.result.factsAndSkills": "Facts & Skills",
  "match.result.gender": "Gender",
  "match.result.groupBasics": "Basics",
  "match.result.groupExpertise": "Expertise",
  "match.result.groupTotal": "Total",
  "match.result.hintNoConditionsBody": "Dieses Match hat keine Anforderungen im Challenge-Schritt – daher bleibt Coverage 0 % und Facts & Skills leer. Definiere Bedingungen, um zu sehen, wie das Team sie erfüllt.",
  "match.result.hintNoConditionsLabel": "Keine Anforderungen definiert",
  "match.result.hintNoDemographicsBody": "Die Personen haben keine Geburtsdaten und kein Geschlecht hinterlegt. Demografie-Chips und Ø Alter bleiben darum ausgeblendet.",
  "match.result.hintNoDemographicsLabel": "Keine demografischen Daten",
  "match.result.hintNoPowersBody": "Die ausgewählten Personen haben ihre Powers nicht selbst eingeschätzt. Powers-Score und Element-Heatmap zeigen darum Nullwerte. Sobald sie Powers im Profil pflegen, füllt sich das Ergebnis automatisch.",
  "match.result.hintNoPowersLabel": "Keine Power-Self-Assessments",
  "match.result.historyLoading": "Gespeicherte Ergebnisse laden …",
  "match.result.historyTitle": "Gespeicherte Ergebnisse",
  "match.result.infeasibleBody": "Die Bedingungen widersprechen sich oder dein Kandidatenpool ist zu klein. Lockere einzelne Anforderungen, entferne harte Filter oder vergrößere den Pool und starte den Solver erneut.",
  "match.result.infeasibleLockedTitle": "Fixierte Kandidaten blockieren die Berechnung",
  "match.result.infeasibleLockedHeading": "Die fixierten Mitglieder allein ergeben kein gültiges Team.",
  "match.result.infeasibleLockedBody": "Es sind zu viele Personen fixiert, oder die fixierten Mitglieder verletzen bereits eine Anforderung. Entsperre einige Mitglieder oder erhöhe die Team-Größe und starte den Solver erneut.",
  "match.result.infeasibleRelaxTitle": "Lockere eine dieser Muss-Anforderungen",
  "match.result.infeasibleShortfall": "fehlt {shortfall}",
  "match.result.unlockMembers": "Mitglieder entsperren",
  "match.result.infeasibleHeading": "Der Solver konnte kein Team zusammenstellen, das alle Anforderungen erfüllt.",
  "match.result.infeasibleTitle": "Keine Lösung gefunden",
  "match.result.insights.aiCriterionCandidates": "{count} Kandidaten",
  "match.result.insights.aiMetShort": "davon {count} per KI erkannt",
  "match.result.insights.aiReasons": "{count} KI Begründungen",
  "match.result.insights.aiShare": "AI-Anteil",
  "match.result.insights.bottlenecks": "Top 3 Bottlenecks",
  "match.result.insights.radius": "Umkreis",
  "match.result.insights.radiusTitle": "{radius} km um {city}",
  "match.result.insights.radiusMapAria": "Umkreis-Karte: Kandidaten nach Distanz zu {city}",
  "match.result.insights.radiusInside": "{count} innerhalb",
  "match.result.insights.radiusOutside": "{count} außerhalb",
  "match.result.insights.radiusMissing": "{count} ohne Distanz",
  "match.result.insights.radiusHint": "Winkel schematisch, Distanzskala gestaucht",
  "match.result.insights.failCount": "{failed}/{total} ausgeschlossen",
  "match.result.insights.fulfilledShort": "{met}/{total} erfüllt",
  "match.result.insights.gapShort": "{value} Lücke",
  "match.result.insights.hardestMust": "K.O.-Kriterium",
  "match.result.insights.header": "Match-Analyse",
  "match.result.insights.koPassing": "erfüllen",
  "match.result.insights.noAiReasons": "Keine KI Begründungen.",
  "match.result.insights.noBottleneck": "Keine auffälligen Engpässe.",
  "match.result.insights.noExclusion": "Kein Muss-Kriterium schließt aus.",
  "match.result.insights.noFulfilled": "Kein Kriterium wird erfüllt.",
  "match.result.insights.averageShort": "Ø {value}",
  "match.result.insights.medianShort": "Median {value}",
  "match.result.insights.requiredShort": "Soll {value}",
  "match.result.insights.sdShort": "SD {value}",
  "match.result.insights.personDetailsInfoAria": "Hinweis zu Personen-Details anzeigen",
  "match.result.insights.personDetailsInfoBody": "Personen-Details werden nicht als Analyse-Verteilung dargestellt. Sie bleiben im Kandidaten-Detail sichtbar.",
  "match.result.insights.personDetailsInfoTitle": "Personen-Details",
  "match.result.insights.reasonsShort": "{count} Reasons",
  "match.result.insights.recommendAi": "{count} KI Begründungen bei {candidates} Kandidaten manuell prüfen.",
  "match.result.insights.recommendBottleneck": "{criterion} ist der stärkste Engpass; Ø Erfüllung {average}.",
  "match.result.insights.recommendData": "Profilwerte für {criterion} nachpflegen; {missing}/{total} Nachweise fehlen.",
  "match.result.insights.recommendMust": "{criterion} prüfen oder lockern; dieses Muss-Kriterium schließt {failed}/{total} Kandidaten aus.",
  "match.result.insights.recommendNone": "Keine unmittelbare Anpassung nötig.",
  "match.result.insights.recommendation": "Empfehlung",
  "match.result.insights.textDistribution": "häufigster Wert {value} ({count}/{present}) · {distinct} Varianten",
  "match.result.insights.topFulfilled": "Top 3 erfüllte Kriterien",
  "match.result.loadFailed": "Ergebnis konnte nicht geladen werden (id {id}). Browser-Konsole prüfen.",
  "match.result.maxRawHint": "/100 (max raw)",
  "match.result.noRequirementsEmpty": "Diese Match-Definition hat keine Anforderungen – Facts & Skills bleibt leer.",
  "match.result.openFlag": "offen",
  "match.result.openProfileTitle": "{name} – Profil öffnen",
  "match.result.powerClusters": "Power Clusters",
  "match.result.powersScore": "Powers Score",
  "match.result.powersTop": "Powers · Top",
  "match.result.ranking.aiChip": "KI Begründung",
  "match.result.ranking.aiChipTitle": "Begründung aus der KI-Auswertung",
  "match.result.ranking.assessment.fazit": "Fazit",
  "match.result.ranking.assessment.negative": "Negativ",
  "match.result.ranking.assessment.positive": "Positiv",
  "match.result.ranking.assessment.title": "Smycles Einschätzung",
  "match.result.ranking.collapseAll": "Alle einklappen",
  "match.result.ranking.expandAll": "Alle aufklappen",
  "match.result.ranking.kindBasics": "Personen-Details",
  "match.result.ranking.kindCertificate": "Zertifikat",
  "match.result.ranking.kindEducation": "Ausbildung",
  "match.result.ranking.kindExperience": "Berufserfahrung",
  "match.result.ranking.kindExpertise": "Fachwissen",
  "match.result.ranking.kindLanguage": "Sprache",
  "match.result.ranking.kindPowers": "Powers",
  "match.result.ranking.lenientMatchHint": "Erfüllt per kulanter Anforderungsprüfung: Fachwissen vorhanden, geforderte Stufe nicht belegt.",
  "match.result.ranking.dotFulfilled": "Erfüllt",
  "match.result.ranking.dotPartial": "Teilweise erfüllt",
  "match.result.ranking.dotUnfulfilled": "Nicht erfüllt",
  "match.result.ranking.emptyHintLabel": "Hinweis",
  "match.result.ranking.emptyFilteredTab": "Keine {requirement}-Kriterien unter „{tab}“.",
  "match.result.ranking.emptyShowAll": "Alle Kriterien zeigen",
  "match.result.ranking.emptySwitchTab": "Zu „{tab}“ wechseln",
  "match.result.ranking.emptyTab": "Unter „{tab}“ gibt es keine Kriterien.",
  "match.result.ranking.tabNameFulfilled": "Erfüllt",
  "match.result.ranking.tabNameLenient": "Kulant erfüllt",
  "match.result.ranking.tabNameUnfulfilled": "Nicht erfüllt",
  "match.result.ranking.lenientTab": "Kulant erfüllt ({count})",
  "match.result.ranking.must": "Muss",
  "match.result.ranking.kpiSmycles": "Smycles Score",
  "match.result.ranking.kpiPowerFit": "Power-Fit",
  "match.result.ranking.mustTitle": "Muss-Kriterien",
  "match.result.ranking.mustNone": "Keine Muss-Kriterien",
  "match.result.ranking.mustInfoTitle": "Muss-Kriterien",
  "match.result.ranking.mustInfoAria": "Muss-Kriterien anzeigen",
  "match.result.ranking.mustFormula": "Muss-Kriterien sind harte Gates: jedes muss erfüllt sein.",
  "match.result.ranking.mustMetSummary": "Erfüllt: {met}/{total}",
  "match.result.ranking.criterionMet": "erfüllt",
  "match.result.ranking.criterionFailed": "nicht erfüllt",
  "match.result.ranking.kannTitle": "Kann-Kriterien",
  "match.result.ranking.scoreCriteriaValue": "Kann-Kriterien: {criteria}",
  "match.result.ranking.filterAll": "Alle",
  "match.result.ranking.filterMust": "Muss",
  "match.result.ranking.filterKann": "Kann",
  "match.result.ranking.sortSmycles": "Smycles",
  "match.result.ranking.powerFitSoon": "Power-Fit-Ansicht kommt noch.",
  "match.result.ranking.noAssessment": "Keine Smycles-Einschätzung vorhanden.",
  "match.result.ranking.noCriteria": "Keine Kriterien definiert",
  "match.result.ranking.noMustHint": "Hier landen Bewerber, die ein Muss-Kriterium (Schloss) verfehlen oder deren Score unter der C-Schwelle liegt.",
  "match.result.ranking.openProfile": "Profil öffnen",
  "match.result.ranking.optional": "Kann",
  "match.result.ranking.powerFitTooltip": "Power-Fit: gewichtetes Mittel der eigenen Power-Werte dieser Person.",
  "match.result.ranking.scoreFormula": "Score = Durchschnitt der Kann-Kriterien.",
  "match.result.ranking.scoreInfoAria": "Rechenweg anzeigen",
  "match.result.ranking.scoreInfoTitle": "Rechenweg",
  "match.result.ranking.scoreMustGate": "Muss-Kriterien bleiben zusätzlich ein hartes Gate.",
  "match.result.ranking.sortBy": "Sortieren nach",
  "match.result.ranking.sortPower": "Power-Fit",
  "match.result.ranking.sortRequirements": "Anforderungs-Fit",
  "match.result.ranking.thresholdAAria": "Schwelle zwischen A und B",
  "match.result.ranking.thresholdBAria": "Schwelle zwischen B und C",
  "match.result.ranking.thresholdCAria": "Untergrenze für C",
  "match.result.ranking.thresholdsLabel": "Schwellen",
  "match.result.ranking.unqualified": "Kriterien nicht erfüllt",
  "match.result.ranking.yearsValue": "{years, plural, one {# Jahr} other {# Jahre}}",
  "match.result.rankingHeader": "Ranking",
  "match.result.reviewSubtitle": "Optimiert auf dein Anforderungsprofil – transparent, erklärbar, exportierbar.",
  "match.result.saveResult": "Ergebnis speichern",
  "match.result.savedResultLabel": "Gespeichertes Ergebnis · {name}",
  "match.result.savedSubtitle": "Du siehst ein gespeichertes Ergebnis dieses Matches.",
  "match.result.solverErrorBody": "Genesis hat die Berechnung abgelehnt. Das passiert aktuell, wenn das Match-Design Felder enthält, die das Backend (noch) nicht kennt. Probier es nach kurzer Zeit erneut oder melde den Fall mit der unten stehenden Korrelations-ID.",
  "match.result.solverErrorHeading": "Das Backend hat den Solver nicht beendet.",
  "match.result.solverErrorTitle": "Solver-Fehler",
  "match.result.solverNotRun": "Solver noch nicht gelaufen.",
  "match.result.solverRunning": "Solver läuft …",
  "match.result.teamHeader": "Team · {count, plural, one {# Person} other {# Personen}}",
  "match.result.teamPowers": "Team Powers",
  "match.result.teamSizeMeta": "Teamgröße {count}",
  "match.result.unnamed": "ohne Namen",
  "match.save.eyebrow": "Ergebnis speichern",
  "match.save.failed": "Speichern fehlgeschlagen",
  "match.save.modeAssess": "Bewerten",
  "match.save.modeOptimize": "Optimieren",
  "match.save.modeRank": "Rangliste",
  "match.save.note": "Notiz",
  "match.save.notePlaceholder": "Optional – Kontext, Annahmen, nächste Schritte …",
  "match.save.off": "aus",
  "match.save.on": "ein",
  "match.save.previewAndNote": "Vorschau & Notiz",
  "match.save.resultName": "Ergebnis-Name",
  "match.save.retry": "Erneut versuchen",
  "match.save.saved": "Gespeichert",
  "match.save.saving": "Speichert…",
  "match.save.statAgenticAi": "Agentic AI",
  "match.save.statConditions": "Bedingungen",
  "match.save.statMode": "Modus",
  "match.save.statPool": "Pool",
  "match.save.statTarget": "Soll",
  "match.save.teamCount": "Team · {count, plural, one {# Person} other {# Personen}}",
  "match.settingsEyebrow": "Match-Einstellungen",
  "match.shortDescPlaceholder": "In einem Satz: was, wofür?",
  "match.smyclesAi": "Anforderungs-Prompt",
  "match.step.challenge": "Challenge",
  "match.step.people": "Teamplayer",
  "match.step.peopleRank": "Kandidaten",
  "match.step.result": "Result",
  "match.teamPowers": "Team Powers",
  "match.teamProfile": "Teamprofil",
  "match.teamProfileBalanced": "Ausgewogen",
  "match.teamProfileCustom": "Individuell",
  "match.teamProfileModifiedSuffix": " · geändert",
  "match.teamReqsSection": "Teamanforderungen",
  "match.teamSizeSection": "Größe des Teams",
  "match.titlePlaceholder": "z. B. Set-Crew BTL · Q2 2026",
  "match.tour.create.desc": "Dieser Button erstellt ein neues Match und öffnet den Editor. Dort beschreibst du, was du brauchst, und der Solver schlägt das Team vor.",
  "match.tour.create.title": "Neues Match erstellen",
  "match.tour.label": "Match",
  "match.tour.list.desc": "Alle deine Matches wohnen hier. Klicke eine Karte, um sie wieder zu öffnen und weiterzumachen.{names}",
  "match.tour.list.names": "Aktuell: {list}.",
  "match.tour.list.title": "Deine Matches",
  "match.tour.summary": "Das ist der Match-Bereich: Hier stellst du Teams aus Menschen und Anforderungen zusammen. Du hast bisher {count} Matches.",
  "match.unnamedMatch": "Unbenanntes Match",
  "match.unnamedProject": "Unbenanntes Projekt",
  "match.weightLevel.high": "Hoch",
  "match.weightLevel.low": "Niedrig",
  "match.weightLevel.medium": "Mittel",
  "match.weightLevel.none": "Nicht relevant",
  "match.workflow.challengeSubtitle": "Beschreibe oben dein Projekt – die KI leitet daraus Team-Größe, Anforderungen und Powers ab. Darunter kontrollierst du das Ergebnis und justierst kleine Stellschrauben.",
  "match.workflow.challengeSubtitleNoTeamSize": "Beschreibe oben dein Projekt – die KI leitet daraus Anforderungen und Powers ab. Darunter kontrollierst du das Ergebnis und justierst kleine Stellschrauben.",
  "match.workflow.challengeSubtitleRank": "Beschreibe oben die Rolle bzw. offene Stelle – die KI leitet daraus die Anforderungen ab, die ein:e Kandidat:in erfüllen soll. Darunter kontrollierst du das Ergebnis und justierst kleine Stellschrauben.",
  "match.workflow.deleteConfirm.confirm": "Löschen",
  "match.workflow.deleteConfirm.message": "Das Match wird endgültig aus genesis entfernt. Diese Aktion kann nicht rückgängig gemacht werden.",
  "match.workflow.deleteConfirm.title": "Match löschen?",
  "match.workflow.deleteTitle": "Match löschen",
  "match.workflow.modeAssess": "Bewerten",
  "match.workflow.modeIndicatorTitle": "Modus (bei Erstellung festgelegt)",
  "match.workflow.modeOptimize": "Optimieren",
  "match.workflow.modeRank": "Rangliste",
  "match.workflow.nextTo": "Weiter zu {label}",
  "match.workflow.prevTo": "Zurück zu {label}",
  "match.workflow.settingsTitle": "Match-Einstellungen",
  "matchDetail.tour.label": "Match Detail",
  "matchDetail.tour.summary": "Du bearbeitest das Match „{name}“, gerade im Workflow-Schritt „{step}“ mit {candidates} Kandidaten und {results} gespeicherten Ergebnissen. Arbeite die Schritte von den Anforderungen bis zum fertigen Team durch.",
  "matchDetail.tour.untitled": "unbenanntes Match",
  "model.connected": "Verbunden",
  "model.keyAriaLabel": "{provider} API-Schlüssel",
  "model.providerSub": "Der zugrunde liegende Modell-Stack. Modellarten werden auf die konkreten Modelle dieses Anbieters aufgelöst.",
  "model.providerTitle": "Anbieter",
  "model.resolvedModels": "Aufgelöste Modelle",
  "model.saveError": "Modelleinstellungen konnten nicht gespeichert werden – bitte erneut versuchen.",
  "model.saveError.forbidden": "Für Änderungen an der Modellkonfiguration sind Administratorrechte erforderlich.",
  "model.saveError.notConfigured": "Die Modellkonfiguration ist auf diesem Server nicht aktiviert.",
  "model.saveError.unauthorized": "Ihre Sitzung ist abgelaufen – bitte erneut anmelden.",
  "model.saveError.upstream": "Der Konfigurationsspeicher ist nicht erreichbar – bitte erneut versuchen.",
  "model.saved": "Einstellungen gespeichert – die Änderung kann bis zu 60 Sekunden dauern.",
  "nav.community": "Community",
  "nav.logout": "Abmelden",
  "nav.mainLandmark": "Hauptnavigation",
  "nav.map": "Map",
  "nav.openMenu": "Menü öffnen",
  "nav.pins": "Pins",
  "nav.play": "Play",
  "nav.profile": "Profil",
  "nav.service": "Dokumente",
  "nav.settings": "Einstellungen",
  "nav.watch": "Watch",
  "personFilter.addFilter": "+ Filter hinzufügen",
  "personFilter.allFilters": "Alle Filter",
  "personFilter.frequent": "Häufig",
  "personFilter.heading": "Teamplayer-Filter{count, plural, =0 {} other { · # aktiv}}",
  "pinboard.tour.controls.desc": "Suche Pins nach Namen, ändere die Sortierung oder filtere auf Pins, die noch in keiner Gruppe sind.",
  "pinboard.tour.controls.title": "Suchen & Sortieren",
  "pinboard.tour.grid.desc": "{count} {typeLabel} in der aktuellen Ansicht. Klicke eine Karte, um sie zu öffnen, nutze „+ Hinzufügen“ für Gruppen oder das Papierkorb-Symbol zum Entpinnen.",
  "pinboard.tour.grid.title": "Deine gepinnten Einträge",
  "pinboard.tour.label": "Save Pins",
  "pinboard.tour.sidebar.desc": "Wechsle zwischen deinen gepinnten Personen ({people}), Beiträgen ({posts}) und Projekten ({projects}) und wähle darunter eine Pin-Gruppe. Ziehe eine Karte auf eine Gruppe, um sie dort abzulegen.",
  "pinboard.tour.sidebar.title": "Typen & Gruppen",
  "pinboard.tour.summary": "Das ist deine Pinnwand mit allem, was du gespeichert hast: {people} Personen, {posts} Beiträge und {projects} Projekte.",
  "power.name.Abs": "Abstraktion",
  "power.name.Ada": "Adaption",
  "power.name.Agg": "Aggression",
  "power.name.Aut": "Autonomie",
  "power.name.Awe": "Selbstwahrnehmung",
  "power.name.Cha": "Charisma",
  "power.name.Con": "Konzentration",
  "power.name.Cop": "Toleranz",
  "power.name.Cou": "Mut",
  "power.name.Cur": "Neugierde",
  "power.name.Dil": "Sorgfalt",
  "power.name.Emp": "Empathie",
  "power.name.Exp": "Expression",
  "power.name.Fai": "Glaube",
  "power.name.Fid": "Treue",
  "power.name.Fns": "Fairness",
  "power.name.Hum": "Humor",
  "power.name.Ima": "Imagination",
  "power.name.Imp": "Improvisation",
  "power.name.Ins": "Inspiration",
  "power.name.Int": "Intention",
  "power.name.Inu": "Intuition",
  "power.name.Joy": "Optimismus",
  "power.name.Lan": "Sprache",
  "power.name.Min": "Achtsamkeit",
  "power.name.Pas": "Passion",
  "power.name.Per": "Wahrnehmung",
  "power.name.Psc": "Ausdauer",
  "power.name.Rpy": "Verantwortung",
  "power.name.Str": "Strategie",
  "power.tag.Co": "Kommunikationsfähigkeit",
  "power.tag.Fo": "Zukunftsorientierung",
  "power.tag.In": "Erfindungsstärke",
  "power.tag.Re": "Belastbarkeit",
  "power.tag.Ro": "Ergebnisorientierung",
  "power.tag.Ts": "Teamfähigkeit",
  "profile.fields.addCountry": "+ Land",
  "profile.fields.avatarAlt": "Avatar",
  "profile.fields.changePhoto": "Foto ändern",
  "profile.fields.removePhoto": "Foto entfernen",
  "profile.page.add.certificate": "Zertifikat hinzufügen",
  "profile.page.add.education": "Ausbildung hinzufügen",
  "profile.page.add.experience": "Berufserfahrung hinzufügen",
  "profile.page.add.expertise": "Skill hinzufügen",
  "profile.page.add.language": "Sprache hinzufügen",
  "profile.page.addToCommunity": "Community",
  "profile.page.addToPins": "Pins",
  "profile.page.ageSuffix": "{age} Jahre",
  "profile.page.allLabel": "Alle:",
  "profile.page.businessCard": "Visitenkarte",
  "profile.page.businessCardRoleHint": "Übernommen aus Details › Unternehmen › Berufsbezeichnung",
  "profile.page.details": "Details",
  "profile.page.details.company": "Unternehmen",
  "profile.page.details.personal": "Persönlich",
  "profile.page.editVisibility": "Sichtbarkeiten bearbeiten",
  "profile.page.empty.certificates": "Keine Zertifikate",
  "profile.page.empty.education": "Keine Ausbildung",
  "profile.page.empty.experience": "Keine Berufserfahrung",
  "profile.page.empty.expertise": "Keine Skills",
  "profile.page.empty.languages": "Keine Sprachen",
  "profile.page.error.certificateNameRequired": "Name ist erforderlich.",
  "profile.page.error.fieldOfStudyRequired": "Fachrichtung ist erforderlich.",
  "profile.page.error.jobTitleRequired": "Stellenbezeichnung ist erforderlich.",
  "profile.page.error.languageLevelRequired": "Bitte ein Niveau für die Fremdsprache wählen.",
  "profile.page.error.nameRequired": "Vorname und Nachname sind erforderlich.",
  "profile.page.error.saveEntries": "Einträge konnten nicht gespeichert werden",
  "profile.page.error.saveEntriesFailedCount": "{count, plural, one {# Eintrag konnte nicht gespeichert werden.} other {# Einträge konnten nicht gespeichert werden.}}",
  "profile.page.error.saveFailed": "Speichern fehlgeschlagen.",
  "profile.page.error.savePerson": "Person konnte nicht gespeichert werden",
  "profile.page.error.startDateRequired": "Startdatum ist erforderlich.",
  "profile.page.familyName.placeholder": "Nachname",
  "profile.page.field.activities.label": "Hauptaufgaben",
  "profile.page.field.activities.placeholder": "z. B. Code-Reviews",
  "profile.page.field.cefr": "Niveau (CEFR)",
  "profile.page.field.certificateName.label": "Bezeichnung",
  "profile.page.field.certificateName.placeholder": "z. B. AWS Solutions Architect",
  "profile.page.field.country": "Land",
  "profile.page.field.degree.label": "Abschluss",
  "profile.page.field.degree.placeholder": "Abschluss auswählen",
  "profile.page.field.degree.search": "Abschluss suchen",
  "profile.page.field.degree.none": "Kein Abschluss ausgewählt",
  "profile.page.field.department": "Abteilung",
  "profile.page.field.employer.label": "Arbeitgeber",
  "profile.page.field.employer.placeholder": "z. B. Smycles GmbH",
  "profile.page.field.expertiseName.label": "Bezeichnung",
  "profile.page.field.expertiseName.placeholder": "z. B. Kubernetes",
  "profile.page.field.field.label": "Fachrichtung",
  "profile.page.field.field.placeholder": "z. B. Informatik",
  "profile.page.field.from": "Von",
  "profile.page.field.industry": "Branche",
  "profile.page.field.institution": "Bildungseinrichtung",
  "profile.page.field.issueDate": "Ausstellungsdatum",
  "profile.page.field.jobTitle.label": "Stellenbezeichnung",
  "profile.page.field.jobTitle.placeholder": "z. B. Softwareentwickler",
  "profile.page.field.language.label": "Sprache",
  "profile.page.field.language.placeholder": "Sprache wählen",
  "profile.page.field.level": "Stufe",
  "profile.page.field.location": "Ort",
  "profile.page.field.nativeSpeaker.label": "Muttersprache",
  "profile.page.field.nativeSpeaker.placeholder": "Muttersprache",
  "profile.page.field.to": "Bis",
  "profile.page.givenName.placeholder": "Vorname",
  "profile.page.hideVisibility": "Sichtbarkeiten ausblenden",
  "profile.page.inCommunity": "In Community",
  "profile.page.inPins": "In Pins",
  "profile.page.label.apartment": "Wohnung",
  "profile.page.label.birthday": "Geburtstag",
  "profile.page.label.childCount": "Anzahl Kinder",
  "profile.page.label.citizenship": "Staatsangehörigkeit",
  "profile.page.label.city": "Wohnort",
  "profile.page.label.contractType": "Vertragsart",
  "profile.page.label.country": "Land",
  "profile.page.label.countryState": "Bundesland / State",
  "profile.page.label.currentActivity": "Aktuelle Tätigkeit",
  "profile.page.label.currentEmployer": "Arbeitgeber",
  "profile.page.label.currentTasks": "Hauptaufgaben",
  "profile.page.label.drivingLicence": "Führerschein",
  "profile.page.label.email": "E-Mail",
  "profile.page.label.gender": "Geschlecht",
  "profile.page.label.houseNumber": "Hausnummer",
  "profile.page.label.jobDepartment": "Abteilung",
  "profile.page.label.jobLocation": "Arbeitsstandort",
  "profile.page.label.jobTitle": "Berufsbezeichnung",
  "profile.page.label.maritalStatus": "Familienstand",
  "profile.page.label.miscellaneous": "Sonstiges",
  "profile.page.label.nationality": "Nationalität",
  "profile.page.label.phone": "Telefon",
  "profile.page.label.profession": "Beruf",
  "profile.page.label.street": "Straße",
  "profile.page.label.website": "Website",
  "profile.page.label.workingTimeModel": "Arbeitszeitmodell",
  "profile.page.label.zipCode": "PLZ",
  "profile.page.loadFailed": "Profil konnte nicht geladen werden",
  "profile.page.loadFailedHint": "Bitte lade die Seite neu oder melde dich erneut an.",
  "profile.page.notFound": "Profil nicht gefunden",
  "profile.page.notFoundHint": "Dieses Profil existiert nicht oder ist nicht für dich freigegeben.",
  "profile.page.openChat": "Chat öffnen",
  "profile.page.section.certificates": "Zertifikate",
  "profile.page.section.education": "Ausbildung",
  "profile.page.section.experience": "Berufserfahrung",
  "profile.page.section.expertise": "Fachwissen",
  "profile.page.section.languages": "Sprachen",
  "profile.page.serviceMenu": "Service",
  "profile.page.startChat": "Nachricht schreiben",
  "profile.page.summary": "Summary",
  "profile.page.warning.childCountMax": "Die Anzahl der Kinder darf 20 nicht überschreiten.",
  "profile.rows.done": "Fertig",
  "profile.rows.level": "Stufe: {level}",
  "profile.rows.nativeSpeaker": "Muttersprache",
  "profile.rows.noLevel": "Kein Niveau",
  "profile.rows.today": "heute",
  "profile.sidebars.errorPrefix": "Fehler: {message}",
  "profile.sidebars.favorites": "Favoriten",
  "profile.sidebars.loading": "lädt…",
  "profile.sidebars.powerMap": "Power Map",
  "profile.sidebars.powersTitle": "Powers",
  "profile.sidebars.selfAssessment": "Selbstbewertung",
  "profile.sidebars.smartAnalysis": "Smart Analyse",
  "profile.skills.addAtLevel": "Fachwissen auf dieser Stufe hinzufügen",
  "profile.skills.unrated": "Unbewertet",
  "profile.skills.viewDiagram": "Modern",
  "profile.skills.viewList": "Klassisch",
  "profile.tour.about.desc": "Dein Zusammenfassungstext, deine persönlichen und beruflichen Details und deine {languages} Sprachen. Klicke ein Feld an, um es direkt zu bearbeiten.",
  "profile.tour.about.title": "Zusammenfassung, Details und Sprachen",
  "profile.tour.card.desc": "Klicke ein beliebiges Feld (Name, Telefon, E-Mail, Land, Stadt) und bearbeite es direkt; Änderungen werden gesammelt und über die Speicherleiste gesichert.{missing}",
  "profile.tour.card.missingHint": "Einige deiner Kontaktfelder sind noch leer.",
  "profile.tour.card.title": "Deine Visitenkarte",
  "profile.tour.cv.desc": "{experiences} Berufserfahrungen, {educations} Ausbildungen, {skills} Skills und {certificates} Zertifikate. Lege hier neue Einträge an oder klicke einen bestehenden, um ihn zu bearbeiten.",
  "profile.tour.cv.title": "Deine Lebenslauf-Einträge",
  "profile.tour.label": "Save Profil",
  "profile.tour.powers.desc": "Deine stärksten Powers auf einen Blick. Klicke eine an für ihre Detailseite, oder schätze weitere drüben in Grow ein.",
  "profile.tour.powers.title": "Deine Powers",
  "profile.tour.service.desc": "KI-Helfer und Datenservices für dein Profil: Powers und Skills ermitteln, einen Lebenslauf oder dein LinkedIn-Profil importieren, einen Lebenslauf erzeugen und deine Daten exportieren.",
  "profile.tour.service.title": "Servicemenü",
  "profile.tour.summary": "Das ist dein eigenes Profil mit {count} Lebenslauf-Einträgen. Fast jedes Feld ist direkt auf der Seite bearbeitbar.",
  "profile.tour.visibility.desc": "Dieser Schalter blendet neben jedem Feld und Eintrag einen Freigabe-Schalter ein. So bestimmst du genau, was andere von deinem Profil sehen.",
  "profile.tour.visibility.title": "Sichtbarkeit bearbeiten",
  "profileExtraction.abort": "Extraktion abbrechen",
  "profileExtraction.abortTip": "Die Extraktion läuft noch - du kannst weiter warten oder abbrechen und es mit demselben Dokument erneut versuchen. Gespeichert wurde noch nichts.",
  "profileExtraction.analysing": "Profildaten werden aus deinem Dokument extrahiert - das kann bis zu zwei Minuten dauern...",
  "profileExtraction.dropZone": "Dokument hierher ziehen oder zum Hochladen klicken",
  "profileExtraction.dropZoneHint": "Lebenslauf, LinkedIn-Export, Bewerbung … · PDF, DOCX, Bild · max. 10 MB",
  "profileExtraction.elapsed": "Verstrichene Zeit: {time}",
  "profileExtraction.fileTooLarge": "Datei ist zu groß (max. 10 MB).",
  "profileExtraction.noResult": "Das Dokument konnte nicht analysiert werden.",
  "profileExtraction.timeout": "Die Analyse dauert zu lange. Bitte versuche es erneut.",
  "profileExtraction.nothingNew": "Nichts Neues gefunden – dein Profil deckt dieses Dokument bereits ab.",
  "profileExtraction.ready": "Wir haben Details zum Überprüfen in {file} gefunden.",
  "profileExtraction.review": "Änderungen prüfen",
  "profileExtraction.title": "CV Extractor",
  "profileExtraction.unsupportedType": "Nicht unterstützter Dateityp.",
  "referenceData.add": "Hinzufügen",
  "referenceData.cancel": "Abbrechen",
  "referenceData.confirmDelete.message": "Der Eintrag wird endgültig entfernt und steht in Profilen und Match-Anforderungen nicht mehr zur Auswahl.",
  "referenceData.confirmDelete.title": "„{label}“ löschen?",
  "referenceData.contractType.add": "Neue Vertragsart",
  "referenceData.contractType.empty": "Noch keine Vertragsarten angelegt.",
  "referenceData.contractType.sub": "Verwaltete Liste der Vertragsarten.",
  "referenceData.contractType.title": "Vertragsarten",
  "referenceData.degree.add": "Neuer Abschluss",
  "referenceData.degree.empty": "Noch keine Abschlüsse angelegt.",
  "referenceData.degree.sub": "Verwaltete Liste der Abschlüsse für Ausbildungseinträge.",
  "referenceData.degree.title": "Abschlüsse",
  "referenceData.delete": "Löschen",
  "referenceData.duplicate": "Diesen Eintrag gibt es bereits.",
  "referenceData.edit": "Bearbeiten",
  "referenceData.gender.add": "Neues Geschlecht",
  "referenceData.gender.empty": "Keine Einträge.",
  "referenceData.gender.sub": "Verwaltete Liste der Geschlechter.",
  "referenceData.gender.title": "Geschlechter",
  "referenceData.industry.add": "Neue Branche",
  "referenceData.industry.empty": "Noch keine Branchen angelegt.",
  "referenceData.industry.sub": "Verwaltete Liste der Branchen für Profile und Match-Anforderungen.",
  "referenceData.industry.title": "Branchen",
  "referenceData.jobDepartment.add": "Neue Abteilung",
  "referenceData.jobDepartment.empty": "Noch keine Abteilungen angelegt.",
  "referenceData.jobDepartment.sub": "Verwaltete Liste der Abteilungen für Profile und Match-Anforderungen.",
  "referenceData.jobDepartment.title": "Abteilungen",
  "referenceData.jobLocation.add": "Neuer Arbeitsstandort",
  "referenceData.jobLocation.empty": "Noch keine Arbeitsstandorte angelegt.",
  "referenceData.jobLocation.sub": "Verwaltete Liste der Arbeitsstandorte für Profile und Match-Anforderungen.",
  "referenceData.jobLocation.title": "Arbeitsstandorte",
  "referenceData.loading": "Lädt…",
  "referenceData.maritalStatus.add": "Neuer Familienstand",
  "referenceData.maritalStatus.empty": "Keine Einträge.",
  "referenceData.maritalStatus.sub": "Verwaltete Liste der Familienstände.",
  "referenceData.maritalStatus.title": "Familienstände",
  "referenceData.save": "Speichern",
  "referenceData.workingTimeModel.add": "Neues Arbeitszeitmodell",
  "referenceData.workingTimeModel.empty": "Noch keine Arbeitszeitmodelle angelegt.",
  "referenceData.workingTimeModel.sub": "Verwaltete Liste der Arbeitszeitmodelle.",
  "referenceData.workingTimeModel.title": "Arbeitszeitmodelle",
  "save.addToCollection.adding": "Fügt hinzu…",
  "save.addToCollection.doneInGroup": "<nm>{name}</nm> wurde zu <b>{target}</b> in <b>{group}</b> hinzugefügt.",
  "save.addToCollection.doneNoGroup": "<nm>{name}</nm> wurde zu <b>{target}</b> (ohne Gruppe) hinzugefügt.",
  "save.addToCollection.error": "Konnte nicht hinzufügen. Bitte erneut versuchen.",
  "save.addToCollection.goToTarget": "Zu {target}",
  "save.addToCollection.groupLabel": "Gruppe",
  "save.addToCollection.noGroupPlaceholder": "Ohne Gruppe",
  "save.addToCollection.personFallback": "Person",
  "save.addToCollection.title": "{name} zu {target} hinzufügen",
  "save.careerGraph.active": "Aktiv",
  "save.careerGraph.done": "Fertig",
  "save.careerGraph.emptyLabel": "Keine Karriere-/Bildungseinträge",
  "save.careerGraph.mainTasks": "Hauptaufgaben",
  "save.careerGraph.modeGraph": "Modern",
  "save.careerGraph.modeList": "Klassisch",
  "save.careerGraph.showMainTasks": "Hauptaufgaben anzeigen",
  "save.careerGraph.title": "Career & Education",
  "save.careerGraph.today": "heute",
  "save.careerGraph.todayMarker": "HEUTE",
  "save.careerGraph.visibilityPrivate": "Privat",
  "save.careerGraph.visibilityPublic": "Öffentlich",
  "save.careerGraph.visibilityShared": "Geteilt",
  "save.collection.addToGroup": "Zu „{name}\" hinzufügen",
  "save.collection.allGroups": "Alle",
  "save.collection.allLabel": "Alle",
  "save.collection.deleteGroup": "Gruppe löschen",
  "save.collection.errorPrefix": "Fehler: {message}",
  "save.collection.nameLabel": "Name",
  "save.collection.openItem": "{title} öffnen",
  "save.collection.removeFromGroup": "Aus „{name}\" entfernen",
  "save.collection.rename": "Umbenennen",
  "save.collection.renameGroup": "Gruppe umbenennen",
  "save.collection.searchPlaceholder": "Suchen…",
  "save.community.addCommunity": "+ Community",
  "save.community.addTrigger": "+ Hinzufügen",
  "save.community.createError": "Community konnte nicht angelegt werden.",
  "save.community.dailyQuotaExceeded": "Tageslimit erreicht. Bitte später erneut versuchen.",
  "save.community.deleteCommunity": "Community löschen",
  "save.community.deleteCompletely": "Komplett löschen",
  "save.community.deleteConfirm": "„{name}\" löschen? Die Kontakte bleiben erhalten, nur die Gruppierung wird entfernt.",
  "save.community.deleteContactPrompt": "„{name}\" aus deinen Kontakten und allen Communities löschen?",
  "save.community.deleteError": "Community konnte nicht gelöscht werden.",
  "save.community.description": "Gruppiere deine Kontakte. Wähle links eine Community und ziehe Kontakte hinein oder füge sie per „Hinzufügen\" zu einer oder mehreren Communities hinzu.",
  "save.community.emptyAllGrouped": "Alle Kontakte sind in Communities.",
  "save.community.emptyCommunity": "Noch niemand in dieser Community. Zieh Kontakte hierher oder nutze „Hinzufügen“.",
  "save.community.emptyNoContacts": "Noch keine Kontakte.",
  "save.community.headerCount": "{count, plural, one {# Kontakt} other {# Kontakte}}",
  "save.community.limitReached": "Sie haben die maximale Anzahl von {limit} Communitys erreicht.",
  "save.community.moveFailed": "Verschieben fehlgeschlagen.",
  "save.community.namePlaceholder": "Community-Name …",
  "save.community.newCommunity": "Neue Community",
  "save.community.removeContact": "Kontakt entfernen",
  "save.community.removeContactError": "Kontakt konnte nicht entfernt werden.",
  "save.community.removeFromCommunityFailed": "Aus der Community entfernen fehlgeschlagen.",
  "save.community.removeFromCommunityPrompt": "„{name}\" aus „{community}\" entfernen (bleibt dein Kontakt und in anderen Communities) oder komplett aus deinen Kontakten und allen Communities löschen?",
  "save.community.removeFromGroup": "Aus Gruppe entfernen",
  "save.community.renameCommunity": "Community umbenennen",
  "save.community.renameError": "Community konnte nicht umbenannt werden.",
  "save.community.saveError": "Community konnte nicht gespeichert werden.",
  "save.community.title": "Community",
  "save.community.ungroupedLabel": "Kontakte ohne Community",
  "save.extraction.analysing": "Analysiert …",
  "save.extraction.analysisComplete": "Analyse abgeschlossen.",
  "save.extraction.analysisFailed": "Analyse fehlgeschlagen.",
  "save.extraction.analysisFailedWithReason": "Analyse fehlgeschlagen ({reason}).",
  "save.extraction.stillRunning": "Die Analyse dauert etwas länger und läuft im Hintergrund weiter. Du erhältst eine Benachrichtigung, sobald sie fertig ist.",
  "save.extraction.runningInBackground": "Läuft im Hintergrund - du kannst dies schließen und weiterarbeiten. Du wirst benachrichtigt, sobald es fertig ist.",
  "save.extraction.done": "Fertig",
  "save.extraction.dropZone": "Datei hierher ziehen oder klicken zum Hochladen",
  "save.extraction.dropZoneHint": "PDF, Word, Excel, Bilder · max. 10 MB pro Datei",
  "save.extraction.duplicateWarning": "Existiert bereits in Documents - das gespeicherte Dokument wird analysiert, kein erneuter Upload.",
  "save.extraction.expertiseFallback": "Fachwissen",
  "save.extraction.fileTooLarge": "„{name}\" ist zu groß (max. 10 MB pro Datei).",
  "save.extraction.fromDocuments": "Aus Documents",
  "save.extraction.newFile": "Neue Datei",
  "save.extraction.newPowersHeading": "Neu erkannte Powers{count, plural, =0 {} other { (#)}}",
  "save.extraction.newSkillsHeading": "Neu erkanntes Fachwissen{count, plural, =0 {} other { (#)}}",
  "save.extraction.noDocuments": "Keine Dokumente vorhanden.",
  "save.extraction.noFolder": "Ohne Ordner",
  "save.extraction.noNewPowers": "Keine Änderungen - die Analyse hat keine neuen Power-Werte ergeben.",
  "save.extraction.noNewSkills": "Keine neuen Einträge - vermutlich war alles bereits in deinem Fachwissen vorhanden.",
  "save.extraction.notAnalyzable": "Wird nicht analysiert",
  "save.extraction.notSignedIn": "Nicht angemeldet - Upload nicht möglich.",
  "save.extraction.nothingSelected": "Nichts ausgewählt",
  "save.extraction.persistUploads": "Hochgeladene Dateien in Documents speichern",
  "save.extraction.pipelineCounts": "{processed} verarbeitet · {skipped} übersprungen · {errored} Fehler",
  "save.extraction.poweredBy": "Powered by smycles AI",
  "save.extraction.powers": "Powers",
  "save.extraction.selectAllInGroup": "Alle in {group} auswählen",
  "save.extraction.selectedCount": "{total, plural, one {# Dokument ausgewählt} other {# Dokumente ausgewählt}}",
  "save.extraction.skills": "Skills",
  "save.extraction.startAnalysis": "Analyse starten",
  "save.extraction.statusLine": "Status: {status}",
  "save.extraction.toggleCollapse": "Auf-/Zuklappen",
  "save.extraction.unsupportedType": "„{name}“ wird nicht analysiert. Unterstützt: PDF, Word, Excel und Bilder.",
  "save.extraction.uploadFailedDuplicate": "Upload fehlgeschlagen. Vermutlich existiert bereits ein Dokument mit diesem Namen.",
  "save.landing.cockpitLabel": "Cockpit · Datenfluss auf einen Blick",
  "save.landing.cockpitRight": "Visibility, Consent, Sync",
  "save.landing.communityCount": "{count, plural, one {# Community} other {# Communities}}",
  "save.landing.communityLabel": "Community",
  "save.landing.complete": "vollständig",
  "save.landing.contacts": "Kontakte",
  "save.landing.enrichProfile": "Profil ergänzen",
  "save.landing.fieldBio": "Bio",
  "save.landing.fieldCity": "Wohnort",
  "save.landing.fieldContactData": "Kontaktdaten",
  "save.landing.fieldEducation": "Bildung",
  "save.landing.fieldExperience": "Berufserfahrung",
  "save.landing.fieldExpertise": "Fachwissen",
  "save.landing.fieldLanguages": "Sprachen",
  "save.landing.fieldProfession": "Beruf",
  "save.landing.heroBody": "Dein persönlicher Tresor, transparent, verifiziert, exportierbar. Profile, Powers, Career, Kontakte, Pins und Favoriten an einem Ort.",
  "save.landing.heroCta": "Open my Vault",
  "save.landing.heroSubtitleLine1": "Own your data.",
  "save.landing.heroSubtitleLine2": "Share on your terms.",
  "save.landing.identitySnapshotLabel": "Identity Snapshot",
  "save.landing.identitySnapshotRight": "Dein Vault auf einen Blick",
  "save.landing.lastVisitor": "zuletzt: {name}",
  "save.landing.noContactsYet": "noch keine Kontakte",
  "save.landing.noPinsYet": "noch nichts gepinnt",
  "save.landing.noVisitsYet": "noch keine Aufrufe",
  "save.landing.openColon": "Offen",
  "save.landing.pinsLabel": "Pins",
  "save.landing.pinsSaved": "gemerkt",
  "save.landing.powerMap": "Power Map",
  "save.landing.powerMapLabel": "Deine Power Map · Ready for MATCH",
  "save.landing.profileCompletenessLabel": "Profil-Vollständigkeit",
  "save.landing.profileVisitorsLabel": "Profilbesucher",
  "save.landing.vaultModules": "Vault-Module",
  "save.landing.vaultModulesLabel": "Your Vault · 4 Module",
  "save.landing.viewAll82": "Alle 82 ansehen",
  "save.landing.viewCommunities": "Communities ansehen",
  "save.landing.viewPins": "Pins ansehen",
  "save.landing.visibilityMatrix": "Visibility Matrix & Recent Activity",
  "save.pinGroupDialog.createFailed": "Gruppe konnte nicht angelegt werden.",
  "save.pinGroupDialog.invalidName": "Ungültiger Name.",
  "save.pinGroupDialog.limitReached": "Sie haben die maximale Anzahl von {limit} Gruppen erreicht.",
  "save.pinGroupDialog.placeholder": "z. B. Mentoren",
  "save.pinGroupDialog.renameFailed": "Gruppe konnte nicht umbenannt werden.",
  "save.pinGroupDialog.submitCreate": "Anlegen",
  "save.pinGroupDialog.titleCreate": "Neue Gruppe",
  "save.pinGroupDialog.titleRename": "Gruppe umbenennen",
  "save.pinGroupDialog.tryAgain": "Bitte erneut versuchen.",
  "save.pinGroupSidebar.addGroup": "+ Gruppe",
  "save.pinGroupSidebar.deleteMessage": "„{name}\" löschen? Die Pins bleiben erhalten, nur die Gruppierung wird entfernt.",
  "save.pinGroupSidebar.deleteTitle": "Gruppe löschen",
  "save.pinGroupSidebar.tabPerson": "Personen",
  "save.pinGroupSidebar.tabPost": "Posts",
  "save.pinGroupSidebar.tabProject": "Projekte",
  "save.pinboardPage.description": "Ziehe eine Karte auf eine Gruppe links oder füge sie per „Hinzufügen\" zu einer oder mehreren Gruppen hinzu. Ziehen auf „Alle\" entfernt sie aus der aktuellen Gruppe.",
  "save.pinboardPage.emptyAllGrouped": "Alle gepinnten {typeLabel} sind in Gruppen.",
  "save.pinboardPage.emptyNoneInView": "Keine gepinnten {typeLabel} in dieser Ansicht.",
  "save.pinboardPage.itemFallback": "Eintrag",
  "save.pinboardPage.openItem": "{name} öffnen",
  "save.pinboardPage.removeFromGroup": "Aus Gruppe entfernen",
  "save.pinboardPage.removeFromGroupMessage": "„{title}\" aus „{group}\" entfernen (bleibt gepinnt und in anderen Gruppen) oder komplett entpinnen?",
  "save.pinboardPage.removePin": "Pin entfernen",
  "save.pinboardPage.title": "Pins",
  "save.pinboardPage.typePersons": "Personen",
  "save.pinboardPage.typePosts": "Posts",
  "save.pinboardPage.typeProjects": "Projekte",
  "save.pinboardPage.ungroupedLabel": "Pins ohne Gruppe",
  "save.pinboardPage.unpin": "Entpinnen",
  "save.pinboardPage.unpinCompletely": "Komplett entpinnen",
  "save.pinboardPage.unpinMessage": "„{title}\" entpinnen?",
  "save.tour.community.desc": "Du hast {contacts} Kontakte in {communities} Communities. Klicke die Kachel, um sie zu gruppieren und zu verwalten.",
  "save.tour.community.title": "Community",
  "save.tour.completeness.desc": "Dein Profil ist zu {pct}% vollständig.{missing} Klicke die Kachel, um die Lücken zu füllen.",
  "save.tour.completeness.done": "Alles ist ausgefüllt.",
  "save.tour.completeness.missing": "Noch offen: {fields}.",
  "save.tour.completeness.title": "Profil-Vollständigkeit",
  "save.tour.label": "Save",
  "save.tour.pins.desc": "{count} gepinnte Einträge: Personen, Beiträge und Projekte, die du gespeichert hast. Klicke die Kachel, um deine Pinnwand zu öffnen.",
  "save.tour.pins.title": "Pins",
  "save.tour.summary": "Das ist dein Save-Bereich, dein persönlicher Datentresor. Dein Profil ist zu {pct}% vollständig. Ich zeige dir deinen Tresor im Überblick.",
  "save.tour.visitors.desc": "{count} kürzliche Profilbesucher{last}. Öffne einen Namen, um zu sehen, wer sich für dich interessiert.",
  "save.tour.visitors.title": "Profilbesucher",
  "search.activeCount": "{count} aktiv",
  "search.allFiltersAdded": "Alle Filter hinzugefügt",
  "search.any": "Beliebig",
  "search.chipType": "Typ",
  "search.clear": "Suche löschen",
  "search.confirmRemoveFromGroup": "Entfernen?",
  "search.discoverHeading": "Discover",
  "search.done": "Fertig",
  "search.either": "Egal",
  "search.errorPrefix": "Fehler: {message}",
  "search.extended": "Erweiterte Suche",
  "search.eyebrow": "Suche",
  "search.fieldAge": "Alter",
  "search.fieldChildren": "Anzahl Kinder",
  "search.fieldCitizenship": "Staatsangehörigkeit",
  "search.fieldCity": "Wohnort",
  "search.fieldCountry": "Land",
  "search.fieldDepartment": "Abteilung",
  "search.fieldExpertise": "Expertise",
  "search.fieldFirstName": "Vorname",
  "search.fieldGender": "Geschlecht",
  "search.fieldIndustry": "Branche",
  "search.fieldJobTitle": "Stellenbezeichnung",
  "search.fieldLanguages": "Sprachen",
  "search.fieldLastName": "Nachname",
  "search.fieldLocation": "Arbeitsstandort",
  "search.fieldMaritalStatus": "Familienstand",
  "search.fieldNationality": "Nationalität",
  "search.filterHeading": "{type}-Filter",
  "search.flagCommented": "Kommentiert",
  "search.flagOwner": "Eigentümer",
  "search.flagPinned": "Gepinnt",
  "search.flagRated": "Bewertet",
  "search.flagSignedUp": "Interessiert",
  "search.groupPosts": "Posts",
  "search.groupProjects": "Projekte",
  "search.groupTeamplayers": "Teamplayer",
  "search.hide": "Ausblenden ▴",
  "search.no": "Nein",
  "search.noFilters": "Keine Filter gesetzt.",
  "search.noResults": "Keine Treffer",
  "search.openChat": "Chat öffnen",
  "search.pin": "Pinnen",
  "search.pinInto": "In „{name}“ pinnen",
  "search.pinNoGroup": "Pinnen (ohne Gruppe)",
  "search.placeholder": "Suche nach Teamplayern, Projekten, Posts …",
  "search.placeholderPerson": "Name, Jobtitel …",
  "search.placeholderShared": "Titel, Beschreibung …",
  "search.queryLabel": "Suchbegriff",
  "search.rangeTo": "bis",
  "search.removeFieldLabel": "{field} entfernen",
  "search.removeFromGroup": "Aus „{name}“ entfernen",
  "search.reset": "Zurücksetzen",
  "search.resultCount": "{count} {type}",
  "search.resultCountMore": "{count}+ {type}",
  "search.resultCountOf": "{count} von {total} {type}",
  "search.search": "Suchen",
  "search.searching": "Suche läuft …",
  "search.show": "Anzeigen ▾",
  "search.tabShare": "Share",
  "search.tabTeamplayer": "Teamplayer",
  "search.tour.filters.desc": "Baue hier strukturierte Filter und kombiniere sie mit dem Freitext-Suchbegriff oben, dann drücke Suchen. Gerade sind {count} Filter aktiv.",
  "search.tour.filters.emptyDesc": "Baue hier strukturierte Filter und kombiniere sie mit dem Freitext-Suchbegriff oben, dann drücke Suchen. Gerade ist kein Filter gesetzt.",
  "search.tour.filters.title": "Filter",
  "search.tour.label": "Suche",
  "search.tour.results.desc": "Hier erscheinen die Treffer, aktuell {summary}. Klicke ein Ergebnis, um es zu öffnen; beim Scrollen lädt mehr nach.",
  "search.tour.results.title": "Ergebnisse",
  "search.tour.summary": "Das ist die erweiterte Suche. Finde Personen oder geteilte Projekte und Beiträge mit strukturierten Filtern. Gerade suchst du {type}.",
  "search.tour.typeToggle.desc": "Wechsle die Suchkategorie: Teamplayer findet Personen, Share findet Projekte und Beiträge. Jede Kategorie hat eigene Filter.",
  "search.tour.typeToggle.title": "Was suchen",
  "search.typeAll": "Alle",
  "search.typePosts": "Posts",
  "search.typeProjects": "Projekte",
  "search.unpin": "Entpinnen",
  "search.useExtended": "Erweiterte Suche verwenden",
  "search.writeMessage": "Nachricht schreiben",
  "search.yes": "Ja",
  "secretInput.hide": "Wert verbergen",
  "secretInput.show": "Wert anzeigen",
  "service.docItemRow.download": "Herunterladen",
  "service.docItemRow.newBadge": "Neu",
  "service.docItemRow.open": "Öffnen",
  "service.docItemRow.rename": "Zum Umbenennen klicken",
  "service.docItemRow.selectAriaLabel": "{name} auswählen",
  "service.docItemRow.sourceLabel": "Quelle: {source}",
  "service.docPreviewCard.cvGeneratorDraft": "CV-Generator Entwurf",
  "service.docPreviewCard.download": "Herunterladen",
  "service.docPreviewCard.newBadge": "Neu",
  "service.docPreviewCard.open": "Öffnen",
  "service.docPreviewCard.rename": "Zum Umbenennen klicken",
  "service.docPreviewCard.selectAriaLabel": "{name} auswählen",
  "service.extRename.ariaLabel": "Umbenennen",
  "service.filterBuilder.addFilter": "+ Filter hinzufügen",
  "service.filterBuilder.all": "Alle",
  "service.filterBuilder.allFiltersAdded": "Alle Filter hinzugefügt",
  "service.filterBuilder.clear": "Leeren",
  "service.filterBuilder.done": "Fertig",
  "service.filterBuilder.removeFilterLabel": "{label} entfernen",
  "service.folderRow.deleteFolder": "Ordner löschen",
  "service.folderRow.deleteFolderAria": "Ordner {name} löschen",
  "service.folderRow.deleteFolderOnlyHint": "Nur den Ordner löschen: {count} Datei(en) wandern zu „Unsortiert\"",
  "service.folderRow.deleteLabel": "Löschen:",
  "service.folderRow.deleteWithFilesHint": "Ordner samt {count} Datei(en) endgültig löschen",
  "service.folderRow.folderNamePlaceholder": "Ordnername …",
  "service.folderRow.folderOnly": "Nur Ordner",
  "service.folderRow.newFolder": "Neuer Ordner",
  "service.folderRow.renameFolder": "Ordner umbenennen",
  "service.folderRow.toggleHint": "Auf-/Zuklappen (Doppelklick: umbenennen)",
  "service.folderRow.withFiles": "Mit Dateien",
  "service.page.allInFolders": "Alles in Ordnern abgelegt",
  "service.page.bulkCv.addMore": "Dateien hinzufügen",
  "service.page.bulkCv.addToCommunity": "Community",
  "service.page.bulkCv.addedToCommunity": "{n} zu {names} hinzugefügt",
  "service.page.bulkCv.communitySubject": "{n} importierte Personen",
  "service.page.bulkCv.desc": "Mehrere Lebensläufe ablegen, um die zugehörigen Profile anzulegen oder zu aktualisieren. Bestehende Profile werden nur dort ergänzt, wo Felder leer sind – nichts wird überschrieben.",
  "service.page.bulkCv.dupWarning": "Lebensläufe ohne E-Mail-Adresse erzeugen bei jedem Lauf ein neues Profil. Dieselben Dateien nicht erneut importieren.",
  "service.page.bulkCv.hint": "PDF, DOCX, Bilder … · max. 10 MB pro Datei · bis zu 25 Dateien",
  "service.page.bulkCv.importBtn": "{n, plural, one {# Lebenslauf} other {# Lebensläufe}} importieren",
  "service.page.bulkCv.importPhoto": "Foto importieren",
  "service.page.bulkCv.importing": "Importiere {done}/{total} …",
  "service.page.bulkCv.openProfile": "Profil",
  "service.page.bulkCv.outcomeCreated": "Neu",
  "service.page.bulkCv.outcomeFailed": "Import fehlgeschlagen",
  "service.page.bulkCv.outcomeUpdated": "Aktualisiert",
  "service.page.bulkCv.rejected": "Einige Dateien wurden übersprungen (zu groß oder nicht unterstützter Typ).",
  "service.page.bulkCv.summary": "{created} angelegt, {updated} aktualisiert, {failed} fehlgeschlagen",
  "service.page.bulkCv.title": "Profile importieren",
  "service.page.bulkCv.tooMany": "Es können höchstens {max} Dateien auf einmal importiert werden.",
  "service.page.bulkCv.willAddToCommunity": "Neue Importe werden hinzugefügt zu: {names}",
  "service.page.bulkCv.zone": "Lebensläufe hierher ziehen oder klicken zum Hinzufügen",
  "service.page.cardCvExtractorDesc": "Parst PDF/DOCX-Lebensläufe und übernimmt Stationen, Skills und Daten strukturiert.",
  "service.page.cardCvExtractorTitle": "CV-Extractor",
  "service.page.cardCvGeneratorDesc": "Erzeugt aus Profil-Daten einen Lebenslauf - landet rechts in DOCUMENTS.",
  "service.page.cardCvGeneratorTitle": "CV-Generator",
  "service.page.cardDatatransferDesc": "Exportiert deine Profil- und Grow-Daten als JSON-Datei (DSGVO Art. 20) - landet in DOCUMENTS und wird sofort heruntergeladen.",
  "service.page.cardDatatransferTitle": "Datentransfer",
  "service.page.cardHardskillDesc": "Erkennt fachliche Hard Skills und Tools aus deinem Profil und bewertet ihr Niveau.",
  "service.page.cardHardskillTitle": "Hardskill-Analyse",
  "service.page.cardLinkedinDesc": "Übernimmt Profil, Stationen und Skills direkt aus deinem LinkedIn-Account.",
  "service.page.cardLinkedinTitle": "LinkedIn-Import",
  "service.page.cardPowerDesc": "Identifiziert Powers, Skills und Erfahrung aus Free-Text und Selbstbeschreibung.",
  "service.page.cardPowerTitle": "Power-Analyse",
  "service.page.clearSelection": "Auswahl aufheben",
  "service.page.confirmDelete": "Wirklich löschen?",
  "service.page.cvFallbackName": "Lebenslauf",
  "service.page.cvNotMovable": "CV-Entwürfe können nicht in Ordner verschoben werden",
  "service.page.docOpening": "Dokument lädt …",
  "service.page.documentDeleteBlocked": "Dieses Dokument wird noch in geteilten Beiträgen verwendet. Entferne es zuerst dort:",
  "service.page.documentsCount": "{total} Dokumenten",
  "service.page.documentsHint": "Alle Dateien, die du hochgeladen oder über die Profil-Services erzeugt hast.",
  "service.page.documentsTitle": "Dokumente",
  "service.page.dropIntoFolder": "Hier ablegen, in diesen Ordner hochladen",
  "service.page.errDownload": "Download fehlgeschlagen.",
  "service.page.errExport": "Datenexport fehlgeschlagen.",
  "service.page.errExportSave": "Export konnte nicht gespeichert werden.",
  "service.page.errFolderCreate": "Ordner konnte nicht angelegt werden.",
  "service.page.errFolderLimit": "Du hast die maximale Anzahl von {limit} Ordnern erreicht.",
  "service.page.errFolderDelete": "Ordner konnte nicht gelöscht werden.",
  "service.page.errFolderRename": "Ordner konnte nicht umbenannt werden.",
  "service.page.errMove": "Verschieben fehlgeschlagen.",
  "service.page.errNoContent": "Kein Inhalt vorhanden.",
  "service.page.errNotSignedInExport": "Nicht angemeldet - Export nicht möglich.",
  "service.page.errNotSignedInUpload": "Nicht angemeldet - Upload nicht möglich.",
  "service.page.errOpen": "Öffnen fehlgeschlagen.",
  "service.page.errPopupBlocked": "Der Browser hat das Öffnen in einem neuen Tab blockiert - bitte Pop-ups für diese Seite erlauben und erneut auf Öffnen klicken.",
  "service.page.errProfileLoad": "Profildaten konnten nicht geladen werden.",
  "service.page.errRename": "Umbenennen fehlgeschlagen.",
  "service.page.errUploadDuplicate": "Upload fehlgeschlagen. Vermutlich existiert bereits ein Dokument mit diesem Namen.",
  "service.page.error": "Fehler: {message}",
  "service.page.exporting": "Exportiert …",
  "service.page.filterFileType": "Filetype",
  "service.page.filterPlaceholder": "Filtere deine verfügbaren Dokumente …",
  "service.page.filterSource": "Quelle",
  "service.page.folderEmpty": "Ordner ist leer - zieh Dokumente auf die Ordnerkachel.",
  "service.page.hardskillAnalysisTitle": "Hardskill-Analyse",
  "service.page.inputTitle": "Profil aufbauen",
  "service.page.maxPerFile": "max. 10 MB pro Datei",
  "service.page.moveToFolder": "In Ordner verschieben",
  "service.page.nextPage": "Weiter",
  "service.page.noDocuments": "Keine Dokumente",
  "service.page.noFolders": "Keine Ordner vorhanden",
  "service.page.noMatches": "Keine Treffer",
  "service.page.noMatchesInFolder": "Keine Treffer in diesem Ordner",
  "service.page.onlyRealFilesMovable": "Nur echte Dateien lassen sich in Ordner verschieben, keine CV-Generator-Einträge.",
  "service.page.openBlockingSharedItem": "Geteilten Beitrag {number} öffnen",
  "service.page.orDragAndDrop": "Oder per Drag & Drop",
  "service.page.outputTitle": "Profil exportieren",
  "service.page.pageOf": "Seite {page} von {total}",
  "service.page.powerAnalysisTitle": "Power-Analyse",
  "service.page.prevPage": "Zurück",
  "service.page.removeBlockingSelection": "Verhindernde Auswahl entfernen",
  "service.page.reset": "Zurücksetzen",
  "service.page.selectedCount": "{count} ausgewählt",
  "service.page.sourceCvGenerator": "CV Generator",
  "service.page.sourceUpload": "Dateiupload",
  "service.page.unsorted": "Unsortiert",
  "service.page.uploadFile": "Datei hochladen",
  "service.page.uploading": "Lädt hoch …",
  "service.page.viewCompact": "Kompakt",
  "service.page.viewPreview": "Vorschau",
  "service.tour.filters.desc": "Filtere deine Dokumente nach Name, Quelle oder Dateityp und wechsle zwischen Vorschau- und Kompaktansicht.",
  "service.tour.filters.title": "Suchen & Filtern",
  "service.tour.label": "Save Dokumente",
  "service.tour.list.desc": "{count} Dokumente in {folders} Ordnern. Öffne einen Ordner für seine Dateien, ziehe Dokumente zwischen Ordnern und fahre über eine Zeile, um sie umzubenennen, auszuwählen oder zu löschen.",
  "service.tour.list.title": "Deine Dokumente",
  "service.tour.summary": "Das ist deine Dokumenten-Seite: {count} Dokumente in {folders} Ordnern, von manuellen Uploads bis zu generierten Lebensläufen.",
  "service.tour.upload.desc": "Lade hier Dateien hoch (max. 10 MB pro Datei), oder ziehe sie einfach per Drag & Drop auf einen Ordner oder die Liste darunter.",
  "service.tour.upload.title": "Dateien hochladen",
  "settings.account.delete.button": "Konto löschen",
  "settings.account.delete.confirm": "Endgültig löschen",
  "settings.account.delete.desc": "Dein Konto und alle zugehörigen Daten werden dauerhaft gelöscht. Das kann nicht rückgängig gemacht werden.",
  "settings.account.delete.dialogTitle": "Konto endgültig löschen?",
  "settings.account.delete.error": "Löschen fehlgeschlagen. Bitte erneut versuchen.",
  "settings.account.delete.placeholder": "Vollständiger Name",
  "settings.account.delete.prompt": "Gib zur Bestätigung deinen vollständigen Namen ein:",
  "settings.account.delete.title": "Konto löschen",
  "settings.account.delete.zone": "Gefahrenzone",
  "settings.eyebrow": "Plattform-Konfiguration",
  "settings.heading": "Admin",
  "settings.intro": "Branding, verwaltete Stammdaten, Fragebögen und Darstellung.",
  "settings.sectionBranding": "Branding",
  "settings.sectionFragebogen": "Fragebögen",
  "settings.sectionHrPrompt": "HR-Prompt",
  "settings.sectionModel": "KI-Modell",
  "settings.sectionRoster": "Profile importieren",
  "settings.sectionStammdaten": "Stammdaten",
  "settings.sectionStyleguide": "Styleguide",
  "settings.upload.appearance.area": "Einstellungen",
  "settings.upload.appearance.limit": "bis 16 MB",
  "settings.upload.appearance.note": "base64-inline, BFF-Limit",
  "settings.upload.appearance.what": "Logo & Hintergrundbild",
  "settings.upload.docs.area": "Save · Dokumente",
  "settings.upload.docs.limit": "10 MB pro Datei",
  "settings.upload.docs.what": "Datei-Upload (PDF, DOCX, …)",
  "settings.upload.generalNote": "Alle Uploads laufen base64-kodiert über das BFF, das pro Anfrage max. 16 MB erlaubt. Da base64 die Größe um rund 33 % erhöht, liegen die tatsächlichen Dateigrenzen etwas darunter.",
  "settings.upload.profile.area": "Profil",
  "settings.upload.profile.limit": "5 MB",
  "settings.upload.profile.what": "Profilbild / Avatar",
  "settings.upload.shareAttach.area": "Share · Anhänge",
  "settings.upload.shareAttach.limit": "bis 16 MB",
  "settings.upload.shareAttach.note": "technische Obergrenze (BFF)",
  "settings.upload.shareAttach.what": "Datei-Anhänge an Projekte",
  "settings.upload.shareImage.area": "Share · Projekte",
  "settings.upload.shareImage.limit": "5 MB pro Bild",
  "settings.upload.shareImage.what": "Titelbild",
  "share.create.attachmentsLabel": "Anhänge",
  "share.create.authorLabel": "Autor",
  "share.create.commentsAfterPublish": "Nach dem Veröffentlichen verfügbar.",
  "share.create.commentsLabel": "Kommentare",
  "share.create.createHeading": "{type, select, POST {Neuer Post} other {Neues Projekt}}",
  "share.create.descriptionLabel": "Beschreibung",
  "share.create.descriptionPlaceholder": "{type, select, POST {Beschreibe deinen Post …} other {Beschreibe dein Projekt …}}",
  "share.create.editHeading": "{type, select, POST {Post bearbeiten} other {Projekt bearbeiten}}",
  "share.create.existingAttachment": "Anhang {n}",
  "share.create.existingImage": "Bild {n}",
  "share.create.eyebrowCreate": "Erstellen",
  "share.create.eyebrowEdit": "Bearbeiten",
  "share.create.eyebrowPreview": "Vorschau",
  "share.create.fromDocuments": "Aus meinen Dokumenten",
  "share.create.imagesLabel": "Bilder",
  "share.create.loadingFiles": "lädt…",
  "share.create.mainImageBadge": "Vorschau",
  "share.create.mainImageHint": "Als Vorschaubild festlegen",
  "share.create.noDescription": "Keine Beschreibung.",
  "share.create.previewButton": "Vorschau",
  "share.create.previewHeading": "So sieht's aus",
  "share.create.publish": "Veröffentlichen",
  "share.create.publishedAtLabel": "Veröffentlicht am",
  "share.create.ratingLabel": "Bewertung",
  "share.create.shortDescriptionLabel": "Kurzbeschreibung",
  "share.create.shortDescriptionPlaceholder": "In einem Satz: worum geht's?",
  "share.create.statComments": "Kommentare",
  "share.create.statInterested": "Interessenten",
  "share.create.statPins": "Pins",
  "share.create.statRatings": "Bewertungen",
  "share.create.statViews": "Views",
  "share.create.titleLabel": "Titel",
  "share.create.titlePlaceholder": "{type, select, POST {Titel des Posts} other {Titel des Projekts}}",
  "share.create.tooLarge": "Zu groß (max. {max} MB pro Datei): {names}",
  "share.create.typeLabel": "Typ",
  "share.create.typePost": "Post",
  "share.create.typeProject": "Projekt",
  "share.create.unsupportedType": "Nicht unterstützter Dateityp: {names}",
  "share.create.untitled": "Unbenannt",
  "share.docPicker.confirm": "{count} übernehmen",
  "share.docPicker.empty": "Noch keine Dokumente in deinem Vault.",
  "share.docPicker.emptyImages": "Noch keine Bilder in deinen Dokumenten.",
  "share.docPicker.hint": "Ausgewählte Dokumente werden dem Beitrag als Kopie angehängt.",
  "share.docPicker.loadFailed": "Dokumente konnten nicht geladen werden.",
  "share.docPicker.title": "Aus meinen Dokumenten hinzufügen",
  "share.docPicker.unnamedDocument": "Unbenanntes Dokument",
  "share.itemDetail.alreadyRated": "Du hast bereits bewertet, erneut tippen zum Ändern.",
  "share.itemDetail.attachmentDownloadFailed": "Download fehlgeschlagen.",
  "share.itemDetail.attachmentOpenFailed": "Öffnen fehlgeschlagen.",
  "share.itemDetail.attachmentUnnamed": "Anhang",
  "share.itemDetail.attachments": "Anhänge",
  "share.itemDetail.downloadAttachment": "{name} herunterladen",
  "share.itemDetail.openAttachment": "{name} öffnen",
  "share.itemDetail.author": "Autor",
  "share.itemDetail.commentPlaceholder": "Kommentar schreiben…",
  "share.itemDetail.comments": "Kommentare",
  "share.itemDetail.deleteConfirm": "Löschen?",
  "share.itemDetail.error": "Fehler: {message}",
  "share.itemDetail.expressInterest": "Interesse zeigen",
  "share.itemDetail.imageN": "Bild {n}",
  "share.itemDetail.linkedMatchTitle": "Neues Match starten und mit diesem Share-Item verknüpfen",
  "share.itemDetail.loading": "lädt…",
  "share.itemDetail.more": "Mehr",
  "share.itemDetail.newMatch": "Neues Match ↗",
  "share.itemDetail.no": "Nein",
  "share.itemDetail.noComments": "Noch keine Kommentare, sei der/die Erste.",
  "share.itemDetail.noDescription": "Keine Beschreibung",
  "share.itemDetail.noDescriptionHint": "kein Inhalt hinterlegt",
  "share.itemDetail.notFound": "Beitrag nicht gefunden",
  "share.itemDetail.publishedOn": "Veröffentlicht am",
  "share.itemDetail.rateYourselfTitle": "Klicken, um selbst zu bewerten",
  "share.itemDetail.rating": "Bewertung",
  "share.itemDetail.ratingClose": "schließen",
  "share.itemDetail.ratingOpen": "bewerten ›",
  "share.itemDetail.ratingsCount": "({count} Bewertungen)",
  "share.itemDetail.send": "Senden",
  "share.itemDetail.share": "Teilen",
  "share.itemDetail.shareWithIcon": "↗ Teilen",
  "share.itemDetail.signedUpWithdraw": "✓ Interesse gezeigt - zurückziehen",
  "share.itemDetail.starsAriaLabel": "{n} von 5 Sternen",
  "share.itemDetail.starsTitle": "{n, plural, one {# Stern} other {# Sterne}}",
  "share.itemDetail.statInterested": "Interessenten",
  "share.itemDetail.statPins": "Pins",
  "share.itemDetail.statViews": "Views",
  "share.itemDetail.thanks": "Danke!",
  "share.itemDetail.tour.actions.desc": "Beobachte den Eintrag, um ihm zu folgen, oder starte ein neues Match, das damit verknüpft ist.",
  "share.itemDetail.tour.actions.projectDesc": "Beobachte den Eintrag, um ihm zu folgen, bekunde Interesse, um dich als Teilnehmer einzutragen, oder starte ein neues Match zu diesem Projekt.",
  "share.itemDetail.tour.actions.title": "Mitmachen",
  "share.itemDetail.tour.content.desc": "Titel, Bildergalerie und vollständige Beschreibung von „{name}“. Klicke die Vorschaubilder, um durch die Galerie zu blättern.",
  "share.itemDetail.tour.content.title": "Der Inhalt",
  "share.itemDetail.tour.label": "Share Beitrag",
  "share.itemDetail.tour.stats.desc": "Die bisherige Reichweite: {views} Aufrufe, {pins} Pins und {signUps} Interessierte.",
  "share.itemDetail.tour.stats.title": "So läuft es",
  "share.itemDetail.tour.summary": "Du schaust dir „{name}“ an, ein {type} aus der Share-Community.",
  "share.itemDetail.unwatch": "✓ Beobachtet - entfernen",
  "share.itemDetail.watch": "Beobachten",
  "share.itemDetail.yes": "Ja",
  "share.landing.carouselDiscussed": "Meiste Kommentare",
  "share.landing.carouselInterest": "Meiste Interessenten",
  "share.landing.carouselNew": "Neueste",
  "share.landing.carouselTop": "Top bewertet",
  "share.landing.discoverAllPosts": "Alle Beiträge entdecken ↗",
  "share.landing.discoverEyebrow": "Entdecken",
  "share.landing.error": "Fehler: {message}",
  "share.landing.heroBody": "Veröffentliche Projekte und Posts, sammle Interessenten, Feedback und Reichweite. Und entdecke, woran die Community gerade baut.",
  "share.landing.heroCta": "Create ↗",
  "share.landing.heroSubtitleLine1": "Zeig, woran du arbeitest.",
  "share.landing.heroSubtitleLine2": "Finde, wer mitmacht.",
  "share.landing.loading": "lädt…",
  "share.landing.myActivity": "Meine Aktivität",
  "share.landing.myProjectsSection": "Meine Projekte & Posts",
  "share.landing.next": "Nächstes",
  "share.landing.noOwnPosts": "Noch keine eigenen Beiträge",
  "share.landing.noOwnPostsHint": "erstelle ein Projekt oder einen Post",
  "share.landing.noSharedItems": "Keine geteilten Items vorhanden.",
  "share.landing.noShortDescription": "Keine Kurzbeschreibung.",
  "share.landing.nothingWatched": "Noch nichts beobachtet oder beteiligt",
  "share.landing.nothingWatchedHint": "Beobachte Projekte & Posts oder beteilige dich.",
  "share.landing.open": "Öffnen ↗",
  "share.landing.previous": "Vorheriges",
  "share.landing.share": "↗ Teilen",
  "share.landing.slide": "Slide {number}",
  "share.landing.statComments": "Kommentare",
  "share.landing.statInterested": "Interessenten",
  "share.landing.statRatings": "Ratings",
  "share.landing.statViews": "Views",
  "share.landing.tour.activity.desc": "Die {count} Einträge, die du beobachtest oder für die du dich eingetragen hast. So kommst du schnell wieder dorthin zurück.",
  "share.landing.tour.activity.emptyDesc": "Einträge, die du beobachtest oder für die du dich einträgst, sammeln sich hier; noch ist nichts da. Öffne einen Eintrag und drücke Beobachten oder Interesse bekunden.",
  "share.landing.tour.activity.title": "Beobachtet & Beteiligt",
  "share.landing.tour.carousel.desc": "Vier kuratierte Top-5-Listen: am besten bewertet, am neuesten, meiste Interessenten, meiste Kommentare. Wechsle die Listen über die Tabs; gerade läuft „{featured}“. Klicke Öffnen, um in einen Eintrag zu springen.",
  "share.landing.tour.carousel.title": "Entdecken",
  "share.landing.tour.create.desc": "Veröffentliche hier dein eigenes Projekt oder deinen Beitrag. Beschreibe es, füge Bilder hinzu und sammle Interessierte.",
  "share.landing.tour.create.title": "Etwas erstellen",
  "share.landing.tour.emptySummary": "Das ist Share, der Community-Feed, in dem Menschen Projekte und Beiträge veröffentlichen, Interessierte gewinnen und Feedback sammeln.",
  "share.landing.tour.label": "Share",
  "share.landing.tour.mine.desc": "Deine eigenen {count} veröffentlichten Einträge. „Alle ansehen“ öffnet die vollständige Liste, in der du sie verwaltest.",
  "share.landing.tour.mine.emptyDesc": "Deine eigenen veröffentlichten Einträge erscheinen hier. Du hast noch keine erstellt.",
  "share.landing.tour.mine.title": "Meine Projekte & Beiträge",
  "share.landing.tour.summary": "Das ist Share, der Community-Feed, in dem Menschen Projekte und Beiträge veröffentlichen, Interessierte gewinnen und Feedback sammeln. Gerade steht „{name}“ im Rampenlicht.",
  "share.landing.viewAll": "Alle ansehen ↗",
  "share.landing.watchedSection": "Beobachtet & Beteiligt",
  "share.mine.emptyHint": "erstelle ein Projekt oder einen Post",
  "share.mine.emptyLabel": "Noch keine eigenen Beiträge",
  "share.mine.error": "Fehler: {message}",
  "share.mine.eyebrow": "SHARE · Meine Beiträge",
  "share.mine.filterAll": "Alle",
  "share.mine.filterPosts": "Posts",
  "share.mine.filterProjects": "Projekte",
  "share.mine.subtitle": "Alle deine Projekte und Posts.",
  "share.mine.title": "Meine Beiträge",
  "share.mine.tour.filters.desc": "Grenze die Liste auf Projekte oder Beiträge ein und ändere rechts die Sortierung.",
  "share.mine.tour.filters.title": "Filtern & Sortieren",
  "share.mine.tour.items.desc": "{count} Einträge. Klicke einen an, um ihn zu öffnen; als Besitzer kannst du ihn auf der Detailseite bearbeiten oder löschen.",
  "share.mine.tour.items.emptyDesc": "Noch nichts hier. Erstelle ein Projekt oder einen Beitrag, dann taucht er in diesem Raster auf.",
  "share.mine.tour.items.title": "Deine Einträge",
  "share.mine.tour.label": "Share Meine",
  "share.mine.tour.summary": "Das sind deine eigenen Beiträge: alles, was du auf Share veröffentlicht hast. Gerade sind es {count} Einträge.",
  "skill.catAwareness": "Bewusstsein & Lernen",
  "skill.catImpact": "Wirkung & Einfluss gestalten",
  "skill.catPractical": "Praktische Anwendung & Kompetenzsicherheit",
  "skill.desc.1": "Du kennst grundlegende Konzepte dieser Kompetenz und hast erste Berührungspunkte damit, nutzt sie aber noch nicht praktisch.",
  "skill.desc.2": "Du baust aktiv Grundlagen in dieser Kompetenz auf und kannst erste einfache Aufgaben mit Unterstützung und Vorgaben bearbeiten.",
  "skill.desc.3": "Du nutzt die Kompetenz bereits in ersten praktischen Situationen und kannst einfache Aufgaben selbstständig umsetzen.",
  "skill.desc.4": "Du setzt die Kompetenz regelmäßig ein und kannst typische Aufgaben zuverlässig und selbstständig lösen.",
  "skill.desc.5": "Du verfügst über tiefgehende praktische Erfahrung und setzt die Kompetenz souverän in unterschiedlichen komplexen und anspruchsvollen Situationen ein.",
  "skill.desc.6": "Du bist eine anerkannte Referenz für diese Kompetenz und stärkst andere in der Anwendung, indem du wirksam Best Practices im Team oder in der Organisation etablierst.",
  "skill.desc.7": "Du entwickelst zukunftsweisende Ansätze für diese Kompetenz und gibst richtungsweisende Impulse, die zu neuen Standards führen.",
  "skill.infoLabel": "Levelbeschreibung",
  "skill.levelName.1": "Explorer",
  "skill.levelName.2": "Builder",
  "skill.levelName.3": "Contributor",
  "skill.levelName.4": "Practitioner",
  "skill.levelName.5": "Specialist",
  "skill.levelName.6": "Multiplier",
  "skill.levelName.7": "Pioneer",
  "skill.levelTitle.1": "Kennenlernen & erste Berührungspunkte",
  "skill.levelTitle.2": "Gezieltes Entwickeln",
  "skill.levelTitle.3": "Erste Praxisanwendungen",
  "skill.levelTitle.4": "Regelmäßige & sichere Praxisanwendungen",
  "skill.levelTitle.5": "Souveräner Einsatz in anspruchsvollen Kontexten",
  "skill.levelTitle.6": "Andere befähigen & entwickeln",
  "skill.levelTitle.7": "Neues prägen & Innovation vorantreiben",
  "sort.az": "A–Z",
  "sort.label": "Sortieren",
  "sort.nameAz": "Name A–Z",
  "sort.nameZa": "Name Z–A",
  "sort.new": "Neueste",
  "sort.old": "Älteste",
  "sort.top": "Top bewertet",
  "stammdaten.details": "Details",
  "stammdaten.experience": "Berufserfahrung",
  "stammdaten.organisation": "Organisation",
  "suggestions.activities": "Aufgaben vorschlagen",
  "suggestions.add": "Tippen zum Hinzufügen",
  "suggestions.addTask": "+ Aufgabe",
  "suggestions.empty": "Keine Vorschläge gefunden",
  "suggestions.loading": "Vorschläge werden geladen…",
  "suggestions.needJobTitle": "Erst Stellenbezeichnung eingeben",
  "suggestions.retry": "Erneut versuchen",
  "suggestions.unavailable": "Vorschläge derzeit nicht verfügbar",
  "topbar.help.choiceNews": "Zeig mir was neu ist",
  "topbar.help.choiceTour": "Starte die Tour",
  "topbar.help.hint": "Neu hier? Starte mit diesem Button die geführte Tour durch die App.",
  "topbar.help.hintDismiss": "Ausblenden",
  "topbar.help.hintNews": "Seit deiner Tour hat sich etwas getan. Dieser Button zeigt dir, was neu ist.",
  "topbar.help.label": "Starte die geführte Tour",
  "unsavedGuard.body": "Du hast Änderungen, die noch nicht gespeichert wurden. Wenn du die Seite verlässt, gehen sie verloren.",
  "unsavedGuard.discard": "Verwerfen",
  "unsavedGuard.save": "Speichern",
  "unsavedGuard.stay": "Hier bleiben",
  "unsavedGuard.title": "Ungespeicherte Änderungen",
  "userSettings.claude.appDesc": "Füge Smycles einmal als Connector in deinem Claude-Konto hinzu, dann funktioniert es in der Claude-Desktop-App, der Web-App und mobil.",
  "userSettings.claude.appInternalHint": "Hinweis: Claude verbindet sich aus der eigenen Cloud, daher funktioniert das vorerst nicht auf internen Systemen. Der Smycles-Server muss aus dem öffentlichen Internet erreichbar sein. Claude Code (unten) funktioniert heute schon auf internen Systemen.",
  "userSettings.claude.appStep1": "Öffne in Claude die Einstellungen und dann Connectors.",
  "userSettings.claude.appStep2": "Wähle „Add custom connector“ und füge die obige Server-URL ein.",
  "userSettings.claude.appStep3": "Öffne die erweiterten Einstellungen, trage die obige Client-ID ein und lass das Client-Secret leer.",
  "userSettings.claude.appStep4": "Füge den Connector hinzu, klicke dann auf Connect und melde dich mit deinem Smycles-Konto an.",
  "userSettings.claude.appTeamNote": "In Team- und Enterprise-Plänen fügt ein Organisations-Owner den Connector einmalig hinzu; alle anderen klicken nur auf Connect und melden sich an.",
  "userSettings.claude.appTitle": "Claude-App (Desktop, Web und Mobil)",
  "userSettings.claude.clientIdLabel": "Client-ID",
  "userSettings.claude.codeDesc": "Führe diesen Befehl aus, starte dann Claude Code, führe /mcp aus, wähle smycles und dann Authentifizieren. Ein Browserfenster öffnet sich für die Smycles-Anmeldung.",
  "userSettings.claude.codeTitle": "Claude Code (für Entwickler)",
  "userSettings.claude.commandLabel": "Befehl",
  "userSettings.claude.detailsTitle": "Verbindungsdaten",
  "userSettings.claude.eyebrow": "Claude",
  "userSettings.claude.intro": "Nutze deine Smycles-Daten und -Werkzeuge direkt in Claude. Claude sieht genau das, was du sehen kannst; du meldest dich mit deinem gewohnten Smycles-Konto an. Das ist unabhängig vom Assistenten in Smycles.",
  "userSettings.claude.noSecret": "Es wird kein Client-Secret benötigt. Lass das Secret-Feld leer.",
  "userSettings.claude.title": "Claude verbinden",
  "userSettings.claude.urlLabel": "Server-URL",
  "userSettings.data.desc": "Exportiere deine Profil- und Grow-Daten als JSON-Datei (DSGVO Art. 20). Den Datentransfer findest du im Profil unter „Service\".",
  "userSettings.data.link": "Zum Datentransfer ↗",
  "userSettings.data.title": "Datenexport",
  "userSettings.email": "E-Mail",
  "userSettings.eyebrow": "Konto · Präferenzen",
  "userSettings.heading": "Einstellungen",
  "userSettings.identityTitle": "Identität",
  "userSettings.intro": "Verwalte dein Konto, Benachrichtigungen und Datenschutz.",
  "userSettings.language": "Sprache",
  "userSettings.languageHint": "Auch für die AI-Generierung.",
  "userSettings.name": "Name",
  "userSettings.sectionAccount": "Konto",
  "userSettings.sectionConnections": "Verknüpfungen",
  "userSettings.sectionData": "Daten & Export",
  "userSettings.tour.content.accountDesc": "Deine Identität (Name und E-Mail), die Oberflächensprache (auch für KI-Generierung genutzt) und ganz unten die Kontolöschung.",
  "userSettings.tour.content.dataDesc": "Exportiere dein Profil und deine Grow-Daten als JSON-Datei (DSGVO Art. 20). Der Button übergibt dich an den Datentransfer.",
  "userSettings.tour.content.title": "Der aktive Bereich",
  "userSettings.tour.label": "Einstellungen",
  "userSettings.tour.nav.desc": "Wechsle zwischen Konto (Identität, Sprache, Löschung) und Daten & Export (dein DSGVO-Datenexport).",
  "userSettings.tour.nav.title": "Die Bereiche",
  "userSettings.tour.summary": "Das sind deine Kontoeinstellungen: Identität, Oberflächensprache, Datenexport und Kontolöschung.",
  "whatsNew.v0_1": "Neu in Smycles: Verbinde die Claude Apps mit deinen Daten. Diese Einstellungsseite zeigt dir wie, mit MCP Endpoint, Client-ID und einer Schritt-für-Schritt-Anleitung.",
  "tobis.eyebrow": "Movie",
  "tobis.favorite.add": "Als Favorit merken",
  "tobis.favorite.remove": "Aus Favoriten entfernen",
  "tobis.title": "Datenquellen",
  "tobis.intro": "TVmaze liefert die Kandidaten und meldet, was sich geändert hat; die mitgelieferte IMDb-ID ist die Brücke zu OMDb, das Bewertungen, Stimmen und Einspielergebnisse ergänzt. Läufe arbeiten im Hintergrund, das Protokoll unten aktualisiert sich selbst.",
  "tobis.notConfigured": "Keine Datenbank konfiguriert. TOBIS_DATABASE_URL in der BFF-Umgebung setzen und die Migration ausführen.",
  "tobis.loadError": "Die Übersicht konnte nicht geladen werden.",
  "tobis.notice.started": "Lauf für {source} gestartet.",
  "tobis.notice.alreadyRunning": "Für {source} läuft bereits ein Lauf.",
  "tobis.notice.forbidden": "Dir fehlt die Berechtigung, einen Lauf zu starten.",
  "tobis.notice.failed": "Der Lauf konnte nicht gestartet werden.",
  "tobis.never": "nie",
  "tobis.status.running": "läuft",
  "tobis.status.ok": "ok",
  "tobis.status.partial": "teilweise",
  "tobis.status.failed": "fehlgeschlagen",
  "tobis.trigger": "Jetzt holen",
  "tobis.kpi.records": "Datensätze",
  "tobis.kpi.recordsSub": "aktuell, alle Quellen",
  "tobis.kpi.failing": "Quellen mit Fehler",
  "tobis.kpi.failingSub": "von {total} Quellen",
  "tobis.kpi.lastRun": "Letzter Lauf",
  "tobis.kpi.scheduled": "Zeitplan",
  "tobis.kpi.scheduledValue": "{active}/{total}",
  "tobis.kpi.scheduledSub": "Quellen mit Timer",
  "tobis.sources.title": "Quellen",
  "tobis.sources.counts": "{current} aktuell, {superseded} historisch · letzte Daten {moment}",
  "tobis.sources.lastRun": "letzter Lauf {status}, {seen} gesehen, {created} neu",
  "tobis.sources.failedHint": "Letzter Lauf fehlgeschlagen",
  "tobis.sources.scheduled": "geplant · nächster {when}",
  "tobis.sources.scheduledOff": "Timer eingerichtet, derzeit aus",
  "tobis.sources.storesAs": "zählt unter {target}",
  "tobis.sources.trend": "Zulauf-Verlauf",
  "tobis.schedule.today": "heute {time}",
  "tobis.schedule.tomorrow": "morgen {time}",
  "tobis.runs.title": "Lauf-Protokoll",
  "tobis.runs.empty": "Es ist noch kein Lauf gelaufen.",
  "tobis.runs.emptyFiltered": "Kein Lauf passt zu diesem Filter.",
  "tobis.runs.source": "Quelle",
  "tobis.runs.started": "Gestartet",
  "tobis.runs.status": "Status",
  "tobis.runs.seen": "Gesehen",
  "tobis.runs.new": "Neu",
  "tobis.runs.changed": "Geändert",
  "tobis.runs.filter.allSources": "Alle Quellen",
  "tobis.runs.filter.onlyFailedAria": "Nur fehlgeschlagene Läufe zeigen",
  "tobis.runs.filter.failed": "FEHLER",
  "tobis.runs.filter.all": "ALLE",
  "settings.sectionTobis": "Movie",
  "nav.tobisTitles": "Titel",
  "nav.tobisPeople": "Personen",
  "nav.tobisLab": "Labor",
  "nav.tobisMarket": "Markt",
  "tobis.titles.heading": "Titel",
  "tobis.titles.intro": "Alle bisher geladenen Titel, mit den Signalen, die eine Einkaufsentscheidung tragen. Die Stimmenzahl zählt so viel wie die Bewertung: eine hohe Note bei wenigen Stimmen sagt kaum etwas.",
  "tobis.titles.count": "{count} Titel",
  "tobis.titles.countOfTotal": "{count} von {total} Titeln geladen",
  "tobis.titles.loadMore": "Mehr laden",
  "tobis.titles.loadingMore": "L\u00e4dt \u2026",
  "tobis.titles.empty": "Noch keine Titel geladen.",
  "tobis.titles.emptyHint": "Starte einen Lauf unter Quellen.",
  "tobis.titles.emptyNoImage": "Kein Titel mit Titelbild passt zu diesen Filtern.",
  "tobis.titles.emptyNoImageHint": "Ohne den Titelbild-Filter gibt es Treffer.",
  "tobis.titles.removeImageFilter": "Titelbild-Filter entfernen",
  "tobis.titles.loading": "Durchsucht die Datenbank …",
  "tobis.titles.searchLabel": "Titel suchen",
  "tobis.titles.searchPlaceholder": "Nach Namen suchen",
  "tobis.view.grid": "Kacheln",
  "tobis.view.compact": "Kompakt",
  "tobis.people.heading": "Personen",
  "tobis.people.intro": "Schauspieler aus den geladenen Cast-Listen. Öffne einen Namen, um die Filmografie als Zeitachse zu sehen.",
  "tobis.people.count": "{count} Personen",
  "tobis.people.countOfTotal": "{count} von {total} Personen geladen",
  "tobis.people.empty": "Noch keine Personen geladen.",
  "tobis.people.loading": "Durchsuche die Datenbank…",
  "tobis.people.emptyHint": "Cast-Listen kommen mit einem TVmaze-Lauf.",
  "tobis.people.searchLabel": "Personen suchen",
  "tobis.people.searchPlaceholder": "Nach Namen suchen",
  "tobis.people.credits": "{count} Rollen",
  "tobis.person.back": "Zurück zu Personen",
  "tobis.person.birthday": "Geboren",
  "tobis.person.country": "Land",
  "tobis.person.timeline": "Filmografie",
  "tobis.person.timelineEmpty": "Noch keine Rollen erfasst.",
  "tobis.person.allYears": "Alle Jahre",
  "tobis.person.timelineFilterEmpty": "Keine Rollen für diesen Typ gefunden.",
  "tobis.person.liveCreditsHeading": "Auch bei TMDB gelistet",
  "tobis.person.liveCreditsHint": "Noch nicht in unserem eigenen Bestand - live von TMDB abgerufen, nicht durch das Erscheinungsdatum begrenzt.",
  "tobis.person.lowConfidence": "Diese Zusammenführung ist unsicher: die kombinierte Filmografie könnte zu zwei verschiedenen Personen mit demselben Namen gehören.",
  "tobis.person.asRole": "als {role}",
  "tobis.person.asSelf": "als sich selbst",
  "tobis.person.voice": "Sprechrolle",
  "tobis.person.sinceYear": "{year} bis heute",
  "tobis.person.yearRange": "{from} bis {to}",
  "tobis.card.rating": "{rating} ({votes})",
  "tobis.card.noRating": "keine Bewertung",
  "tobis.card.admissionsDe": "{count} DE",
  "tobis.person.moreRoles": " und {count} weitere Rollen",
  "tobis.title.back": "Zurück zu Titeln",
  "tobis.title.about": "Titel",
  "tobis.title.years": "Ausgestrahlt",
  "tobis.title.kind": "Art",
  "tobis.title.status": "Status",
  "tobis.title.runtime": "Laufzeit",
  "tobis.title.minutes": "{count} Min",
  "tobis.title.network": "Sender",
  "tobis.title.country": "Land",
  "tobis.title.imdb": "IMDb-ID",
  "tobis.title.originalTitle": "Originaltitel",
  "tobis.title.wikidata": "Wikidata",
  "tobis.title.eidr": "EIDR",
  "tobis.title.isan": "ISAN",
  "tobis.title.signals": "Signale",
  "tobis.title.rating": "IMDb",
  "tobis.title.votes": "Stimmen",
  "tobis.title.tmdbScore": "TMDB",
  "tobis.title.metascore": "Metascore",
  "tobis.title.wins": "Preise",
  "tobis.title.boxOffice": "Einspielergebnis (OMDb)",
  "tobis.title.budget": "Budget",
  "tobis.title.revenue": "Einspielergebnis (TMDB, weltweit)",
  "tobis.title.popularity": "Popularität",
  "tobis.title.script": "Drehbuch",
  "tobis.title.scriptValue": "{scenes} Szenen, {characters} Rollen ({source})",
  "tobis.title.admissionsDe": "Kinobesucher DE",
  "tobis.title.admissionsDeValue": "{count} ({source})",
  "tobis.title.admissionsMeasured": "gemessen, FFA",
  "tobis.title.admissionsEstimated": "geschätzt, LUMIERE",
  "tobis.title.admissionsTotal": "Kinobesucher gesamt",
  "tobis.title.admissionsTotalValue": "{count} (LUMIERE, {markets} Märkte)",
  "tobis.admissions.modalTitle": "Kinobesucher je Markt",
  "tobis.admissions.summary": "{markets, plural, one {# Markt} other {# Märkte}}, gezählt ab {year}",
  "tobis.admissions.ffaNote": "Die FFA-Hitliste weist für Deutschland {count} Besucher aus - eine veröffentlichte Abrechnung und damit die belastbarere Zahl für DE.",
  "tobis.admissions.disclaimer": "LUMIERE bezeichnet seine Zahlen selbst als Mindestwerte; die Abdeckung schwankt zwischen Märkten und Jahren, außerhalb Europas führt die Datenbank nur, was ihr gemeldet wurde. Besucher vor dem ersten Erhebungsjahr fehlen.",
  "tobis.admissions.source": "LUMIERE-Filmseite",
  "tobis.admissions.close": "Schließen",
  "tobis.dossier.title": "Alles, was wir haben",
  "tobis.dossier.loading": "Quellen werden gesammelt …",
  "tobis.dossier.loadError": "Die Quellen konnten nicht gelesen werden.",
  "tobis.dossier.empty": "Keine Quelle führt etwas zu diesem Eintrag.",
  "tobis.dossier.failed": "nicht lesbar",
  "tobis.dossier.fieldCount": "{count} Felder",
  "tobis.dossier.rowCount": "{count} Zeilen",
  "tobis.dossier.allEmpty": "Alle Felder sind leer.",
  "tobis.dossier.emptyFields": "{count} weitere Felder sind leer: {names}",
  "tobis.dossier.caveatTitleYear": "Verknüpft über Titel und Jahr (±1), nicht über eine ID - diese Quelle führt keine IMDb-ID, eine Fehlzuordnung ist also möglich.",
  "tobis.dossier.caveatName": "Verknüpft über den Klartextnamen, nicht über eine ID - Namensvetter landen im selben Satz.",
  "tobis.dossier.caveatTitleWriter": "Verknüpft über den Titel und, wo möglich, über Jahr oder Drehbuchautor. Die Spalte match_origin sagt, welche Stufe getragen hat: 'title+year' und 'title+writer' sind belegt, 'title' beruht allein auf dem Namen.",
  "tobis.title.cast": "Cast",
  "tobis.title.funding": "FFA-Förderung & Hitlisten-Einträge",
  "tobis.title.admissionsSeries": "Besucherverlauf (Deutschland)",
  "tobis.title.admissionsSeriesTotal": "Besucher, kumuliert",
  "tobis.title.admissionsSeriesPeriod": "Besucher im Zeitraum",
  "tobis.title.admissionsSeriesInPeriod": "{count} in diesem Zeitraum",
  "tobis.title.admissionsSeriesRank": "Platz {rank} der Hitliste",
  "tobis.title.admissionsSeriesNote": "FFA-Hitlisten. Das sind Ranglisten, keine Vollerhebung: Monate, in denen der Film nicht in den Top 100 stand, fehlen. Der kumulierte Wert stammt von der FFA und trägt diese Lücken korrekt über.",
  "tobis.title.revenueHistory": "Einspielergebnis im Verlauf (TMDB)",
  "tobis.title.revenueHistoryNote": "Weltweites Einspielergebnis, wie TMDB es zu unseren jeweiligen Abrufdaten führte. Die Abstände sind unregelmäßig, und der Wert ist nur so aktuell wie seine Pflege bei TMDB: eine Größenklasse, keine offizielle Abrechnung.",
  "tobis.title.revenueHistorySource": "Quelle: TMDB",
  "tobis.title.fundingAmount": "{amount} €",
  "tobis.title.hitlisteLegacyEntry": "{year} ({period})",
  "tobis.title.hitlisteLegacyAdmissions": "{count} Besucher",
  "tobis.title.fundingSource": "FFA-Förderübersicht (aktuelle Liste, nicht die archivierte Fassung)",
  "tobis.title.dfff": "DFFF-Förderprojekt",
  "tobis.title.dfff.regie": "Regie",
  "tobis.title.dfff.autor": "Autor",
  "tobis.title.dfff.darsteller": "Darsteller",
  "tobis.title.dfff.produzent": "Produzent",
  "tobis.title.dfff.koproduzenten": "Koproduzenten",
  "tobis.title.dfff.verleih": "Verleih",
  "tobis.title.dfff.produktionsdienstleister": "Produktionsdienstleister",
  "tobis.title.dfff.drehbeginn": "Drehbeginn",
  "tobis.title.dfff.foerderung": "DFFF-Förderung",
  "tobis.title.dfff.zuschuss": "DFFF-Förderung (Zuschuss)",
  "tobis.title.dfff.source": "DFFF-Projektliste (Quelle)",
  "tobis.title.castEmpty": "Kein Cast erfasst.",
  "tobis.title.castFilterEmpty": "Niemand in dieser Kategorie erfasst.",
  "tobis.title.castRoles": "{role} und {count} weitere",
  "tobis.person.titleCount": "Titel",
  "tobis.person.boxOffice": "Kassenerfolg",
  "tobis.person.boxOfficeValue": "{admissions} Besucher (DE), aus {withData} von {total} Titeln",
  "tobis.person.viewOnTmdb": "Auf TMDB ansehen",
  "tobis.person.awards": "Auszeichnungen",
  "tobis.person.awardWon": "Gewonnen",
  "tobis.person.awardNominated": "Nominiert",
  "tobis.person.awardsMore": "und {count} weitere",
  "tobis.person.scripts": "Drehbücher",
  "tobis.person.scriptScenes": "{count} Szenen",
  "tobis.sort.newest": "Neueste zuerst",
  "tobis.sort.relevance": "Relevanz",
  "tobis.sort.updated": "Zuletzt aktualisiert",
  "tobis.filter.reset": "Filter zurücksetzen",
  "tobis.filter.all": "Alle",
  "tobis.filter.movies": "Filme",
  "tobis.filter.series": "Serien",
  "tobis.filter.genres": "Genres",
  "tobis.filter.languages": "Sprachen",
  "tobis.filter.companies": "Produktionsfirma",
  "tobis.filter.distributors": "Verleiher",
  "tobis.filter.year": "Jahr",
  "tobis.filter.yearFrom": "Jahr von",
  "tobis.filter.yearTo": "Jahr bis",
  "tobis.filter.rangeSecondClick": "Zweiter Klick legt das Enddatum fest",
  "tobis.filter.ratingFrom": "Bewertung ab",
  "tobis.filter.votesFrom": "Stimmen ab",
  "tobis.filter.sources": "Quellen",
  "tobis.filter.admissionsFrom": "Besucher DE ab",
  "tobis.filter.runtimeFrom": "Laufzeit ab",
  "tobis.filter.runtimeValue": "{minutes} Min.",
  "tobis.filter.productionCountry": "Produktionsland",
  "tobis.filter.networks": "Sender",
  "tobis.filter.status": "Status",
  "tobis.filter.awardsWon": "Auszeichnung gewonnen",
  "tobis.filter.awardsWonWellKnown": "Bekannteste",
  "tobis.filter.hasScript": "Drehbuch",
  "tobis.filter.hasScriptLabel": "Vorhanden",
  "tobis.filter.hasImage": "Titelbild",
  "tobis.filter.hasImageLabel": "Nur mit Titelbild",
  "tobis.filter.identifiers": "Kennungen",
  "tobis.filter.identifierImdb": "IMDb-ID",
  "tobis.filter.identifierLumiere": "LUMIERE-ID",
  "tobis.filter.identifierIsan": "ISAN",
  "tobis.filter.identifierWikidata": "Wikidata",
  "tobis.filter.identifierEidr": "EIDR",
  "tobis.filter.tone": "Tonalität / Stoff",
  "tobis.filter.toneAny": "Beliebig",
  "tobis.filter.toneAll": "Alle",
  "tobis.filter.toneSearch": "z.B. Heist, Coming-of-Age …",
  "tobis.filter.toneLoading": "Suche…",
  "tobis.filter.countries": "Länder",
  "tobis.filter.age": "Alter",
  "tobis.filter.ageFrom": "Alter von",
  "tobis.filter.ageTo": "Alter bis",
  "tobis.filter.rolesFrom": "Rollen ab",
  "tobis.filter.source": "Quelle",
  "tobis.filter.sourceTvmaze": "TVmaze",
  "tobis.filter.sourceTmdb": "TMDB",
  "tobis.sort.roles": "Meiste Rollen",
  "tobis.sort.admissions": "Meiste Besucher",
  "tobis.filter.roleType": "Typ",
  "tobis.filter.roleTypeActing": "Schauspieler",
  "tobis.filter.roleTypeDirecting": "Regie",
  "tobis.filter.roleTypeProducing": "Produktion",
  "tobis.filter.roleTypeCrew": "Crew",
  "tobis.lab.heading": "Labor",
  "tobis.lab.intro": "Beschreibe deinen Pitch, dann befrage den Assistenten zu den gefundenen Vergleichstiteln, z.B. welche davon vergleichbar sind und was sie eingespielt haben.",
  "tobis.lab.resultHeading": "Vergleichstitel",
  "tobis.lab.empty": "Keine vergleichbaren Titel gefunden.",
  "tobis.lab.emptyHint": "Mehr Details zum Pitch ergänzen oder erneut versuchen.",
  "tobis.lab.step.pitch": "Pitch",
  "tobis.lab.step.result": "Ergebnis",
  "tobis.lab.pitchSubtitle": "Beschreibe links deinen Pitch, leite dann rechts Suchkriterien ab - Genres, Quellen und ein paar Keywords. Alles bleibt danach von Hand anpassbar.",
  "tobis.lab.resultSubtitle": "Ein Durchlauf holt den Kontext zu Regie, Drehbuchautor:in und Cast, wählt dann wirklich vergleichbare Titel aus und schätzt das Potenzial ein.",
  "tobis.lab.pitchTitleLabel": "Pitch-Titel",
  "tobis.lab.pitchTitlePlaceholder": "z.B. Arbeitstitel",
  "tobis.lab.pitchShortLabel": "Logline",
  "tobis.lab.pitchShortPlaceholder": "In einem Satz: was, für wen?",
  "tobis.lab.pitchDescriptionLabel": "Pitch",
  "tobis.lab.pitchDescriptionPlaceholder": "Tonalität, Genre, Cast-Ideen, Setting - was auch immer den Vergleich trägt.",
  "tobis.lab.charsCount": "{count} Zeichen",
  "tobis.lab.hintsLabel": "Tonalität",
  "tobis.lab.hintsPlaceholder": "Optional: Stimmung, Atmosphäre oder Stilhinweise, die der Pitch-Text allein nicht abdeckt.",
  "tobis.lab.requiredNote": "Pflicht",
  "tobis.lab.requiredHint": "Vor dem Vergleich noch ausfüllen: {missing}",
  "tobis.lab.criteria": "Kriterien",
  "tobis.lab.aiWorking": "Arbeitet…",
  "tobis.lab.aiDeriveHint": "Gleicht Wörter aus dem Pitch mit dem echten TMDB-Keyword-Katalog ab und ergänzt die Auswahl, ohne bereits gewählte Keywords zu ersetzen. Erkennt zusätzlich im Text genannte Vergleichsfilme. Jedes Keyword lässt sich danach entfernen.",
  "tobis.lab.aiFillFirstHint": "Erst Pitch oder Suchbegriffe ausfüllen.",
  "tobis.lab.aiGenerating": "Generiert…",
  "tobis.lab.generateWithAi": "Mit KI generieren",
  "tobis.lab.hint": "Hinweis",
  "tobis.lab.hintText": "Keywords rangieren nur den Themen-Pool mit TMDB-Abdeckung; Genres/Sprachen grenzen zusätzlich ein. Regie, Drehbuchautor:in und Cast bringen ihre eigene Filmografie als getrennten Kontext mit.",
  "tobis.lab.removeKeyword": "{keyword} entfernen",
  "tobis.lab.keywordsLabel": "Keywords",
  "tobis.lab.keywordAlreadyAdded": "übernommen",
  "tobis.lab.keywordAddPlaceholder": "Keyword hinzufügen, Enter zum Bestätigen",
  "tobis.lab.aiNoMatches": "Keine TMDB-Keywords zu diesem Text gefunden - versuch es mit gängigeren Genre-/Themenbegriffen.",
  "tobis.lab.pinnedFromText": "Im Pitch genannt",
  "tobis.lab.pinnedRemove": "{name} nicht mehr anpinnen",
  "tobis.lab.askPrompt": "Welche der Vergleichstitel, die du für meinen Pitch \"{title}\"{short} gefunden hast, sind die stärksten Treffer, und was haben sie eingespielt (Kinobesucher DE / Einspielergebnis)?",
  "tobis.lab.askAssistant": "Assistenten fragen",
  "tobis.lab.contextHeading": "Kontext für die KI",
  "tobis.lab.resultsHistoryHeading": "Frühere Ergebnisse",
  "tobis.lab.resultsHistoryOpen": "offen",
  "tobis.lab.resultsHistoryDelete": "Dieses Ergebnis löschen",
  "tobis.lab.resultsHistoryDeleteConfirmTitle": "Dieses Ergebnis löschen?",
  "tobis.lab.resultsHistoryDeleteConfirmMessage": "Das kann nicht rückgängig gemacht werden.",
  "tobis.card.keywordMatch": "{count} Keywords",
  "tobis.card.personMatch": "{count} Cast/Crew",
  "tobis.lab.untitledPitch": "unbenannt",
  "tobis.lab.compare": "Vergleichstitel finden",
  "tobis.lab.regenerate": "Erneut suchen",
  "tobis.lab.exportPdf": "Als PDF exportieren",
  "tobis.lab.exportPitchHeading": "Pitch",
  "tobis.lab.findComparablesHint": "Ein Modell-Aufruf holt den Filmografie-Kontext zu Regie/Drehbuchautor:in/Cast, rangiert einen Themen-Pool und schätzt das Potenzial ein.",
  "tobis.lab.findingComparables": "Wird gestartet…",
  "tobis.lab.loadingResult": "Wird geladen…",
  "tobis.lab.tobisAlgorithm.ariaLabel": "TOBIS Algorithmus",
  "tobis.lab.tobisAlgorithm.label": "TOBIS Algorithmus",
  "tobis.lab.tobisAlgorithm.infoAriaLabel": "Was der TOBIS Algorithmus macht",
  "tobis.lab.tobisAlgorithm.info": "Wendet Movies feste Vergleichsregeln an statt der Filter oben: nur Titel der letzten 12 Jahre mit deutschem Kinostart oder als Streaming-Original, 5 bis 15 statt bis zu 8 Vergleichsfilme. Ueberschreibt Jahr von/bis, solange aktiv.",
  "tobis.lab.directorLabel": "Regie",
  "tobis.lab.directorPlaceholder": "Nach Namen suchen",
  "tobis.lab.writerLabel": "Drehbuchautor:in",
  "tobis.lab.writerPlaceholder": "Nach Namen suchen",
  "tobis.lab.castLabel": "Cast",
  "tobis.lab.castPlaceholder": "Nach Namen suchen",
  "tobis.lab.personRemove": "{name} entfernen",
  "tobis.lab.personAdd": "{name} hinzufügen",
  "tobis.lab.personSearching": "Suche …",
  "tobis.lab.personAiToggle": "Text eingeben, KI ordnet zu",
  "tobis.lab.personAiPlaceholder": "z.B. Hauptrolle besetzt mit einer Schauspielerin wie Jane Doe, Regie führt John Smith",
  "tobis.lab.personAiButton": "Mit KI zuordnen",
  "tobis.lab.personAiNoMatches": "Noch keine Treffer.",
  "tobis.lab.expectedCurrencyLabel": "Währung",
  "tobis.lab.expectedBudgetLabel": "Budget",
  "tobis.lab.expectedBudgetPlaceholder": "Optional",
  "tobis.lab.expectedRevenueLabel": "Erwartetes Einspielergebnis (weltweit)",
  "tobis.lab.expectedRevenuePlaceholder": "Optional",
  "tobis.lab.scriptLabel": "Skript",
  "tobis.lab.scriptUploadPrompt": "Skript-PDF hochladen (optional)",
  "tobis.lab.scriptRemove": "Skript entfernen",
  "tobis.lab.valuation.noComparablesResolved": "Für diesen Lauf ließen sich keine Vergleichstitel zuordnen.",
  "tobis.lab.valuation.heading": "Geschätzte Kaufpreisgrenze",
  "tobis.lab.valuation.viable": "Zu diesem Preis tragfähig",
  "tobis.lab.valuation.notViable": "Zu diesem Preis nicht tragfähig",
  "tobis.lab.valuation.estimateFailed": "Konnte nicht berechnet werden - erneut versuchen.",
  "tobis.lab.valuation.comparablesUsed": "{count, plural, one {# Vergleichstitel mit DE-Besucherzahl} other {# Vergleichstitel mit DE-Besucherzahl}}",
  "tobis.lab.valuation.avgAdmissions": "Ø DE-Besucher",
  "tobis.lab.valuation.avgRevenue": "Ø Erlös (weltweit)",
  "tobis.lab.valuation.avgBudget": "Ø Budget",
  "tobis.lab.valuation.yourRevenue": "Dein erwartetes Einspielergebnis",
  "tobis.lab.valuation.yourBudget": "Dein Budget",
  "tobis.lab.valuation.compRevenue": "{amount} Erlös",
  "tobis.lab.valuation.compBudget": "{amount} Budget",
  "tobis.lab.valuation.cinemaShare": "Verleihmiete",
  "tobis.lab.valuation.homeEntertainment": "Home Entertainment",
  "tobis.lab.valuation.payTv": "Pay-TV",
  "tobis.lab.valuation.freeTv": "Free-TV",
  "tobis.lab.valuation.distributionSubsidy": "Verleihförderung",
  "tobis.lab.valuation.paBudget": "P&A-Budget",
  "tobis.lab.valuation.internalCost": "Interne Kosten",
  "tobis.lab.valuation.margin": "Zielmarge (10 %)",
  "tobis.lab.valuation.distributionHeading": "Streuung über die Vergleichsfilme",
  "tobis.lab.valuation.distributionTooFew": "Weniger als zwei Vergleichsfilme mit DE-Besucherzahl - für eine Verteilung nicht genug.",
  "tobis.lab.valuation.distributionRevenue": "Umsatz",
  "tobis.lab.valuation.distributionPrice": "Kaufpreis",
  "tobis.lab.valuation.distributionMostLikely": "Wahrscheinlichstes Szenario",
  "tobis.lab.valuation.distributionCostNote": "Aufwände bleiben bei jedem Vergleichsfilm konstant bei {amount} - das ist eine manuelle Eingabe für dieses Projekt, nicht je Titel belegt, deshalb keine eigene Kurve.",
  "tobis.lab.valuation.distributionMeanHint": "{count} Vergleichsfilme mit DE-Besucherzahl - der Gipfel markiert den Schnitt, kein garantiertes Ergebnis.",
  "tobis.lab.valuation.manualHint": "Für diese sechs Posten gibt es keine Quelle im Bestand: von Hand eintragen, oder bei 0 lassen, um den Kanal auszuschließen.",
  "tobis.lab.valuation.comparablesHeading": "Berücksichtigte Vergleichstitel",
  "tobis.lab.valuation.directorCredit": "Regie: {names}",
  "tobis.lab.valuation.writerCredit": "Drehbuch: {names}",
  "tobis.lab.valuation.streamingOriginal": "Streaming Original",
  "tobis.lab.valuation.noAdmissions": "keine DE-Besucherzahl",
  "tobis.lab.valuation.included": "✓ Berücksichtigt - entfernen",
  "tobis.lab.valuation.excluded": "Berücksichtigen",
  "tobis.lab.valuation.excludedPrintNote": "(ausgeschlossen)",
  "tobis.lab.valuation.sourceTitle": "Quelle",
  "tobis.lab.valuation.origin.measured": "gemessen",
  "tobis.lab.valuation.origin.derived": "abgeleitet",
  "tobis.lab.valuation.origin.estimated": "geschätzt",
  "tobis.lab.valuation.origin.manual": "manuell",
  "tobis.lab.valuation.assessmentHeading": "KI-Einschätzung",
  "tobis.lab.valuation.benchmarkInfo": "Was diese Durchschnitte bedeuten",
  "tobis.lab.valuation.comparablesUsedInfo": "Welche Vergleichstitel die Rechnung nutzt",
  "tobis.lab.valuation.contribution.calculating": "Wird gerade gerechnet …",
  "tobis.lab.valuation.contribution.excluded": "Aktuell ausgeschlossen, wirkt nicht auf die Grenze.",
  "tobis.lab.valuation.contribution.noAdmissions": "Zählt nur als Kontext: ohne deutsche Besucherzahl und Startjahr gibt es keinen Kinoumsatz abzuleiten, dieser Titel bewegt die Grenze also nicht.",
  "tobis.lab.valuation.contribution.own": "{admissions} DE-Besucher ({year}). Allein mit diesem Titel ergäbe die Rechnung eine Grenze von {ceiling}; die Zahl oben ist der Schnitt über alle einbezogenen Titel.",
  "tobis.lab.valuation.formula.benchmark": "Schnitt über die {count} berücksichtigten Vergleichstitel, jeweils über die Titel, die den Wert überhaupt tragen. Erlös und Budget kommen von TMDB, weltweit, in Dollar: sie ordnen die Größenordnung ein und gehen bewusst NICHT in die Kaufpreisgrenze ein, die immer nur den deutschen Kinoanteil rechnet. Deshalb kann ein Titel mit 190 Mio. $ weltweit bei einer Grenze von zwei Millionen Euro landen.",
  "tobis.lab.valuation.formula.ceiling": "Erlöse {revenue} − Kosten {cost} = Zwischensumme {subtotal}, minus Zielmarge {margin}. Was bleibt, darf der Titel höchstens kosten. Modell {version}.",
  "tobis.lab.valuation.formula.cinemaShare": "Je Vergleichsfilm: DE-Besucher × Ø Ticketpreis seines Startjahrs = Kinoumsatz brutto. Davon {vat} MwSt heraus, dann {ffa} FFA-Abgabe und {gema} GEMA/GVL vom Netto; {share} des Rests ist die Verleihmiete. Angezeigt ist der Schnitt über die {count} Vergleichsfilme mit deutscher Besucherzahl.",
  "tobis.lab.valuation.formula.comparablesUsed": "Von {considered} berücksichtigten Titeln tragen {used} sowohl eine deutsche Besucherzahl als auch ein Startjahr. Nur daraus lässt sich ein Kinoumsatz ableiten; die übrigen bleiben als Kontext in der Liste und bewegen die Zahl nicht.",
  "tobis.lab.valuation.formula.exampleAverage": "Genauso für {others, plural, one {den anderen Vergleichsfilm} other {die anderen # Vergleichsfilme}}; der Schnitt dieser {count} Beträge ist die {total} oben (Spanne {min} bis {max}).",
  "tobis.lab.valuation.formula.exampleHeading": "Beispielrechnung: {name}",
  "tobis.lab.valuation.formula.step.gross": "{admissions} Besucher × {price} ({priceYear}) = {gross} brutto",
  "tobis.lab.valuation.formula.step.levies": "− {ffa} FFA − {gema} GEMA/GVL = {afterLevies}",
  "tobis.lab.valuation.formula.step.net": "− {vat} MwSt = {net} netto",
  "tobis.lab.valuation.formula.step.priceSubstitute": "{year}, nächstliegender erfasster Jahrgang: {fromYear}",
  "tobis.lab.valuation.formula.step.share": "× {share} Verleihanteil = {result}",
  "tobis.lab.valuation.formula.manual": "Für diesen Posten gibt es keine Quelle im Bestand: der Wert ist von Hand eingetragen und geht unverändert in die Rechnung ein. Bei 0 € bleibt der Kanal ausgeschlossen.",
  "tobis.lab.valuation.formula.margin": "{rate} auf P&A-Budget + interne Kosten + Zwischensumme ({base}). Diese Summe entspricht dem Gesamterlös; die Form folgt der Fach-Anleitung, damit sie gegen das Dokument prüfbar bleibt.",
  "tobis.lab.valuation.formulaTitle": "Rechenweg",
  "tobis.lab.valuation.whyNoReason": "Das Modell hat für diesen Titel keine Begründung geliefert. Er kam entweder als im Pitch genannter Titel oder aus dem Themen-Pool herein.",
  "tobis.lab.valuation.whyThisTitle": "Warum dieser Titel?",
  "tobis.lab.landing.intro": "Jede bisher begonnene Vergleichsfilm-Untersuchung. Setze eine fort, oder starte eine neue.",
  "tobis.lab.landing.yourSessions": "Deine Untersuchungen",
  "tobis.lab.landing.newSession": "Neue Untersuchung",
  "tobis.lab.landing.creating": "Wird angelegt…",
  "tobis.lab.landing.empty": "Noch keine Untersuchungen",
  "tobis.lab.landing.emptyHint": "Starte eine mit dem Button oben.",
  "tobis.lab.landing.updatedAt": "Aktualisiert {when}",
  "tobis.lab.session.invalidUrl": "Ungültige Labor-URL.",
  "tobis.lab.session.loading": "Lädt…",
  "tobis.lab.session.notFound": "Untersuchung nicht gefunden.",
  "tobis.lab.session.backToLanding": "Zurück zum Labor",
  "tobis.lab.landing.delete": "Löschen",
  "tobis.lab.landing.deleteAria": "{label} löschen",
  "tobis.lab.landing.confirmDeleteTitle": "„{label}“ löschen?",
  "tobis.lab.landing.confirmDeleteMessage": "Die Untersuchung und ihre Kriterien werden endgültig entfernt.",
  "tobis.market.title": "Markt",
  "tobis.market.intro": "Deutscher Kino- und Streaming-Markt, ohne Titelbezug: der Boden, auf dem die Bewertungszahlen stehen.",
  "tobis.market.loadError": "Die Marktübersicht konnte nicht geladen werden.",
  "tobis.market.loading": "Marktdaten werden geladen …",
  "tobis.market.cinema.title": "FFA: Kino",
  "tobis.market.admissions": "Besucher",
  "tobis.market.revenue": "Kinoumsatz",
  "tobis.market.yoy": "{change} ggü. {year}",
  "tobis.market.yoyPoints": "{change} PP ggü. {year}",
  "tobis.market.marketShareLatest": "Marktanteil deutscher Filme ({year})",
  "tobis.market.homevideoLatest": "Home Video ({year})",
  "tobis.market.admissionsByYear": "Besucher je Jahr, {from}–{to}",
  "tobis.market.revenueByYear": "Kinoumsatz je Jahr, {from}–{to}",
  "tobis.market.marketShare.title": "Marktanteil deutscher Filme",
  "tobis.market.marketShare": "Marktanteil deutscher Filme",
  "tobis.market.germanFilmCounts": "Deutsche Filmstarts nach Kategorie, {from}–{to}",
  "tobis.market.spielfilme": "Spielfilme",
  "tobis.market.dokumentarfilme": "Dokumentarfilme",
  "tobis.market.koproduktionen": "Koproduktionen",
  "tobis.market.topFilms": "Beliebteste Filme",
  "tobis.market.multiplex.title": "Multiplex-Segment im Zeitverlauf",
  "tobis.market.monthly.title": "Besucher nach Monat, {from}–{to}",
  "tobis.market.correlation.title": "Besucher, Umsatz & Ticketpreis, indexiert",
  "tobis.market.correlation.note": "Besucher (Millionen), Umsatz (€) und Ticketpreis (€) haben zu unterschiedliche Skalen: ein Diagramm mit zwei Y-Achsen würde die tatsächliche relative Entwicklung verzerren. Deshalb indexiert auf 100 im Jahr {baseYear}, gleicher Startpunkt, vergleichbares Wachstum.",
  "tobis.market.infrastructure.title": "FFA-Kino-Infrastruktur im Zeitverlauf",
  "tobis.market.infrastructure.methodBreak2025": "2025 ist bei Standorten, Leinwänden und Sitzplätzen nicht direkt mit den Vorjahren vergleichbar: das Quell-PDF hat die Zählweise des Kinobestands geändert (ab 2025 ohne Autokinos, Open Airs, Filmfestivals und Mitspiel-Betriebe). Der Eintrittspreis ist davon nicht betroffen.",
  "tobis.market.venuesByYear": "Standorte je Jahr",
  "tobis.market.venues": "Standorte",
  "tobis.market.screensByYear": "Leinwände je Jahr",
  "tobis.market.screens": "Leinwände",
  "tobis.market.seatsByYear": "Sitzplätze je Jahr",
  "tobis.market.seats": "Sitzplätze",
  "tobis.market.ticketPriceByYear": "Durchschnittlicher Eintrittspreis je Jahr",
  "tobis.market.ticketPrice": "Eintrittspreis",
  "tobis.market.states.title": "Besucher nach Bundesland, Deutschland {year}",
  "tobis.market.topOverTime": "Top 6 nach {metric}, im Zeitverlauf",
  "tobis.market.venuesByState.title": "Standorte nach Bundesland, Deutschland {year}",
  "tobis.market.screeningVenues": "Spielstätten",
  "tobis.market.ticketPriceByState.title": "Durchschnittlicher Eintrittspreis nach Bundesland, Deutschland {year}",
  "tobis.market.cities.title": "Top-Städte nach Tickets, Deutschland {year}",
  "tobis.market.venues.title": "Tickets nach Spielstätte, Deutschland 2025",
  "tobis.market.kpiExplorer.title": "FFA-Jahreskennzahlen ({count} Kennzahlen)",
  "tobis.market.kpiExplorer.note": "Selbst aus den FFA-Original-PDFs extrahiert, gegen bekannte Referenzwerte verifiziert.",
  "tobis.market.kpiExplorer.group.admissions": "Besucher / Tickets",
  "tobis.market.kpiExplorer.group.revenue": "Kinoumsatz / Eintrittspreis",
  "tobis.market.kpiExplorer.group.marketShare": "Marktanteil",
  "tobis.market.kpiExplorer.group.population": "Bevölkerung",
  "tobis.market.kpiExplorer.group.infrastructure": "Spielstätten, Leinwände & Sitzplätze",
  "tobis.market.kpiExplorer.searchLabel": "Kennzahlen durchsuchen",
  "tobis.market.kpiExplorer.searchPlaceholder": "z.B. Eintrittspreis, Sitzplätze…",
  "tobis.market.kpiExplorer.empty": "Keine passende Kennzahl.",
  "tobis.market.kpiExplorer.viewGrid": "Kacheln",
  "tobis.market.kpiExplorer.viewOverlay": "Überlagert (indexiert)",
  "tobis.market.kpiExplorer.overlayNote": "Indexiert auf 100 im Jahr {baseYear}, dem ersten Jahr mit einem Wert für jede gewählte Kennzahl.",
  "tobis.market.kpiExplorer.overlayEmpty": "Kein gemeinsames Jahr mit einem Wert für jede gewählte Kennzahl.",
  "tobis.market.byForm": "Nach Kinoform (regulär, Multiplex, Autokino…)",
  "tobis.market.bySize": "Nach Leinwandzahl je Standort",
  "tobis.market.byPlaceSize": "Nach Einwohnerzahl des Orts",
  "tobis.market.bySonderform": "Nach Sonderform, {year}",
  "tobis.market.sonderformenOverTime": "Sonderformen im Zeitverlauf",
  "tobis.market.tickets": "Tickets",
  "tobis.market.homevideo.title": "Home Entertainment (Marktaggregat)",
  "tobis.market.homevideo.note": "Marktweiter Umsatz, nicht je Titel, als Quote gegen ein vergleichbares Kinoergebnis nutzen.",
  "tobis.market.homevideo.confidenceNote": "1990–2015 von Balkendiagramm-Beschriftungen in den Quell-PDFs abgelesen (geringere Sicherheit, gegen Überlappungsjahre geprüft), ab 2016 direkt aus dem Berichtstext.",
  "tobis.market.homevideo.segments": "Nach Kauf, Leihe & Abonnement",
  "tobis.market.homevideo.kaufvideos": "Kauf (DVD/Blu-ray/EST)",
  "tobis.market.homevideo.leihvideos": "Leihe (DVD/Blu-ray/TVoD)",
  "tobis.market.homevideo.svod": "Abonnement (SVoD)",
  "tobis.market.homevideo.consumers": "Konsumenten, 2017–2025",
  "tobis.market.homevideo.sankey": "Umsatzaufschlüsselung, {year}",
  "tobis.market.homevideo.sankeyNote": "Zwei Jahre gezeigt, wo sie sich unterscheiden: das detailreichste (Leihe noch nach Format aufgeschlüsselt) und das aktuellste verfügbare (Leihe DVD/Blu-ray ist seit 2023 fast verschwunden, TVoD wurde stattdessen ein eigenständiges Segment).",
  "tobis.market.homevideo.metric.kaeufer": "Käufer/Leiher/Abonnenten",
  "tobis.market.homevideo.metric.reichweite": "Reichweite (vs. Bevölkerung)",
  "tobis.market.homevideo.metric.ausgaben": "Ausgaben pro Person",
  "tobis.market.homevideo.metric.intensitaet": "Käufe/Leihvorgänge pro Person",
  "tobis.market.homevideo.genres": "Genre-Mix (Umsatzanteil, alle Formate)",
  "tobis.market.homevideo.genresNote": "Von gestapelten Balkendiagrammen abgelesen (chart estimate). Top 4 Genres einzeln, der Rest als \"Sonstige\" gebündelt: eine vollständige 10-Genre-Aufschlüsselung bräuchte eine Farbpalette, die die Monochrom-Konvention dieses Dashboards brechen würde.",
  "tobis.market.homevideo.genre.action": "Action",
  "tobis.market.homevideo.genre.kinder": "Kinder",
  "tobis.market.homevideo.genre.drama": "Drama",
  "tobis.market.homevideo.genre.komoedie": "Komödie",
  "tobis.market.homevideo.genre.sonstige": "Sonstige",
  "tobis.market.konsumklima.title": "Konsumklima (GfK), 2016 / 2023–2025",
  "tobis.market.konsumklima.note": "Indexpunkt-Veränderung gegenüber dem Vormonat, wie in der Kennzahlenbox des Berichts abgedruckt. Nur 4 von 15 Berichtsjahren drucken diese Box mit Zahlen; die übrigen behandeln das Thema entweder nicht, zeigen nur Icons ohne Zahl, oder nur den Gesamtindex-Zeitverlauf.",
  "tobis.market.konsumklima.metric.konjunktur": "Konjunkturerwartung",
  "tobis.market.konsumklima.metric.einkommen": "Einkommenserwartung",
  "tobis.market.konsumklima.metric.anschaffung": "Anschaffungsneigung",
  "tobis.market.konsumklima.metric.preis": "Preiserwartung",
  "tobis.market.konsumklima.metric.sparen": "Sparneigung",
  "tobis.market.streaming.title": "AGF: Streaming-Reichweite",
  "tobis.market.streaming.empty": "Keine Daten für diese Zielgruppe.",
  "tobis.market.streaming.metric": "Kennzahl: Sehdauer in Minuten pro Tag, gemittelt über die gesamte Zielgruppe, auch über Personen, die die Plattform gar nicht nutzen. Nicht die Nutzungsintensität der tatsächlichen Nutzer.",
  "tobis.market.streaming.sources": "Quellberichte:",
  "tobis.market.tv.title": "AGF: Fernsehen",
  "tobis.market.tv.note": "Die Quellseite führt kein Archiv, aber jeder gesammelte Lauf bleibt erhalten: die Tages-Top-10 lässt sich zwischen den erfassten Tagen umschalten (Lücken sind Tage ohne Lauf). Die Monatsmarktanteile zeigen weiterhin nur den letzten Monat.",
  "tobis.market.tv.audienceTotal": "Alle Zuschauer",
  "tobis.market.tv.audienceE1449": "Zuschauer 14–49",
  "tobis.market.tv.dailyTop10": "Tages-Top-10",
  "tobis.market.tv.byDay": "Top-10-Publikum je Tag, aufgeteilt nach Sender",
  "tobis.market.tv.viewers": "Zuschauer (Mio.)",
  "tobis.market.tv.empty": "Noch keine Daten.",
  "tobis.market.tv.rank": "#",
  "tobis.market.tv.channel": "Sender",
  "tobis.market.tv.programme": "Sendung",
  "tobis.market.tv.viewers": "Zuschauer (Mio.)",
  "tobis.market.tv.monthlyMarketShare": "Monatsmarktanteil, {period}",
  "tobis.market.sources.document": "Quelldokument",
  "tobis.market.sources.document2025": "Quelldokument, 2021–2025",
  "tobis.market.sources.kinoergebnisse": "Quelldokumente:",
  "tobis.market.sources.document2025": "Quelldokument, 2021–2025",
  "tobis.market.sources.videoergebnisse": "Quelldokumente:",
  "tobis.boxOfficeCheck.title": "Box-Office-Plausibilitätscheck",
  "tobis.boxOfficeCheck.intro": "model.match_tconst matcht Boxoffice-Zeilen ohne IMDb-ID per Titel und Jahr, mit einer Toleranz von +/-1 Jahr. Das kann theoretisch zwei Filme mit demselben Titel in unterschiedlichen Jahren verwechseln (z. B. Remakes). Bislang wurde kein solcher Fall gefunden, aber das Inlands-Einspiel kann nie höher sein als das Welt-Einspiel, ein Treffer hier ist also ein starkes Indiz auf eine falsche Zuordnung.",
  "tobis.boxOfficeCheck.run": "Check ausführen",
  "tobis.boxOfficeCheck.running": "Prüfe…",
  "tobis.boxOfficeCheck.forbidden": "Dir fehlt die Berechtigung, diesen Check auszuführen.",
  "tobis.boxOfficeCheck.failed": "Der Check konnte nicht ausgeführt werden.",
  "tobis.boxOfficeCheck.clean": "Keine Anomalien in {total} geprüften Zeilen gefunden.",
  "tobis.boxOfficeCheck.found": "{anomalies} von {total} geprüften Zeilen haben ein höheres Inlands- als Welt-Einspiel.",
  "tobis.boxOfficeCheck.column.title": "Titel",
  "tobis.boxOfficeCheck.column.year": "Jahr",
  "tobis.boxOfficeCheck.column.domestic": "Inland",
  "tobis.boxOfficeCheck.column.worldwide": "Welt"
}
